/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-debugger */
/* eslint-disable no-unreachable */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable default-param-last */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-use-before-define */
/* eslint-disable no-useless-escape */
/* eslint-disable no-else-return */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-lonely-if */
import Icon, {
  CheckOutlined,
  InfoCircleOutlined,
  LeftOutlined,
  SmileOutlined,
} from "@ant-design/icons";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  Alert,
  Avatar,
  Badge,
  Button,
  Col,
  Collapse,
  Drawer,
  Dropdown,
  Menu,
  Row,
  Select,
  Skeleton,
  Spin,
  Checkbox,
  Modal,
  Radio,
  Table,
  Tooltip,
  message,
  Form,
} from "antd";
import dayjs from "dayjs";
import { debounce, isEmpty, isUndefined, sumBy, uniq, uniqBy } from "lodash";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "@reach/router";
import EngagedAiLogo from "../../static/EngagedAi_trans_bg.svg";
import { UserContext } from "../amplify/authenticator-provider";
import { BottomActions } from "../components/engagements/activityCenter/BottomActions";
import { InputAreaWrapper as InputArea } from "../components/engagements/activityCenter/InputArea";
import MessagesGroup from "../components/engagements/activityCenter/MessagesGroup";
import EmptyConversationState from "../components/engagements/activityCenter/EmptyConversationState";
import PaginationLoader from "../components/engagements/activityCenter/PaginationLoader";
import useChatScroll from "../hooks/useChatScroll";
import useMessageForwardOptions from "../hooks/useMessageForwardOptions";
import TopToolbarJsx from "../components/engagements/activityCenter/TopToolbarJsx";
import AppointmentModal from "../components/engagements/activityCenter/appointments/appointmentModal";
import Attachments from "../components/engagements/activityCenter/attachments";
import ConversationSummary from "../components/engagements/activityCenter/conversationSummary";
import "../components/engagements/activityCenter/editor.css";
import {
  handleFiles,
  leadStatus,
  pageSize,
} from "../components/engagements/activityCenter/engagementActivity";
import {
  EMAIL_ATTACHMENT_LIMITS,
  INPUT_TAB_HEIGHT,
  LeadStatus,
  ShowConsent,
  buildEmailAttachmentsPayload,
  isConsentStatusEnable,
  leadOwners,
  vehicles,
} from "../components/engagements/activityCenter/engagementHelpers";
import LeadListContainer from "../components/engagements/activityCenter/leadListContainer";
import LeadProfile from "../components/engagements/activityCenter/leadProfile";
import ViewScheduledMessagesPopup from "../components/engagements/activityCenter/viewScheduledMessagesPopup";
import TemplateDrawer from "../components/engagements/schedual/templateDrawer";
import UserProfile from "../components/userSettings/userProfile/userProfile";
import {
  NotificationsDropdown,
  convertToInitials,
  profileMenu,
} from "../components/layoutComponent/layoutHelpers";
import {
  BROADCAST_UNREAD_COUNT,
  CREATE_LEAD_EMAIL,
  CREATE_LEAD_PHONE,
  CREATE_MESSAGE,
  CREATE_MMS,
  CREATE_SCHEDULED_MESSAGE,
  RETRY_MESSAGE_SEND,
  TRANSLATE_MESSAGE,
  UPDATE_LEAD,
  UPDATE_LEAD_CONSENT,
  UPDATE_LEAD_CONVERSATION_STATUS,
  UPDATE_LEAD_EMAIL,
  UPDATE_LEAD_PHONE,
  UPDATE_TRANSLATION_SETTINGS,
  CREATE_LEAD,
  CREATE_EMAIL,
} from "../graphql/mutation";
import {
  EDIT_LEAD,
  GET_ALL_TEAMS,
  GET_ALL_USERS_ACTIVITY_CENTER,
  GET_CAMPAIGN_BY_LEAD,
  GET_CAMPAIGN_LIST_FILTERS,
  GET_COMPANY_AFTER_MESSAGE_CONSENT_TEMPLATE,
  GET_COMPANY_CONSENT,
  GET_COMPANY_CONSENT_TEMPLATES,
  GET_CONSENT_TEMPLATE,
  GET_CRM_LEAD_STATUS,
  GET_DETECTED_LANGUAGE,
  GET_EXTENSION_LEAD_SOURCES,
  GET_EXTENSION_LIST_ACTIVITY_CENTER,
  GET_LEAD_ACTIVE_APPOINTMENT,
  GET_LEAD_DETAIL_ACTIVITY_CENTER_V2,
  GET_LEAD_DETAIL_CLICK,
  GET_MESSAGES_V2,
  GET_SCHEDULED_MESSAGES_FOR_LEAD,
  GET_SOCIAL_REVIEW_SETTINGS,
  GET_SUPPORTED_LANGUAGES_BY_LOCATION,
  GET_TRANSLATION_SETTINGS,
  GET_POTENTIAL_LEADS_BY_ID,
  GET_LEADS_BY_PHONE,
} from "../graphql/query";
import { useInterval } from "../hooks";
import { useGetScreenDimensions } from "../hooks/personalizedHooks";
import useCrmIntegration from "../hooks/useCrmIntegration";
import useLang from "../hooks/useLang";
import useCrm from "../hooks/useCrm";
import usePrevious from "../hooks/usePrevious";
import { isPlatformAdmin } from "../hooks/utils";
import AddUserIcon from "../icons/js/AddUserIcon";
import CollapseIcon from "../icons/js/CollapseIcon";
import ExpandIcon from "../icons/js/ExpandIcon";
import NotificationIcon from "../icons/js/NotificationIcon";
import { OptionContainer } from "../library/activityComponents";
import {
  AccessPermissionAction,
  HIDDEN_MESSAGE_CONTENT_TYPES,
  MESSAGE_CONTAINER_CLASSNAME,
  MESSAGE_CONTENT_TYPES,
  URL_PARAM_MESSAGE_ID,
  QUERY_VAR_TARGET_MESSAGE_ID,
} from "../library/constants";
import { CRM_TYPES } from "../constants/crmConstants";
import {
  checkAccessPermission,
  closeDialog,
  isAllLocationSelected,
  openDialog,
  showConfirmationModal,
} from "../library/helpers";
import { formatBytes, groupMessagesByDate } from "../library/utils";
import {
  getCacheApi,
  pushActiveLeadFilter,
  resetApiCacheStore,
  setAfterMessageText,
  setAllCampaigns,
  setCompanyConsentTemplate,
  setConsentTemplateSlice,
  setCrmLeadStatus,
  setIsuserTeamLeader,
  setLeadSources,
  setSelectedLeadPhone,
  setUserList,
} from "../redux/slices/apiCacheSlice";
import { getMobileView } from "../redux/slices/isMobile";
import {
  addMessage,
  addQuickFilter,
  getUpdatedCountInfo,
  resetLeadFilters,
  setLeadsRedux,
  setScheduledMessages,
  setSearchRedux,
  setSelectedLeadIdRedux,
  setSelectedLeadRedux,
  updateLeadInList,
  resetTranlatedContent,
  setUserFilters,
  setCampaignFilters,
  changeMessageOpportunity,
  resetSelectedLeadMessages,
  QUICK_FILTERS,
} from "../redux/slices/leadSlice";
import { getLocationId, setLocationIdSlice } from "../redux/slices/locationSlice";
import {
  setTextAiResponseHistoryId,
  setEmailAiResponseHistoryId,
  getTextAiResponseHistoryId,
  getEmailAiResponseHistoryId,
} from "../redux/slices/aiSlice";
import { AttachmentSource } from "../library/messageSourceEnums";
import { toTitleCase } from "../utils";
import AntdIconV4 from "../utils/antdIcon";
import { dynamicSort } from "../utils/dataSorting";
import { s3uploader } from "../utils/awsS3MediaUploader";
import { generateVideoThumbnails } from "../utils/videoThumbnailGenerator";
import { generateImageThumbnail } from "../utils/mediaUtilities";
import { getActiveSupportedLanguages } from "../utils/languages";
import { getLeadToPhone } from "../utils/phoneHelpers";
import ResizableContainer from "../components/commonComponents/ResizableContainer";
import { prepareOpportunityList, resolveLeadOpportunityId } from "../helpers/opportunityHelper";
import { setTasks } from "../redux/slices/taskSlice";
import { setNotesRedux } from "../redux/slices/notesSlice";

let page = 1;
let lastLead = "";
let isSkipFilter = false;

const parseUserList = async (users, userIdMap, setUserIdMap) => {
  let obj = userIdMap;
  if (users.length > 0) {
    users.forEach(el => {
      const id = el?.id;
      obj = {
        ...obj,
        [id]: el?.fullName || "Otto",
      };
    });
    setUserIdMap({ ...obj });
  }
};

const BrowserExtensionPopup = props => {
  const {
    notificationsCount,
    location,
    locationChatBot,
    lead = {},
    currentLocation,
    Role,
    location2,
    setLocation,
    getActiveCrmIntegration,
    setchanged,
    changed,
    gotLocationId = true,
    setPhone = () => {},
    setShowSupportModal,
    deleteFcmDevice,
    refetchNotificationsCount,
  } = props;

  const {
    user,
    setUser,
    modal,
    notificationData,
    isUserIsBeingSet,
    persistor,
    apolloPersistor,
    authData,
  } = useContext(UserContext);

  const [lang] = useLang();
  const { getOpprDetails } = useCrm();
  const appRef = useRef();
  const dispatch = useDispatch();

  // Get message forward options to determine if UserHoverCard should be shown
  const { hasAnyForwardOption } = useMessageForwardOptions();
  const isPlatformAdminUser = isPlatformAdmin(authData);
  const handleDispatch = locationId => {
    setSearchKey("");
    setQueryString("");
    setSelectedLead({});
    setLeadList([]);
    setLeadIdClick("");
    setPhone("");
    setIsClickonPotentialDuplicate("");
    localStorage.removeItem("clickLeadId");
    localStorage.removeItem("changedLocationLeadId");
    setVariables({ ...variables, dsEventId: "", dsEntityId: "", page: 1, search: "" });
    setSearch("");
    setEventId("");
    setEntityId("");
    setchanged(!changed);
    window.parent.postMessage(searchKey, "*");
    dispatch(setLocationIdSlice({ locationId: locationId }));
  };

  const text = useRef("");
  const emailTextRef = useRef("");
  const messagesEndRef = useRef(null);
  const msgContainerRef = useRef(null);
  // Always-current mirror of `selectedLead?.id`. Lazy-query onCompleted
  // callbacks fire asynchronously with closure-captured state, so late
  // responses from a previous lead can overwrite a newer selection. Each
  // onCompleted compares the response's lead id against this ref and
  // bails on mismatch — killing the stale-response race.
  const selectedLeadIdRef = useRef(null);

  // Unified CRM iframe-URL contract (see smai-chrome-extension/docs/crm-iframe-url-contract.md).
  // The extension emits the same seven query-string keys for every CRM; branch on
  // crmIntegrationType when a CRM-specific query/mutation shape is needed.
  //
  // These are React state rather than render-time consts so the extension's
  // `crm_context_update` postMessage (sent on every phone-icon click) can
  // update them without a full iframe reload. Initial values still seed from
  // the URL to keep deep-link refresh working.
  const urlParams = new URLSearchParams(locationChatBot);
  const [crmIntegrationType, setCrmIntegrationType] = useState(() =>
    urlParams.get("crmIntegrationType")
  );
  const [crmLeadId, setCrmLeadId] = useState(() => urlParams.get("crmLeadId"));
  const [crmOpportunityId, setCrmOpportunityId] = useState(() => urlParams.get("crmOpportunityId"));
  const [crmDealerId, setCrmDealerId] = useState(() => urlParams.get("crmDealerId"));
  // crmUserId is DS-only today; reserved for future voice-call / assignment flows.
  // eslint-disable-next-line no-unused-vars
  const [crmUserId, setCrmUserId] = useState(() => urlParams.get("crmUserId"));
  const [leadName, setLeadName] = useState(() => urlParams.get("leadName"));
  const [locationName, setLocationName] = useState(() => urlParams.get("locationName"));
  // Gate for the main getLeads useQuery. Prevents the "first call without CRM
  // variables, second call with them" flicker when the parent extension opens
  // `/browser-ext-v3/<phone>` without query params and delivers CRM context via
  // the `crm_context_update` postMessage after mount.
  //
  // Ready signals:
  //   - URL seeded any CRM param on mount → already-ready on first render.
  //   - crm_context_update postMessage received → flip ready.
  //   - 300ms safety timeout → flip ready anyway, so non-CRM loads (bare
  //     /browser-ext-v3/ opened by a user) don't hang on the wait.
  const [crmContextReady, setCrmContextReady] = useState(
    () =>
      !!urlParams.get("crmIntegrationType") ||
      !!urlParams.get("crmLeadId") ||
      !!urlParams.get("crmOpportunityId") ||
      !!urlParams.get("crmDealerId")
  );
  useEffect(() => {
    if (crmContextReady) return undefined;
    const timer = setTimeout(() => setCrmContextReady(true), 300);
    return () => clearTimeout(timer);
  }, [crmContextReady]);
  const locaitonLocalId = localStorage.getItem("changedLocationLeadId");
  // React state (not just a derived const) so clearing it triggers a re-render and hides the
  // "View all messages" button. Initializes from URL or sessionStorage on mount.
  const [targetMessageId, setTargetMessageId] = useState(() => {
    const fromUrl = urlParams.get(URL_PARAM_MESSAGE_ID);
    const fromSession = sessionStorage.getItem("targetMessageId");
    if (fromUrl && !fromSession) {
      sessionStorage.setItem("targetMessageId", fromUrl);
    }
    return fromUrl || fromSession || null;
  });

  const clearTargetMessageId = () => {
    setTargetMessageId(null);
    sessionStorage.removeItem("targetMessageId");
  };

  // Reactive location — updates when Gatsby navigate() pushes a new URL, unlike the `locationChatBot`
  // prop which is a non-reactive snapshot of window.location.search.
  const routerLocation = useLocation();
  let msgUnreadTimeOut;
  let timeReference;
  const { selectedLead, leads: leadList, messageOpportunity } = useSelector(state => state.lead);
  const locationIdslice = useSelector(state => getLocationId(state));
  const leadSourcesReduxData = useSelector(state => getCacheApi(state, "leadSources"));
  const afterMessageFromRedux = useSelector(state => getCacheApi(state, "afterMessageText"));
  const consentTemplateFromRedux = useSelector(state => getCacheApi(state, "consentTemplate"));
  const crmLeadStatusReduxData = useSelector(state => getCacheApi(state, "crmLeadStatus"));
  const userListReduxData = useSelector(state => getCacheApi(state, "userList"));

  const leadCountUpdatedData = useSelector(state => getUpdatedCountInfo(state));
  const { leadScheduledMessages: scheduledMessages } = useSelector(state => state?.lead);
  const { leadSort, search } = useSelector(state => state.lead);
  const allCampaignsReduxData = useSelector(state => getCacheApi(state, "allCampaigns"));
  const actionDispatchTime = useSelector(state => getCacheApi(state, "expiryTime"));

  // `entityId` / `eventId` feed the DealerSocket-shaped GraphQL variables
  // `dsEntityId` / `dsEventId` (backend contract, kept as-is). Their VALUES are
  // derived from the unified CRM contract:
  //   DS  → entityId=crmLeadId,        eventId=crmOpportunityId
  //   VIN → entityId=crmOpportunityId, eventId=""                (maps to autoleadid)
  //   *   → ""                                                   (Tekion, MF, EL, SF, generic)
  // They're kept as React state so search / dispatch / location-switch handlers
  // can clear them without rewriting callers.
  const deriveEntityIdFromUrl = () => {
    if (crmIntegrationType === CRM_TYPES.DEALERSOCKET) return crmLeadId || "";
    if (crmIntegrationType === CRM_TYPES.VIN_SOLUTIONS) return crmOpportunityId || "";
    return "";
  };
  const deriveEventIdFromUrl = () => {
    if (crmIntegrationType === CRM_TYPES.DEALERSOCKET) return crmOpportunityId || "";
    return "";
  };
  const [entityId, setEntityId] = useState(deriveEntityIdFromUrl);
  const [eventId, setEventId] = useState(deriveEventIdFromUrl);
  useEffect(() => {
    setEntityId(deriveEntityIdFromUrl());
    setEventId(deriveEventIdFromUrl());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlParams]);
  const [leadFirstName, setLeadFirstName] = useState(leadName ? leadName.split(" ")[0] : "");
  const [leadLastName, setLeadLastName] = useState(
    leadName ? (leadName.split(" ")?.length > 0 ? leadName.split(" ").splice(1).join(" ") : "") : ""
  );
  const [queryString, setQueryString] = useState(
    (`${location?.split("/")[2]}`.replace("/", "") === "undefined" ||
    `${location?.split("/")[2]}`.replace("/", "") === "remove"
      ? ""
      : `${location?.split("/")[2]}`.replace("/", "")) || ""
  );
  const [activeLeadId, setActiveLeadId] = useState(
    localStorage.getItem("changedLocationLeadId") || false
  );
  const [isReview, setisReview] = useState(false);
  const [openAddModal, setAddPhoneModalVisible] = useState(false);
  const [userIdMap, setUserIdMap] = useState({});
  const [searchKey, setSearchKey] = useState(
    queryString !== "undefined" && queryString !== "remove" ? queryString : ""
  );

  const [showSidebar, setShowSideBar] = useState(true);
  const [isEmojiOpen, setIsEmojiOpen] = useState(false);
  const [textMode, settextMode] = useState(0);
  const [richTextValue, setrichTextValue] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [showReviewRequestButton, setShowReviewRequestButton] = useState(true);
  const [activeOpp, setActiveOpp] = useState("#DEFAULTOPPID");
  const [activeOppName, setActiveOppName] = useState("");
  const [opportunityList, setOpportunityList] = useState([
    { filterId: null, id: "#DEFAULTOPPID", name: "All" },
  ]);
  const [mmsLoader, setmmsLoader] = useState(false);
  const [filterLastId, setFilterLastId] = useState("");
  const [filterApplied, setFilterApplied] = useState(false);
  const [showLeadSection, setShowLeadSection] = useState(window.innerWidth > 1024);
  const [callLeadDetailApi, setCallLeadDetailAPI] = useState(window.innerWidth > 1024);
  const [showProfileSection, setShowProfileSection] = useState(window.innerWidth > 1024);
  const [changeState, setChangeState] = useState(true);
  const [visibleMergeLeadModal, setVisibleMergeLeadModal] = useState(false);
  const [duplicateRecord, setDuplicateRecord] = useState([]);
  const [records, setRecords] = useState([]);
  const [leadCount, setLeadCount] = useState(0);
  const [openCRMModal, setPushToCrmModalVisible] = useState(false);
  const [openAppointmentDrawer, setOpenAppointmentDrawer] = useState(false);
  const [openSendReviewModal, setSendReviewVisible] = useState(false);
  const crmIntegration = useCrmIntegration();
  // Prefer the explicit CRM marker from the URL / postMessage. Only fall back
  // to the "non-numeric crmOpportunityId" heuristic when `crmIntegrationType`
  // is absent — otherwise this false-positives for CRMs that emit UUIDs
  // (e.g. Elead's `aef13925-6923-42bb-b069-88944b86fbc6`), silently skipping
  // the main getLeads query and routing everything through the Tekion path.
  const isTekionCrm =
    crmIntegrationType === CRM_TYPES.TEKION ||
    crmIntegration === CRM_TYPES.TEKION ||
    (!crmIntegrationType && crmOpportunityId && Number.isNaN(Number(crmOpportunityId)));
  const [crmIntegrationData, setcrmIntegrationData] = useState("");
  const [openSetReviewTemplateUploadModal, setReviewTemplateUploadVisible] = useState(false);
  const [openTemplateModal, setTemplateModal] = useState({ visible: false });
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [refetchAppointment, setRefetchAppointment] = useState(false);
  const [inlineField, setInlineEditField] = useState("");
  const [connection, setConnection] = useState({});
  const [openEditUserPhone, setOpenEditUserPhone] = useState(false);
  const [messageFilters, setMessageFilters] = useState({
    campaignIds: [],
    leadId: selectedLead && +selectedLead?.id,
    lastId: lastLead,
    page: 1,
    pageSize,
  });
  const prevStateData = usePrevious({ messageFilters });
  const [globalMessageData, setGlobalMessageData] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const isMobileView = useSelector(state => getMobileView(state));
  const textAiResponseHistoryId = useSelector(getTextAiResponseHistoryId);
  const emailAiResponseHistoryId = useSelector(getEmailAiResponseHistoryId);
  const {
    quickFilters: selectedQuickFilters,
    addMyConversation,
    userFilters,
    campaignFilter,
  } = useSelector(state => state.lead.filters);
  const [isMsgScroll, setIsMsgScroll] = useState(false);
  const { width: screenWidth, height: screenHeight } = useGetScreenDimensions();
  const [disableConcentClick, setDisableConcentClick] = useState(true);
  const [apiCheck, setApiCheck] = useState(false);
  const [tekionSearchDone, setTekionSearchDone] = useState(false);
  const [summaryVisible, setSummaryVisible] = useState({ visible: false, count: 0 });
  const [reviewInfo, setReviewInfo] = useState(null);
  const [leadCampaigns, setLeadCampaigns] = useState([]);
  const [consent, setConsent] = useState([]);
  const [consentTemplate, setConsentTemplate] = useState();
  const [selectedLeadID, setSelectedLeadID] = useState();
  const [openAppointmentPopup, setAppointmentPopupVisible] = useState(false);
  const [statusList, setstatusList] = useState([]);
  const [userLocation, setUserLocation] = useState("");
  const [isAppointmentChangeFromLead, setIsAppointmentChangeFromLead] = useState(false);
  const mediaRef = useRef(null);
  const videoRef = useRef(null);
  const documentRef = useRef(null);
  const shouldScrollOnMessagesLoadRef = useRef(false);
  // Synchronous re-entry guard for MMS send. See engagementActivity.js for
  // the full EAI-1124 root-cause writeup; the same Enter-key + Send-click
  // race exists here.
  const sendingMMSRef = useRef(false);

  const [appintmentLead, setAppointmentLead] = useState({});
  const [notificationDrawer, setNotificationDrawer] = useState(false);
  const [settingsDrawer, setSettingsDrawer] = useState(false);
  const [implicit, setimplicit] = useState(
    consent.find(item => item.code === "CONSENT_MESSAGE_FOR_OPTIN_CONSENT_METHOD_OFF")?.isActive
  );
  const [explicit, setexplicit] = useState(
    consent.find(item => item.code === "CONSENT_MESSAGE_FOR_OPTIN_CONSENT_METHOD_ON")?.isActive
  );
  const [isAutoTranslate, setIsAutoTranslate] = useState(false);
  const [isIncludeOriginalMessage, setIsIncludeOriginalMessage] = useState(false);
  const [isTranslatePreviewShow, setIsTranslatePreviewShow] = useState(false);
  const [originalText, setOriginalText] = useState("");
  const [scheduledMessageDrawer, setscheduledMessageDrawer] = useState({
    open: false,
    messages: null,
  });
  const [visibleTranslationSettings, setVisibleTranslationSetting] = useState(false);
  const canEdit = checkAccessPermission(AccessPermissionAction.LEAD_ADD_EDIT);
  const canViewTranslation = checkAccessPermission(
    AccessPermissionAction.TRANSLATION_MANAGEMENT_VIEW
  );
  const canDisabledConversation = checkAccessPermission(
    AccessPermissionAction.LEAD_MANAGEMENT_DISABLED_CONVERSATION
  );
  const restrictRemoveDefaultFilter = checkAccessPermission(
    AccessPermissionAction.ACTIVITY_CENTER_RESTRICT_REMOVE_DEFAULT_FILTER
  );
  isSkipFilter = !isUndefined(queryString) && !isEmpty(queryString) && queryString !== "remove";
  const [variables, setVariables] = useState({
    source: [],
    sourceOriginal: [],
    combinedSource: [],
    voi: [],
    page: 1,
    pageSize: 25,
    orderBy: "latest_chat",
    orderDirection: "desc",
    status: uniq([...selectedQuickFilters, ...selectedStatus]),
    campaignIds: [],
    dsEntityId: entityId,
    dsEventId: eventId,
    skipFilter: isSkipFilter,
  });

  const [isSingleLeadView, setIsSingleLeadView] = useState(
    !!crmOpportunityId ||
      !isTekionCrm ||
      !!new URLSearchParams(window.location.search).get("crmOpportunityId")
  );

  useEffect(() => {
    const urlLeadId = new URLSearchParams(window.location.search).get("crmOpportunityId");
    if (urlLeadId && !isTekionCrm) {
      setIsSingleLeadView(true);
    }
  }, [window.location.href, isTekionCrm]);

  const [btnClicked, setbtnClicked] = useState(false);
  const [mediaUploadLoader, setMediaUploadLoader] = useState(false);
  const [openPotentialLeadDialog, setOpenPotentialLeadDialog] = useState(false);
  const [isClickonPotentialDuplicate, setIsClickonPotentialDuplicate] = useState(false);
  const [sourcesData, setSourcesData] = useState({});
  const [afterMessageConsent, setAfterMessageConsent] = useState("");
  const [onlyFirstMessage, setonlyFirstMessage] = useState("");
  const [isActive, setisActive] = useState(null);
  const [cosentAtEnd, setcosentAtEnd] = useState(isActive);
  const [recording, setRecording] = useState({ visible: false, lead: {} });
  const [selectedMedia, setSelectedMedia] = useState("");
  const [videoThumbnails, setVideoThumbnails] = useState([]);
  const [IsLeadListVisible, setIsLeadListVisible] = useState(() => {
    const storedValue = sessionStorage.getItem("leadList");
    return storedValue === "true" ? true : false;
  });

  if (process.env.NODE_ENV !== "production") {
    console.log("BrowserExtensionPopup [CRM Debug] V3 Params:", {
      phone: queryString,
      leadName,
      locationName,
      crmLeadId,
      crmOpportunityId,
      crmDealerId,
      crmIntegrationType,
    });
  }
  // console.log("🚀 ~ BrowserExtensionPopup ~ IsLeadListVisible:", IsLeadListVisible);
  const [isLeadProfileVisible, setisLeadProfileVisible] = useState(() => {
    const storedValue = sessionStorage.getItem("leadProfile");
    return storedValue === "true" ? true : false;
  });
  const [getScheduleMessagesForLead] = useLazyQuery(GET_SCHEDULED_MESSAGES_FOR_LEAD, {
    variables: {
      leadId: selectedLead?.id || messageFilters?.leadId,
    },
    skip: !selectedLead?.id || +selectedLead?.id === +selectedLeadID,
    onCompleted: res => {
      dispatch(setScheduledMessages([...res?.getScheduledMessagesForLead]));
    },
  });

  const { socket, isFullScreen } = useContext(UserContext);
  const [targetLangForCustomer, setTargetLangForCustomer] = useState("");
  const [targetLangForEmployee, setTargetLangForEmployee] = useState("");
  const [emailCursor, setemailCursor] = useState(null);
  const [languages, setLanguages] = useState();
  const [stopLoaderForReceivedMessage, setStopLoaderForReceivedMessage] = useState(true);

  useQuery(GET_SUPPORTED_LANGUAGES_BY_LOCATION, {
    fetchPolicy: "cache-first",
    variables: {
      locationId: isAllLocationSelected() ? null : sessionStorage.getItem("currentLocationId"),
    },
    onCompleted: res => {
      if ((res?.getSupportedLanguages || []).length > 0) {
        const languages = structuredClone(getActiveSupportedLanguages(res?.getSupportedLanguages));
        setLanguages(languages);
      }
    },
  });

  const handleLeadListVisible = () => {
    setIsLeadListVisible(prev => !prev);
  };
  const setSelectedLead = lead => {
    // EAI-1200 diagnostic: which lead id is being selected, from which prior
    // id. ONLY internal numeric ids — no names/phones/emails to avoid PII
    // exposure via PostHog. Correlate against [crm_context_update] /
    // [getLeads.onCompleted] logs to trace wrong-lead bugs.
    console.log("[setSelectedLead]", {
      incomingLeadId: lead?.id ?? null,
      previousLeadId: selectedLead?.id ?? null,
      hasIncoming: !isEmpty(lead),
    });
    if (!isEmpty(lead)) {
      const findIndex = (leadList || []).map(el => +el.id === +selectedLead?.id);
      let messages = [...(lead?.messages || [])];
      if (findIndex > 0) {
        messages = [...messages, ...(leadList[findIndex]?.messages || [])];
      }
      dispatch(setSelectedLeadRedux({ ...selectedLead, ...lead }));
    } else {
      dispatch(setSelectedLeadRedux({}));
    }
  };
  const setSelectedLeadId = id => {
    dispatch(setSelectedLeadIdRedux(id));
  };
  const setSearch = search => {
    dispatch(setSearchRedux(search));
  };
  const setLeadList = list => {
    if (list && !isEmpty(list)) {
      const newList = list.map(el => {
        const existingLead = leadList.find(lead => +lead.id === +el.id && !isEmpty(lead.messages));
        if (existingLead) {
          return {
            ...el,
            messages: uniqBy(
              [...(el?.messages || []), ...(existingLead?.messages || [])],
              message => String(message.id)
            ),
          };
        }
        return { ...el };
      });
      dispatch(setLeadsRedux(newList));
    } else if (list && isEmpty(list)) {
      dispatch(setLeadsRedux([]));
    }
  };
  const sendMessageToParent = (messageName, messageContent) => {
    // console.log(
    //   "🚀 ~ sendMessageToParent ~ resizeWindow: IsLeadListVisible",
    //   IsLeadListVisible,
    //   isLeadProfileVisible
    // );
    if (window) {
      window.location.pathname.includes("browser-ext") &&
        window.parent.postMessage(
          {
            event_id: "resizeWindow_trigger",
            data: {
              isLeadProfileVisible: isLeadProfileVisible,
              IsLeadListVisible: IsLeadListVisible,
            },
          },
          "*"
        );
    }

    // window.parent.postMessage({ type: messageName, ...messageContent }, "*");
  };
  useEffect(() => {
    if (!localStorage.getItem("previousLeadSearchTrack"))
      setSearch(queryString !== "undefined" && queryString !== "remove" ? queryString : "");
  }, [queryString]);

  useEffect(() => {
    if (locationIdslice) {
      dispatch(setCampaignFilters([]));
      dispatch(setUserFilters([]));
    }
  }, [locationIdslice]);

  useEffect(() => {
    dispatch(resetTranlatedContent());
  }, [selectedLead?.id]);

  const [getLeadSources, { data: leadSourcesData }] = useLazyQuery(GET_EXTENSION_LEAD_SOURCES, {
    fetchPolicy: "cache-and-network",
    onCompleted: res => {
      if (res.leadSources && res.leadSources.length > 0) {
        setSourcesData(leadSourcesData);
        dispatch(setLeadSources({ leadSources: res.leadSources }));
      }
    },
  });
  useEffect(() => {
    window.addEventListener("message", function (event) {
      // Check if the message is from the extension
      // console.log("Received message from extension:", event);
      if (event.source === window.parent) {
        // Retrieve the data sent from the extension
        const messageData = event.data.data;

        // Process the message data
        // console.log("Received message from extension:", messageData);

        // Optionally, you can send a response back to the extension if needed
        // window.parent.postMessage({ response: 'Response from iframe' }, '*');
      }
    });
  }, []);

  // Extension-driven CRM context updates. The extension keeps the iframe
  // mounted across phone-icon clicks and delivers new context (phone, CRM
  // identifiers, lead/location metadata) via postMessage instead of mutating
  // the iframe src. Updating the same state that the URL seeds keeps every
  // downstream useQuery / derivation reactive without a full reload.
  // Contract: see smai-chrome-extension/docs/crm-iframe-url-contract.md.
  //
  // Dedupes identical re-emissions from the parent. The parent already
  // deduplicates via `_lastSentContextJson`, but that cache resets on
  // `crm_context_ready` and iframe `onLoad`, so an identical payload can be
  // re-delivered after a manual location switch and clobber the state the
  // user just cleared (phone, leadName, crmIntegrationType, etc.). Dedupe on
  // the receiving side too. Persist via sessionStorage rather than useRef so
  // the dedupe survives a component remount (the parent extension can
  // remount the iframe shell after auth refresh / chrome.storage churn,
  // which would reset a useRef and let the next identical postMessage slip
  // through to re-clobber the cleared state).
  const CTX_DEDUPE_KEY = "browserExtensionV3LastAppliedCtxJson";
  const AUTO_MATCH_KEY = "browserExtensionV3LastAutoMatchedCtx";
  const MANUAL_OVERRIDE_KEY = "browserExtensionV3ManualLocationOverride";
  // Mirror of the in-memory CRM identifier set, kept in a ref so the
  // message-listener useEffect (deps: []) can read the *current* state without
  // re-binding. The dedupe below uses this to distinguish "ctx already applied
  // and still live in state" (real no-op) from "ctx was applied earlier but
  // state has since been wiped by a remount" — the latter must re-apply.
  const crmStateRef = useRef({
    crmIntegrationType: null,
    crmLeadId: null,
    crmOpportunityId: null,
    crmDealerId: null,
    queryString: "",
  });
  useEffect(() => {
    crmStateRef.current = {
      crmIntegrationType: crmIntegrationType || null,
      crmLeadId: crmLeadId || null,
      crmOpportunityId: crmOpportunityId || null,
      crmDealerId: crmDealerId || null,
      queryString: queryString || "",
    };
  }, [crmIntegrationType, crmLeadId, crmOpportunityId, crmDealerId, queryString]);
  useEffect(() => {
    const handleCrmContextUpdate = event => {
      if (event?.data?.event_id !== "crm_context_update") return;
      const ctx = event.data.data || {};
      console.log("[crm_context_update] received", ctx);
      // Guard: ignore empty / placeholder postMessages that carry no CRM
      // identifiers and no phone. The parent extension may emit such updates
      // during iframe re-init (e.g., after `crm_context_ready` ack), and the
      // unconditional reset below would (1) clear crmOpportunityId, (2) close
      // an in-flight AddPhoneModal opened by searchTekionLeads, and (3) flip
      // the main getLeads `skip` from true → false, which then loads the
      // location's full lead list and auto-selects the first lead — wiping
      // out the "lead not found here" UX the search just produced. We only
      // apply an update when it has at least one CRM identifier or a phone;
      // otherwise we leave the existing URL/postMessage-derived state intact.
      const hasCrmIdentifier = !!(
        ctx.crmIntegrationType ||
        ctx.crmOpportunityId ||
        ctx.crmLeadId ||
        ctx.crmDealerId ||
        (typeof ctx.phone === "string" && ctx.phone.length > 0)
      );
      if (!hasCrmIdentifier) {
        console.log("[crm_context_update] ignored — empty ctx, preserving existing state");
        return;
      }
      // Dedupe identical re-emissions. Keyed on the lead-identifying subset of
      // the payload — fields that, if unchanged, mean "this is the same lead
      // context we already processed." Excludes ancillary metadata
      // (leadName, locationName, etc.) since the parent occasionally enriches
      // those between identical-identifier emits and we still want a no-op.
      const ctxKey = JSON.stringify({
        crmIntegrationType: ctx.crmIntegrationType || null,
        crmLeadId: ctx.crmLeadId || null,
        crmOpportunityId: ctx.crmOpportunityId || null,
        crmDealerId: ctx.crmDealerId || null,
        phone: typeof ctx.phone === "string" ? ctx.phone : "",
      });
      const lastAppliedCtxJson = sessionStorage.getItem(CTX_DEDUPE_KEY);
      const manualOverride = sessionStorage.getItem(MANUAL_OVERRIDE_KEY) === "true";
      // Compare against the *live* React state, not just the sessionStorage
      // dedupe key. The dedupe key persists across component remounts (by
      // design — see comment above), but the state itself does not. If the
      // parent extension remounts the iframe shell after we've applied a
      // ctx, mount #2 will see the same dedupe key with `null` CRM state.
      // Skipping there leaves the new mount with no CRM identifiers, and
      // the main getLeads runs unscoped and auto-selects the first lead.
      // Only treat the message as a true no-op when both the dedupe key
      // AND the in-memory state match.
      const stateMatchesCtx =
        crmStateRef.current.crmIntegrationType === (ctx.crmIntegrationType || null) &&
        crmStateRef.current.crmLeadId === (ctx.crmLeadId || null) &&
        crmStateRef.current.crmOpportunityId === (ctx.crmOpportunityId || null) &&
        crmStateRef.current.crmDealerId === (ctx.crmDealerId || null) &&
        crmStateRef.current.queryString === (typeof ctx.phone === "string" ? ctx.phone : "");
      if (lastAppliedCtxJson === ctxKey && stateMatchesCtx) {
        console.log("[crm_context_update] ignored — same identifier set already applied", {
          ctxKey,
          manualOverride,
        });
        return;
      }
      if (lastAppliedCtxJson === ctxKey && !stateMatchesCtx && !manualOverride) {
        // State was wiped without a manual switch — most likely the parent
        // remounted the iframe shell (auth refresh, chrome.storage churn).
        // Fall through and re-apply so the new mount isn't left empty. The
        // same-ctx-while-manual-override case is handled by the override
        // block below (early-return on ctxKey match).
        console.log("[crm_context_update] re-applying — dedupe matched but state was wiped", {
          ctxKey,
          stateSnapshot: crmStateRef.current,
        });
      }
      // Manual location override: while the user is holding a manual
      // location switch, ignore passive re-flushes of the SAME ctx (parent
      // re-emits the cached payload on iframe remount / onLoad /
      // crm_context_ready) — those would restore the old crmDealerId and
      // snap the location back. The discriminator is ctxKey: a re-flush
      // carries the same key as the cached one; a real user action (new
      // phone click in CRM) changes crmLeadId / crmOpportunityId / phone,
      // so ctxKey differs and we fall through to apply.
      //
      // We deliberately don't key off ctx.manualOverride here. The flag is
      // only attached by feature-branch builds of the parent extension;
      // the published prod extension never sets it, so depending on it
      // would silently ignore real clicks on prod after a manual switch.
      // ctxKey works across all extension builds.
      //
      // When ctxKey differs (real new context arrived) we also clear the
      // override so subsequent passive re-flushes for the NEW lead behave
      // normally — the override has served its purpose.
      if (manualOverride) {
        if (lastAppliedCtxJson === ctxKey) {
          console.log("[crm_context_update] ignored — manual override active, same ctx re-flush", {
            ctxKey,
            incoming: ctx,
          });
          return;
        }
        sessionStorage.removeItem(MANUAL_OVERRIDE_KEY);
      }
      sessionStorage.setItem(CTX_DEDUPE_KEY, ctxKey);
      console.log("[crm_context_update] applying", { ctxKey });
      // CRITICAL: clear the currently-displayed lead + list BEFORE applying
      // the new CRM context. Without this, between postMessage and the
      // subsequent getLeads response returning, the UI keeps rendering the
      // PREVIOUS lead (Herman) while the search bar / CRM vars already show
      // the NEW one (Antonio). Worse, stale in-flight queries fired for the
      // previous lead (getLeadDetail / getLeadDetailClick) can arrive late
      // and merge their data back into `selectedLead` on top of the new one.
      // Clearing here + per-response id guards below gives a clean handoff.
      dispatch(setSelectedLeadRedux({}));
      dispatch(setLeadsRedux([]));
      setLeadCount(0);
      setSelectedLeadID(undefined);
      setLeadIdClick("");
      localStorage.removeItem("clickLeadId");
      // Tear down any AddPhonePopup left open from a previous CRM click.
      // Without this, clicking a not-found lead opens the popup, then
      // clicking a different (found) lead in the CRM updates the header /
      // sidebar to the new lead but the popup stays mounted with the
      // PREVIOUS lead's prefilled name + phone — which is misleading and
      // can also accidentally create a lead under the new context if the
      // user clicks Start Conversation.
      setAddPhoneModalVisible(false);
      closeDialog("addLeadViaPhone");
      closeDialog("leadAccessPermissionMessage");
      // Full reset + apply semantics. Each setter below replaces (never
      // merges) with the value from the incoming ctx; if the field is missing
      // in ctx, state goes back to null/empty. So every new extension-icon
      // click that produces a postMessage lands with a clean slate — no
      // lingering crmLeadId / crmOpportunityId / crmDealerId / crmIntegrationType
      // from the previous click.
      setCrmIntegrationType(ctx.crmIntegrationType || null);
      setCrmLeadId(ctx.crmLeadId || null);
      setCrmOpportunityId(ctx.crmOpportunityId || null);
      setCrmDealerId(ctx.crmDealerId || null);
      setCrmUserId(ctx.crmUserId || null);
      setLeadName(ctx.leadName || null);
      setLocationName(ctx.locationName || null);
      // Keep `isSingleLeadView` in sync with the ctx. The initial-mount
      // effect at isSingleLeadView's declaration only flips this to `true`;
      // without an explicit reset here, a click that drops `crmOpportunityId`
      // would leave the sidebar stuck in single-lead-view mode.
      setIsSingleLeadView(!!ctx.crmOpportunityId);
      // Release the getLeads gate: main useQuery was waiting for this exact
      // message so it doesn't fire once with null CRM vars and again with
      // real ones. All four CRM state setters above apply in the same React
      // batch as this flip, so the gate-open render has full variables.
      setCrmContextReady(true);

      const phone = typeof ctx.phone === "string" ? ctx.phone : "";
      setQueryString(phone);
      setSearchKey(phone);
      setSearch(phone);

      const nameParts = (ctx.leadName || "").split(" ");
      setLeadFirstName(nameParts[0] || "");
      setLeadLastName(nameParts.length > 1 ? nameParts.slice(1).join(" ") : "");
    };
    window.addEventListener("message", handleCrmContextUpdate);

    // Signal the parent extension that this iframe is ready to receive
    // crm_context_update messages. The extension will reset its dedupe cache
    // and re-post the latest context in response. Without this, the first
    // message sent from componentDidUpdate (before this listener was
    // registered) is lost.
    if (window.parent && window.parent !== window) {
      console.log("[crm_context_ready] posting to parent");
      window.parent.postMessage({ event_id: "crm_context_ready" }, "*");
    }

    return () => window.removeEventListener("message", handleCrmContextUpdate);
  }, []);

  // Auto-select the EngagedAI location whose CRM integration matches the
  // `crmDealerId` emitted by the extension (per the unified iframe-URL
  // contract). Without this, users who land in a non-default dealer context
  // would see data for the wrong location until they manually change the
  // dropdown. Setting `sessionStorage.currentLocationId` is what the Apollo
  // middleware at authenticator-provider.js reads to populate the
  // `sLocationId` request header on every GraphQL call. Dispatching
  // `setLocationIdSlice` keeps the rest of the app (dropdown value, redux
  // consumers, Apollo client re-auth headers) in sync.
  //
  // Fires whenever `crmDealerId` / `crmIntegrationType` change. Use cases:
  //   - Initial load with URL-seeded crmDealerId → applies matched location.
  //   - New crm_context_update with a different dealer → applies new location.
  //   - Same-dealer, different-phone update → deps don't change → no re-run,
  //     location stays where it already is.
  //   - Manual dropdown switch → resetSearch() sets crmDealerId to null →
  //     effect early-returns, leaving the user's choice intact.
  //
  // Spurious re-emissions of the *same* ctx (e.g. dev Strict Mode firing the
  // crm_context_ready useEffect twice, which resets the parent's dedupe) are
  // caught by the iframe-side dedupe in `handleCrmContextUpdate`, so this
  // effect never sees the second emit and never undoes a manual switch.
  useEffect(() => {
    if (!crmDealerId) return;
    if (!user?.locations?.length) return;
    const isTekion = crmIntegrationType === CRM_TYPES.TEKION;
    const matched = user.locations.find(loc => {
      const integration = loc?.location?.crmIntegration;
      if (!integration) return false;
      if (crmIntegrationType && integration.integrationType !== crmIntegrationType) return false;
      // Tekion identifies the dealer/site by crmFranchiseId; other CRMs use crmDealerId.
      const locDealerKey = isTekion ? integration.crmFranchiseId : integration.crmDealerId;
      return locDealerKey === crmDealerId;
    });
    console.log("[location-match] result", {
      matchedLocationId: matched?.location?.id ?? null,
      matchedIntegrationType: matched?.location?.crmIntegration?.integrationType ?? null,
    });
    if (!matched?.location?.id) return;
    const matchedLocationId = String(matched.location.id);
    if (sessionStorage.getItem("currentLocationId") === matchedLocationId) return;
    sessionStorage.setItem("currentLocationId", matchedLocationId);
    dispatch(setLocationIdSlice({ locationId: matchedLocationId }));
  }, [user?.locations, crmDealerId, crmIntegrationType, dispatch]);

  useEffect(() => {
    sessionStorage.setItem("leadProfile", isLeadProfileVisible);
    sessionStorage.setItem("leadList", IsLeadListVisible);
  }, [isLeadProfileVisible, IsLeadListVisible]);

  const initialIFrameWidth = 650;
  useEffect(() => {
    sendMessageToParent("engagedai-resize", {
      width: IsLeadListVisible
        ? isLeadProfileVisible
          ? screenParts.leftSide + screenParts.rightSide + initialIFrameWidth
          : screenParts.leftSide + initialIFrameWidth
        : isLeadProfileVisible
        ? screenParts.rightSide + initialIFrameWidth
        : initialIFrameWidth,
    });
  }, [IsLeadListVisible]);

  useEffect(() => {
    setSelectedLead({ ...selectedLead, messages: [] });
    setMessageFilters({
      ...messageFilters,
      leadOpportunityId: messageOpportunity === "#DEFAULTOPPID" ? null : messageOpportunity,
      page: 1,
    });
    // Flag to scroll to bottom after messages are loaded
    shouldScrollOnMessagesLoadRef.current = true;
  }, [messageOpportunity]);

  useEffect(() => {
    sendMessageToParent("engagedai-resize", {
      width: isLeadProfileVisible
        ? IsLeadListVisible
          ? screenParts.rightSide + screenParts.leftSide + initialIFrameWidth
          : screenParts.rightSide + initialIFrameWidth
        : IsLeadListVisible
        ? screenParts.leftSide + initialIFrameWidth
        : initialIFrameWidth,
    });
  }, [isLeadProfileVisible]);
  // useEffect(() => {
  //   window.addEventListener("beforeunload", event => {
  //     localStorage.removeItem("leadList");
  //     localStorage.removeItem("leadProfile");
  //   });
  //   return () => {
  //     window.removeEventListener("beforeunload", event => {});
  //   };
  // }, []);
  useEffect(() => {
    // The user may click the phone number on any page to trigger the browser
    // extension, so we may not know the location this opportunity belongs to.
    // Moreover, in DealerTeam, the customer may exist independent of any
    // location; only the opportunity is tied to a specific location. As we may
    // not even know if the trigger for the browser extension was on a specific
    // opportunity page, we cannot assume a location to be available in this
    // context.
    if (crmIntegration !== null && crmIntegration === "DT") {
      let ids = "";
      for (let i = 0; i < location2.length; i++) {
        const element = location2[i];
        ids = `${ids}${element.id}${location2.length - 1 === i ? "" : ","}`;
      }
      sessionStorage.setItem("currentLocationId", ids);
    }
  }, [location2, crmIntegration]);

  useEffect(() => {
    if (!leadSourcesReduxData.length) {
      getLeadSources();
    } else {
      setSourcesData(leadSourcesReduxData);
    }
    if (!crmLeadStatusReduxData.crmLeadStatus.length) {
      getCrmLeadStatusData();
    } else {
      setstatusList(crmLeadStatusReduxData.crmLeadStatus);
      setcrmIntegrationData(crmLeadStatusReduxData.crmIntegrationData);
    }
  }, [leadSourcesReduxData, crmLeadStatusReduxData]);
  // useEffect(() => {
  //   // Toggle sidebar based on the screen width breakpoint (e.g., 1000px)
  //   if (width <= 800) {
  //     setisLeadProfileVisible(false);
  //   } else {
  //     setisLeadProfileVisible(true);
  //   }
  // }, [width]);
  const record = lead => {
    try {
      setRecording({ visible: true, lead: lead });
    } catch (err) {
      //
    }
  };

  const setSelectedLeadPhoneToRedux = selectedLeadPhone => {
    dispatch(setSelectedLeadPhone({ selectedLeadPhone }));
  };

  const [getUsersByCompany] = useLazyQuery(GET_ALL_USERS_ACTIVITY_CENTER, {
    variables: { companyId: +user?.company?.id || 0 },
    fetchPolicy: "cache-first",
    onCompleted: async res => {
      const data = res?.getUsers?.data || [];
      if (data != null && data.length > 0) {
        dispatch(setUserList({ usersList: data || [], companyId: user.company.id }));
        await parseUserList(data, userIdMap, setUserIdMap);
      }
    },
  });

  const [getAfterMessageText] = useLazyQuery(GET_COMPANY_AFTER_MESSAGE_CONSENT_TEMPLATE, {
    fetchPolicy: "network-only",
    onCompleted: res => {
      dispatch(setAfterMessageText({ afterMessageText: res?.getAfterMessageText }));
      setAfterMessageConsent(res?.getAfterMessageText?.content);
      setonlyFirstMessage(res?.getAfterMessageText?.onlyFirstMessage);
      setisActive(res?.getAfterMessageText?.isActive);
    },
  });

  useEffect(() => {
    if (user?.company?.id && consent.length === 0) {
      getCompanyConsentTemplateEvent();
    }
  }, [user?.company?.id, consent]);

  useEffect(() => {
    if (
      Object.entries(userListReduxData.users).length &&
      +user?.company?.id === +userListReduxData?.companyId
    ) {
      setUserIdMap({ ...userListReduxData.users });
    }
    if (allCampaignsReduxData?.length === 0) {
      getAllCampaigns();
    }

    if (isEmpty(afterMessageFromRedux)) {
      getAfterMessageText();
    } else {
      setAfterMessageConsent(afterMessageFromRedux?.content);
      setonlyFirstMessage(afterMessageFromRedux?.onlyFirstMessage);
      setisActive(afterMessageFromRedux?.isActive);
      setcosentAtEnd(afterMessageFromRedux?.isActive);
    }
  }, [user?.company?.id, userListReduxData, allCampaignsReduxData, afterMessageFromRedux]);

  // Expire cached data periodically to fetch latest from server
  useInterval(() => {
    dispatch(resetApiCacheStore({}));
  }, parseInt(actionDispatchTime));

  const [getCrmLeadStatusData] = useLazyQuery(GET_CRM_LEAD_STATUS, {
    fetchPolicy: "network-only",
    onCompleted: resp => {
      setcrmIntegrationData(resp?.getCrmLeadStatus?.data);
      const leadStatus = (resp?.getCrmLeadStatus?.data || []).map(e => ({
        status: e?.status?.replace(/_/g, " "),
        statusTypeId: e?.statusTypeId,
        type: e.type,
        crmId: e?.id,
      }));
      setstatusList([...leadStatus]);
      dispatch(
        setCrmLeadStatus({
          crmLeadStatus: leadStatus,
          crmIntegration: resp?.getCrmLeadStatus?.crmIntegrationType,
          crmIntegrationData: resp?.getCrmLeadStatus?.data,
        })
      );
    },
  });

  const [doNotMerge, setDoNotMerge] = useState({
    merged: false,
  });

  const handleCheckboxChange = key => {
    setDoNotMerge(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleRadioChange = (field, recordIndex) => {
    setRecords(prevRecords =>
      prevRecords.map((record, index) => ({
        ...record,
        [field]: {
          ...record[field],
          selected: index === recordIndex - 1,
        },
      }))
    );
  };

  // eslint-disable-next-line react/display-name
  const RadioField = ({ field, record, recordIndex, onRadioChange }) => {
    const [seeMore, setSeeMore] = useState(false);
    const value = record[field]?.value;
    const icon = <CheckOutlined className="text-green-500" />;

    const handleToggleSeeMore = e => {
      e.stopPropagation(); // Prevent the Radio event from triggering
      setSeeMore(prev => !prev); // Toggle See More state
    };

    const renderValues = () => {
      const values = value
        .split(",")
        .map(val => val.trim())
        .filter(val => val !== "");

      const displayedValues = seeMore ? values : values.slice(0, 3);

      return (
        <>
          {displayedValues.map((val, index) => (
            <div key={index} className="flex items-center gap-1">
              {val}
              {record[field]?.phoneNumbers?.length > index && (
                <span className="text-gray-500">
                  ({record[field]?.phoneNumbers[index]?.phoneType})
                </span>
              )}
              {record[field]?.Owners?.length > index && (
                <span className="text-gray-500">
                  ({record[field]?.Owners[index]?.userType?.name})
                </span>
              )}
              {index === 0 && !record[field]?.Owners && icon}
            </div>
          ))}
          {values.length > 3 && (
            <span className="text-blue-500 cursor-pointer" onClick={handleToggleSeeMore}>
              {seeMore ? "See Less" : "See More"}
            </span>
          )}
        </>
      );
    };

    return (
      <div className="flex items-start gap-2">
        <Radio
          onChange={() => onRadioChange(field, recordIndex)} // Trigger only on radio change
          checked={record[field]?.selected}
          className="mt-1"
          disabled={record[field]?.disabled}
        />
        <div>{value && value.includes(",") ? renderValues() : value || "N/A"}</div>
      </div>
    );
  };

  const fields = (records?.length > 0 ? Object.keys(records[0]) : []).filter(key => key !== "id");

  // Render dynamic checkboxes aligned with the dynamic records
  const renderCheckboxes = index => (
    <Checkbox
      checked={doNotMerge[`record${index + 1}`]}
      onChange={() => handleCheckboxChange(`record${index + 1}`)}
      className="relative bottom-[120%] left-[1%]"
      // className="relative"
    >
      <span className="text-[#334155] text-xs">Do Not Merge</span>
    </Checkbox>
  );

  const selectFieldsAtIndex = i => {
    setRecords(prevRecords => {
      // Create a new array with updated records
      return prevRecords.map((record, index) => {
        if (index === i) {
          // Set selected: true for the specified index
          return {
            ...record,
            Name: { ...record.Name, selected: true },
            "Phone number": { ...record["Phone number"], selected: true },
            Address: { ...record.Address, selected: true },
            Location: { ...record.Location, selected: true },
            Owners: { ...record.Owners, selected: true },
            Email: { ...record.Email, selected: true },
            "Lead status": { ...record["Lead status"], selected: true },
            Source: { ...record.Source, selected: true },
            Vehicle: { ...record.Vehicle, selected: true },
          };
        } else {
          // Set selected: false for all other indices
          return {
            ...record,
            Name: { ...record.Name, selected: false },
            "Phone number": { ...record["Phone number"], selected: false },
            Address: { ...record.Address, selected: false },
            Location: { ...record.Location, selected: false },
            Owners: { ...record.Owners, selected: false },
            Email: { ...record.Email, selected: false },
            "Lead status": { ...record["Lead status"], selected: false },
            Source: { ...record.Source, selected: false },
            Vehicle: { ...record.Vehicle, selected: false },
          };
        }
      });
    });
  };

  const columns = [
    {
      title: "Field",
      dataIndex: "field",
      key: "field",
      className: "highlight-column",
      width: "200px",
      onCell: () => ({
        style: { backgroundColor: "#E2E8F0" }, // Background for cells
      }),
    },
    {
      title: "Merged Record",
      dataIndex: "merged",
      key: "merged",
      className: "highlight-column",
      width: "200px",
      render: (text, record) => record.merged || "N/A", // Display merged record
      onCell: () => ({
        style: { backgroundColor: "#E2E8F0" }, // Background for cells
      }),
    },
    ...records.map((_, index) => ({
      title: (
        <div style={{ textAlign: "center" }}>
          <div>{renderCheckboxes(index)}</div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span className="text-[14px]">Record {index + 1}</span>
            <span
              className={`text-[#3B82F6] ml-2 text-[14px] cursor-pointer ${
                doNotMerge[`record${index + 1}`] ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={() => !doNotMerge[`record${index + 1}`] && selectFieldsAtIndex(index)}
            >
              Select All
            </span>
          </div>
        </div>
      ),
      dataIndex: `record${index}`,
      key: `record${index}`,
      render: (text, record) => {
        const fieldName = record.field; // Field like name, address, city
        return (
          <RadioField
            key={index}
            field={fieldName}
            record={records[index]}
            recordIndex={index + 1}
            onRadioChange={handleRadioChange}
          />
        );
      },
      onCell: () => ({
        style: { backgroundColor: "#FFFFFF" }, // Background for cells
      }),
    })),
  ];

  const tableData = fields.map(field => {
    const row = { field };

    // Find the first record where the field has `selected: true`
    const selectedRecord = records.find(record => record[field]?.selected === true);

    // Use the selected record's value, or fallback to the first record if no selected record
    row.merged = selectedRecord ? selectedRecord[field]?.value : records[0][field]?.value || "N/A";

    // Fill data for other records (record1, record2, etc.)
    records.forEach((record, index) => {
      row[`record${index}`] = record[field]?.value || "N/A";
    });

    return row;
  });

  const setFilterStatusForTeamLeader = async isTeamLeader => {
    if (restrictRemoveDefaultFilter) {
      const hasMyConversation = selectedQuickFilters?.includes(QUICK_FILTERS.MY_CONVERSATIONS);
      if (!hasMyConversation) {
        dispatch(addQuickFilter(QUICK_FILTERS.MY_CONVERSATIONS));
      }
      // Unified CRM routing — refetchLeads works for every CRM now.
      refetchLeads();
      return;
    }
    if (addMyConversation) {
      const status = uniq([...selectedQuickFilters, ...selectedStatus]);
      const hasMyConversation = status?.find(item => item === QUICK_FILTERS.MY_CONVERSATIONS);
      if (!isTeamLeader && !hasMyConversation) {
        status.push(QUICK_FILTERS.MY_CONVERSATIONS);
        dispatch(addQuickFilter(QUICK_FILTERS.MY_CONVERSATIONS));
      } else if (isTeamLeader && hasMyConversation) {
        const newStatusList = status.filter(item => item !== QUICK_FILTERS.MY_CONVERSATIONS);
        setSelectedStatus(newStatusList);
      }
      // Unified CRM routing — refetchLeads works for every CRM now.
      refetchLeads();
    }
  };

  // console.log("browser-ext: user?.id, selectedLead?.id:", user?.id, selectedLead?.id);
  const [getTeamsByCompany] = useLazyQuery(GET_ALL_TEAMS, {
    variables: {
      companyId: user?.company?.id,
    },
    onCompleted: async res => {
      const teamData = res?.getTeams?.data || [];
      if (res && teamData.length > 0) {
        const isTeamLeader = teamData.filter(item => +item?.leaderId === +user?.id)?.length > 0;
        dispatch(setIsuserTeamLeader({ isUserTeamLeader: isTeamLeader }));
        await setFilterStatusForTeamLeader(isTeamLeader);
      }
    },
  });
  const [isRefetching, setRefetching] = useState(false);

  // Professional Solution: Memoize ALL query variable arrays
  // Apollo Client uses deep equality for variables - new array references trigger refetches
  // These memoizations ensure arrays only change when their actual data changes
  const memoizedLocationIds = useMemo(() => {
    return (user?.locations || []).map(item => +item.location.id);
  }, [user?.locations]);

  const memoizedStatusArray = useMemo(() => {
    return uniq([...selectedQuickFilters, ...selectedStatus]);
  }, [selectedQuickFilters, selectedStatus]);

  const memoizedCampaignIds = useMemo(() => {
    return (variables?.campaignIds || []).map(el => parseInt(el));
  }, [variables?.campaignIds]);

  const memoizedUserIds = useMemo(() => {
    return [...userFilters];
  }, [userFilters]);

  const [refreshLeadList, { loading: refreshLeadListLoading }] = useLazyQuery(
    GET_EXTENSION_LIST_ACTIVITY_CENTER,
    {
      fetchPolicy: "network-only",
      variables: {
        ...variables,
        search,
        status: memoizedStatusArray,
        campaignIds: memoizedCampaignIds,
        excludeDuplicate: true,
        userIds: memoizedUserIds,
        prioritySortOrder: leadSort,
        locationIds: memoizedLocationIds,
        // Unified CRM routing — backend branches on crmIntegrationType and uses
        // crmLeadId / crmOpportunityId / crmDealerId to resolve the lead for any
        // CRM (DS, VIN, TK, EL, MF, SF). Single query replaces the previous
        // per-CRM split (dsEntityId/dsEventId for DS, searchTekionLeads for TK).
        crmIntegrationType: crmIntegrationType || undefined,
        crmLeadId: crmLeadId || undefined,
        crmOpportunityId: crmOpportunityId || undefined,
        crmDealerId: crmDealerId || undefined,
      },
    }
  );
  const prevYourReduxValueRef = useRef();
  const prevStatusRef = useRef();
  if (process.env.NODE_ENV !== "production") {
    console.log("🚀 ~ BrowserExtensionPopup ~ render: crmIntegrationType:", crmIntegrationType);
  }
  const {
    data: leadData,
    loading: leadsLoading,
    error: leadsError,
    refetch: refetchLeads,
  } = useQuery(GET_EXTENSION_LIST_ACTIVITY_CENTER, {
    // Extension/webapp expectation: fresh leads on every mount. `cache-and-network`
    // fires onCompleted TWICE (cache hit + network response), which double-opens the
    // addLeadViaPhone dialog and causes an open→close→open flicker. `network-only`
    // fires onCompleted once per fetch; subsequent refetch() calls still hit network
    // (correct for this flow — search, filter, location change, pagination all want
    // fresh data).
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    // Unified CRM routing: single getLeads path for every CRM. No more
    // `isTekionCrm` skip — the backend branches on crmIntegrationType and
    // resolves via crmLeadId / crmOpportunityId / crmDealerId.
    //
    // Also gated on `crmContextReady` so we don't fire once with null CRM
    // variables (before the parent extension's crm_context_update postMessage
    // arrives) and a second time with the real values. See `crmContextReady`
    // setup above for the ready conditions.
    skip:
      sessionStorage.getItem("currentLocationId") === null ||
      !sessionStorage.getItem("currentLocationId") ||
      !crmContextReady ||
      // Tekion phone-less opportunity lookup: when the CRM posts a
      // crmOpportunityId but no phone, the main getLeads path returns the
      // whole location-wide list (skipFilter=true doesn't narrow to a
      // single lead without a phone match). Route this case through the
      // legacy searchTekionLeads (GET_LEADS_BY_PHONE / getLeadsSearch)
      // below, which resolves the exact lead by crmOpportunityId.
      (isTekionCrm && isEmpty(queryString) && !!crmOpportunityId),
    variables: {
      ...variables,
      search: search ? search?.trim() : "",
      // Legacy DS-shaped variables — backend still accepts them, and the
      // derivation path (deriveEntityIdFromUrl / deriveEventIdFromUrl) already
      // scopes them to DS-only. Kept for backward compatibility until backend
      // stops reading dsEntityId/dsEventId entirely.
      // dsEntityId: entityId || "",
      // dsEventId: eventId || "",
      // Unified CRM variables — populated from the postMessage/URL contract.
      // For any CRM, these carry the raw identifiers the backend needs to
      // resolve the lead (hex for Tekion, numeric for DS/VIN, UUID for Elead,
      // absent for Momentum/Salesforce which use phone-only lookup).
      crmIntegrationType: crmIntegrationType || undefined,
      crmLeadId: crmLeadId || undefined,
      crmOpportunityId: crmOpportunityId || undefined,
      crmDealerId: crmDealerId || undefined,
      status: isEmpty(search) && !variables?.leadId ? memoizedStatusArray : [],
      campaignIds: memoizedCampaignIds,
      excludeDuplicate: true,
      userIds: memoizedUserIds,
      prioritySortOrder: leadSort,
      // Single-lead-view gate: present whenever the CRM context identifies a
      // specific lead/opportunity. Backend uses this to return just that lead.
      skipFilter: !isEmpty(search) || !!crmLeadId || !!crmOpportunityId,
      // `leadId` is the legacy numeric-only filter; keep only the numeric case
      // so non-numeric ids (Tekion hex, Elead UUID) flow through crmLeadId /
      // crmOpportunityId instead.
      // leadId: crmOpportunityId && !Number.isNaN(Number(crmOpportunityId)) && crmOpportunityId,
      pageSize: variables.pageSize,
      locationIds: memoizedLocationIds,
    },
    onCompleted: res => {
      let leadList = res?.getLeads?.data || [];
      let leadListCount = res?.getLeads?.count || [];
      // EAI-1200 diagnostic: what response landed and whether the
      // isRefetching gate is about to fire. ONLY ids + flags — no names /
      // phones / search strings to avoid PII exposure via PostHog. crmLeadId
      // and crmOpportunityId are CRM-side opaque tokens (already in existing
      // [crm_context_update] logs).
      console.log("[getLeads.onCompleted] enter", {
        responseCount: res?.getLeads?.count,
        responseLeadIds: leadList.map(l => l?.id),
        crmLeadId,
        crmOpportunityId,
        hasSearch: !isEmpty(search),
        isRefetching,
      });
      // Historical guard: a parallel notification-driven refreshLeadList
      // can "win" by blocking the main useQuery's onCompleted. If that
      // notification promise ever rejects silently, the flag stays true and
      // every subsequent main-query response is discarded.
      //
      // EAI-1200 diagnostic: SKIPPED warn is no longer gated by NODE_ENV —
      // we need PostHog visibility on prod to know when this is actually
      // firing for failing user sessions.
      if (isRefetching) {
        console.warn("[getLeads.onCompleted] SKIPPED — isRefetching=true", {
          responseCount: res?.getLeads?.count,
          responseLeadIds: (res?.getLeads?.data || []).map(l => l?.id),
          crmLeadId,
          crmOpportunityId,
          hasSearch: !isEmpty(search),
        });
        return;
      }
      setApiCheck(false);

      isSkipFilter = !isUndefined(queryString) && !isEmpty(queryString) && queryString !== "remove";
      if (res?.getLeads?.count > 0) {
        localStorage.setItem("previousLeadSearchTrack", searchKey);
        setLeadCount(res.getLeads.count);
        leadList = leadList.filter(x => x.id !== lead?.id);
        if (
          !(lead && Object.keys(lead).length === 0) &&
          !isEmpty(lead) &&
          search.length === 0 &&
          variables?.source.length === 0 &&
          variables?.voi.length === 0
        ) {
          handleLeadDetailProfile(lead?.id);
        } else {
          let leadInfo = selectedLead;
          if (!selectedLead?.id || isEmpty(selectedLead)) {
            if (activeLeadId) {
              const leads = structuredClone([...leadList]);
              setLeadList(leads);
              setSelectedLead({ ...leads[0], messages: [] });
              handleLeadDetailProfile(leads[0]?.id);
              setApiCheck(true);
              return;
            }

            const currentLead = leadList.filter(lead => +lead?.id === +activeLeadId);
            leadInfo = activeLeadId ? currentLead.length > 0 && currentLead[0] : leadList[0];
            setLeadList(structuredClone([...leadList]));
            setSelectedLead({ ...leadInfo, messages: [] });
            clearTimeout(msgUnreadTimeOut);
          } else {
            setLeadList([...leadList]);
            leadInfo = { ...leadList[0] };
            setSelectedLead({ ...leadList[0], messages: [] });
            clearTimeout(msgUnreadTimeOut);
          }

          page = 1;
          setMessageFilters({
            ...messageFilters,
            leadId: leadInfo?.id,
            lastId: lastLead,
            page: 1,
          });
        }
        if (!activeLeadId) {
          // Single-lead-view (CRM phone click) — backend resolved the
          // specific lead for us, possibly at a location different from the
          // user's currently-selected dropdown value. Skip the local
          // location filter (it would reject the lead) and auto-switch
          // `currentLocationId` to the returned lead's location so follow-up
          // queries (messages, lead detail, campaigns) use the right
          // sLocationId header.
          const isCrmSingleLead = (!!crmLeadId || !!crmOpportunityId) && leadList.length > 0;
          if (isCrmSingleLead) {
            const targetLocId = leadList[0]?.location?.id;
            if (
              targetLocId &&
              String(sessionStorage.getItem("currentLocationId")) !== String(targetLocId)
            ) {
              sessionStorage.setItem("currentLocationId", String(targetLocId));
              dispatch(setLocationIdSlice({ locationId: String(targetLocId) }));
            }
            clearTimeout(msgUnreadTimeOut);
          } else if (sessionStorage.getItem("currentLocationId")?.includes(",")) {
            // "All locations" selected — show everything.
            setLeadList([...leadList]);
            setSelectedLead({ ...leadList[0], messages: [] });
            clearTimeout(msgUnreadTimeOut);
          } else {
            if (
              sessionStorage.getItem("currentLocationId") === undefined ||
              sessionStorage.getItem("currentLocationId") === "undefined"
            ) {
              if (crmIntegration !== null && crmIntegration === "DT") {
                let ids = "";
                for (let i = 0; i < location2.length; i++) {
                  const element = location2[i];
                  ids = `${ids}${element.id}${location2.length - 1 === i ? "" : ","}`;
                }
                sessionStorage.setItem("currentLocationId", ids);
              }
            }
            const currentLocForFilter =
              locationIdslice || sessionStorage.getItem("currentLocationId");
            const filterArr = leadList.filter(item => {
              if (item?.location?.id === currentLocForFilter) {
                return item;
              }
              if (item?.leadOpportunities?.length > 0) {
                const locOpps = item?.leadOpportunities.filter(
                  lo => lo.location?.id === currentLocForFilter
                );
                if (locOpps.length > 0) {
                  return item;
                }
              }
            });

            leadListCount = (filterArr || []).length;

            if (leadListCount > 0) {
              setLeadList(structuredClone([...filterArr]));
              setSelectedLead({ ...filterArr[0], messages: [] });
            }

            clearTimeout(msgUnreadTimeOut);
          }
        }
        setAddPhoneModalVisible(false);
        closeDialog("addLeadViaPhone");
        closeDialog("leadAccessPermissionMessage");
        if (leadSort !== prevYourReduxValueRef.current) {
          setLeadList([...leadList]);
          if (+leadList[0].id === +selectedLead?.id) {
            setSelectedLead({ ...leadList[0], ...selectedLead });
          } else {
            setSelectedLead({ ...leadList[0], messages: [] });
          }
          setActiveLeadId(leadList[0]?.id);
          setSelectedLeadID(leadList[0]?.id);
          prevYourReduxValueRef.current = leadSort;
        }
        if (uniq([...selectedQuickFilters, ...selectedStatus]) !== prevStatusRef) {
          setLeadList([...leadList]);
          if (+leadList[0].id === +selectedLead?.id) {
            setSelectedLead({ ...leadList[0], ...selectedLead });
          } else {
            setSelectedLead({ ...leadList[0], messages: [] });
          }
          setActiveLeadId(leadList[0]?.id);
          setSelectedLeadID(leadList[0]?.id);
          prevStatusRef.current = uniq([...selectedQuickFilters, ...selectedStatus]);
        }
      } else if (
        !isUndefined(queryString) &&
        !isEmpty(queryString) &&
        queryString !== "remove" &&
        res?.getLeads?.count === 0
      ) {
        setAddPhoneModalVisible(true);
        if (res?.getLeads?.hasNotPermitted) {
          openDialog("leadAccessPermissionMessage", {
            dialogHeader: lang.accessPermissionMessageDialogTitle,
            onClose: handleCloseAccessDialog,
          });
        } else {
          openDialog("addLeadViaPhone", {
            dialogHeader: "Confirm Phone To Text",
            phoneNumber: queryString,
            setQueryString: setQueryString,
            openModal: openAddModal && modal && apiCheck,
            statusList: statusList,
            setModalVisible: setAddPhoneModalVisible,
            variables: variables,
            data: leadList,
            sources: sourcesData?.leadSources || [],
            user: user,
            leadFirstName: leadFirstName,
            leadLastName: leadLastName,
            userLocation: userLocation,
            handleLeadCRMName: handleLeadCRMName,
            onSetLead: (item, mode, phoneLead = "") => {
              if (phoneLead === "phoneLead") {
                const itemData = { ...item, messages: [] };
                setSelectedLead(itemData);
                page = 1;
                setMessageFilters({
                  ...messageFilters,
                  leadId: item.id,
                  lastId: lastLead,
                  page: 1,
                });
                if (mode === "new") {
                  const tempLeads = structuredClone(leadList);
                  tempLeads.unshift(itemData);
                  setLeadList(structuredClone([...tempLeads]));
                }
              } else {
                if (selectedLead?.id === item?.id) {
                  setAddPhoneModalVisible(false);
                  return;
                }

                if (sessionStorage.getItem("currentLocationId") !== item?.location?.id) {
                  localStorage.setItem("changedLocationLeadId", item?.id);
                  sessionStorage.setItem("currentLocationId", item?.location?.id);
                  dispatch(setLocationIdSlice({ locationId: item?.location?.id }));
                  closeDialog("addLeadViaPhone");
                  return;
                }

                handleLeadDetailProfile(item?.id);
                handleScrollOnMovement();
              }
            },
            onLeadStatus: LeadStatus,
            onLeadOwners: leadOwners,
            onVehicles: vehicles,
            crmIntegration: crmIntegration || crmIntegrationType,
            isFromChatbot: true,
            setSearchKey: setSearchKey,
            setVariables: setVariables,
            handleCancelBtn: handleCancel,
            eventId,
            locationName,
            entityId,
            isFromCRM: true,
            // addPhoneModal keeps its legacy prop names; source values from the
            // unified contract, gated on the CRM that owns each field.
            vinCustomerId: crmIntegrationType === CRM_TYPES.VIN_SOLUTIONS ? crmLeadId : undefined,
            vinDealerId: crmIntegrationType === CRM_TYPES.VIN_SOLUTIONS ? crmDealerId : undefined,
            refetchLeads: refetchLeads,
            siteId: crmIntegrationType === CRM_TYPES.TEKION ? crmDealerId : undefined,
            paramLeadId: crmOpportunityId,
          });
        }
        setSelectedLead({});
      }
      if (res?.getLeads?.count === 0 || leadListCount === 0) {
        setSelectedLead();
        setSelectedLeadId();
        setSelectedLeadID();
        setMessageFilters({
          ...messageFilters,
          leadId: undefined,
          page: 1,
        });
        setLeadList([]);
        setLeadCount(0);
      }
      setApiCheck(true);
    },
    onError: error => {
      console.log("err", error);
      isSkipFilter = true;
    },
  });

  const updateLeadMessagesRedux = async (laedId, messages) => {
    dispatch(addMessage({ id: laedId, messages: messages }));
  };

  const handleMediaSharing = mediaType => {
    if (mediaType === "image") {
      mediaRef.current.click();
    } else if (mediaType === "video") {
      videoRef.current.click();
    } else {
      documentRef.current.click();
    }
  };

  const resetSearch = () => {
    setSearchKey("");
    setVariables({ ...variables, page: 1, search: "" });
    setSearch("");
    setQueryString("");
    // Exit single-lead-view and clear every CRM identifier so the main
    // useQuery refetches with a clean payload (no CRM filters). Without
    // clearing *all four* CRM vars the backend stays in single-lead mode
    // and the sidebar keeps showing the previously-opened lead.
    //   - crmIntegrationType → routes the backend's per-CRM resolver
    //   - crmLeadId / crmOpportunityId → single-lead-view gate (skipFilter)
    //   - crmDealerId → CRM-specific dealer scoping
    //   - isSingleLeadView → hides the "Load All Leads" button / single-lead UI
    //   - entityId / eventId → legacy DS-shaped graphql variables
    setIsSingleLeadView(false);
    setCrmIntegrationType(null);
    setCrmLeadId(null);
    setCrmOpportunityId(null);
    setCrmDealerId(null);
    setEntityId("");
    setEventId("");
    // Inline the bits of handleLeadCRMName we still want (clear pending
    // first/last name from the AddPhone prefill) WITHOUT its trailing
    // `setSearch(localStorage.getItem("previousLeadSearchTrack"))` — that
    // line re-pollutes redux search with the stale phone right after we
    // just cleared it, leaving the search bar populated and the main
    // useQuery filtering by the previous phone instead of returning the
    // full list. Also wipe the localStorage track so no other consumer
    // (the line-665 mount effect, future handleLeadCRMName calls) can
    // resurrect it on the next render.
    setLeadFirstName("");
    setLeadLastName("");
    localStorage.removeItem("previousLeadSearchTrack");
    window.history.pushState("", "", "/browser-ext-v3/");
    window.parent.postMessage(searchKey, "*");
  };

  const handleCancel = () => {
    resetSearch();
    closeDialog("addLeadViaPhone");
    // Unified CRM routing — every CRM is served by the main useQuery now.
    // `resetSearch` clears the search/CRM state, Apollo sees the variable
    // diff and refetches. No Tekion-specific lazy refetch needed.
    //
    // VIN edge case: after a not-found AddPhonePopup cancel, Apollo's
    // automatic variable-diff refetch was leaving the sidebar empty —
    // resetSearch's setState updates hadn't flushed by the time Apollo
    // diffed, so the refetch either ran with the stale CRM-scoped vars or
    // not at all. Defer an explicit refetch to the next tick so it runs
    // after the React state updates settle and uses the cleared variables,
    // re-populating the full location-wide list.
    setTimeout(() => refetchLeads(), 0);
  };

  const handleCloseAccessDialog = () => {
    resetSearch();
    closeDialog("leadAccessPermissionMessage");
  };

  const [createMMS] = useMutation(CREATE_MMS);

  async function fetchData(files, fileType) {
    if (fileType.includes("video" || "quicktime")) {
      try {
        const response = await generateVideoThumbnails(files, 2);
        setVideoThumbnails(response[0]);
        const thumbnailUrl = await s3uploader(
          response,
          process.env.GATSBY_S3_BUCKET,
          state => {},
          true,
          sessionStorage.getItem("currentLocationId")?.includes(",")
            ? "all"
            : sessionStorage.getItem("currentLocationId"),
          user,
          selectedLead,
          null,
          true
        );
        return thumbnailUrl.url;
      } catch (e) {
        console.log("error in generateVideoThumbnails", e.message);
        return null;
      }
    }
    if (fileType.includes("image")) {
      try {
        const thumbFile = await generateImageThumbnail(files, 256);
        const uploaded = await s3uploader(
          thumbFile,
          process.env.GATSBY_S3_BUCKET,
          () => {},
          false,
          sessionStorage.getItem("currentLocationId")?.includes(",")
            ? "all"
            : sessionStorage.getItem("currentLocationId"),
          user,
          selectedLead,
          null
        );
        return uploaded?.url || null;
      } catch (e) {
        console.log("error in generateImageThumbnail", e);
        return null;
      }
    }
    return null;
  }

  const handleMediaEvent = async (e, attachments, setAttachments) => {
    const fileType = "";
    const { files } = e.target;
    const filesarr = [];
    if (e.target.files.length === 0) return;
    for (let i = 0; i < e.target.files.length; i++) {
      filesarr.push(e.target.files[i]);
    }
    if (filesarr.length > 0) {
      setAttachments([
        ...attachments,
        ...filesarr.map(item => {
          return {
            file: item,
            preview: URL.createObjectURL(item),
            generateLink: true,
          };
        }),
      ]);
    }
  };
  const [messageCount, setmessageCount] = useState(0);
  const [getMessages, { refetch: refetchMessages, loading, error, data: leadMessagesData }] =
    useLazyQuery(GET_MESSAGES_V2, {
      fetchPolicy: "network-only",
      variables: {
        ...messageFilters,
        leadId: selectedLead?.id || selectedLeadID || messageFilters?.leadId,
        campaignIds: !isEmpty(campaignFilter)
          ? campaignFilter
          : (messageFilters.campaignIds || []).map(el => parseInt(el)),
        [QUERY_VAR_TARGET_MESSAGE_ID]: targetMessageId,
      },
      onCompleted: res => {
        lastLead = res?.messagesV2?.lastId || "";
        filterApplied && setFilterLastId(lastLead);
        const messageData = (res?.messagesV2?.data || []).filter(
          item => item !== undefined && +item?.leadId === +selectedLead?.id
        );
        if (isEmpty(messageData)) {
          // CRITICAL FIX: Don't clear existing messages if we already have some loaded
          // This prevents conversation disappearing during race conditions
          if ((selectedLead?.messages || []).length === 0) {
            updateLeadMessagesRedux(selectedLead.id, []);
            return setSelectedLead({ ...selectedLead, messages: [] });
          }
          return; // Keep existing messages instead of clearing them
        }
        // setmessageCount(messageData.count);
        setmessageCount(res?.messagesV2?.count);
        let zeroIndexMsg;
        let messagePayload = messageData.map(el => {
          const findIndex = (selectedLead?.messages || []).findIndex(s => +s?.id === +el?.id);
          if (findIndex === 0) {
            zeroIndexMsg = el;
            return el;
          }
          if (findIndex === -1 && !isUndefined(el)) {
            return el;
          }
        });
        messagePayload = messagePayload?.filter(obj => obj !== null && obj !== undefined);
        if (filterApplied && messageData.length > 0 && !activeOpp.includes("#")) {
          setGlobalMessageData(prev => [...prev, ...messageData]);
        }

        let messageList;
        if (
          messageData.length > 0 &&
          messagePayload.length > 0 &&
          isEmpty(messageFilters.campaignIds)
        ) {
          if (activeOpp === "#DEFAULTOPPID") {
            messageList = selectedLead?.messages || [];

            messagePayload.map(el => {
              messageList = [...messageList, el];
            });
            const specificMsg = messageList.findIndex(msg => msg?.id === zeroIndexMsg?.id);
            if (specificMsg !== -1) {
              messageList[specificMsg] = { ...zeroIndexMsg };
            }
          } else {
            messageList = [...messageData];
          }
          const leadDetail = {
            ...selectedLead,
            messages: uniqBy(messageList, message => String(message.id)),
          };
          setSelectedLead({ ...leadDetail });
          updateLeadMessagesRedux(leadDetail?.id, leadDetail.messages);
          setChangeState(!changeState);
        } else if (messageData.length > 0 && !isEmpty(messageFilters.campaignIds)) {
          setSelectedLead({ ...selectedLead, messages: [...messageData] });
          updateLeadMessagesRedux(selectedLead?.id, messageData);
          setChangeState(!changeState);
        } else {
          // SAFETY FIX: Only clear messages if this is a legitimate empty state (new lead or filter)
          // Don't clear during race conditions when we should have messages
          if (page === 1 || (selectedLead?.messages || []).length === 0) {
            setSelectedLead({ ...selectedLead, messages: [] });
            updateLeadMessagesRedux(selectedLead?.id, []);
            setChangeState(!changeState);
          }
          // Otherwise, keep existing messages to prevent disappearing conversation
        }

        if (messageData.length === 0 && filterApplied) {
          messageList = isMsgScroll ? [] : [...globalMessageData];
          const leadDetail = {
            ...selectedLead,
            messages: uniqBy(messageList, message => String(message.id)),
          };
          // SAFETY FIX: Only update if we actually have messages to show
          if (leadDetail?.messages?.length > 0) {
            setSelectedLead({ ...leadDetail });
            updateLeadMessagesRedux(leadDetail?.id, leadDetail.messages);
            setChangeState(!changeState);
          }
          // If no messages, keep existing state to prevent disappearing conversation
        }

        // Scroll to bottom after messages are loaded (when opportunity filter changes)
        if (shouldScrollOnMessagesLoadRef.current) {
          shouldScrollOnMessagesLoadRef.current = false;
          setTimeout(() => {
            scrollToBottom("smooth");
          }, 100);
        }
      },
    });

  // Sync targetMessageId state with sessionStorage on route change (e.g., notification click
  // while already on extension page). Same pattern as engagementActivity.js.
  // - Notification click: sessionStorage has value → set state + explicitly fire messagesV2 with messageId
  // - Location dropdown switch: sessionStorage cleared → clear state → hides "View all messages" button
  useEffect(() => {
    const fromSession = sessionStorage.getItem("targetMessageId");
    if (fromSession) {
      setTargetMessageId(fromSession);
      if (selectedLead?.id) {
        getMessages({
          variables: {
            ...messageFilters,
            leadId: selectedLead?.id,
            campaignIds: (messageFilters.campaignIds || []).map(el => parseInt(el)),
            [QUERY_VAR_TARGET_MESSAGE_ID]: fromSession,
          },
        });
      }
    } else if (targetMessageId) {
      setTargetMessageId(null);
    }
  }, [routerLocation?.search, locationIdslice]);

  const [getLeadActiveAppointment, { loading: activeSpinner }] = useLazyQuery(
    GET_LEAD_ACTIVE_APPOINTMENT,
    {
      fetchPolicy: "network-only",
    }
  );

  const [getReviewInfo] = useLazyQuery(GET_SOCIAL_REVIEW_SETTINGS, {
    variables: {
      companyId: user?.company?.id,
      locationIds: [+(selectedLead?.location?.id || lead?.location?.id)],
    },
    onCompleted: res => {
      const reviewInfos = res?.getSocialReviewSettings || [];
      if (reviewInfos.length > 0) {
        setReviewInfo(reviewInfos[0]);
      }
    },
  });

  const [getAllCampaigns, { data: respCampaigns }] = useLazyQuery(GET_CAMPAIGN_LIST_FILTERS, {
    fetchPolicy: "cache-and-network",
    variables: {
      locationIds: isAllLocationSelected()
        ? null
        : [
            +(
              sessionStorage.getItem("currentLocationId") ||
              selectedLead?.location?.id ||
              lead?.location?.id
            ),
          ],
    },
    onCompleted: () => {
      dispatch(setAllCampaigns({ campaigns: respCampaigns?.getCampaigns?.data }));
    },
  });

  const [getCompanyConsentTemplateEvent] = useLazyQuery(GET_COMPANY_CONSENT, {
    variables: { companyId: user?.company?.id },
    fetchPolicy: "cache-and-network",
    onCompleted: res => {
      const consentData = res?.getCompanyConsentTemplateEvent.map(item => {
        return {
          code: item?.consentTemplateEvent?.code,
          isActive: item?.companyConsentTemplateEvent?.isActive,
          templatetext: item?.companyConsentTemplateEvent?.templateText,
        };
      });
      setConsent(consentData);
      dispatch(setCompanyConsentTemplate({ companyId: user?.company?.id, consents: consentData }));
    },
  });

  const [editLeadDetails] = useLazyQuery(EDIT_LEAD, {
    fetchPolicy: "network-only",
    onCompleted: () => {
      setOpenEditPopup(true);
    },
  });

  const [getLeadDetail, { loading: spinner }] = useLazyQuery(GET_LEAD_DETAIL_ACTIVITY_CENTER_V2, {
    fetchPolicy: "network-only",
    onCompleted: data => {
      const leadRes = data?.leadNew || null;
      if (!leadRes) return;
      // Stale-response guard: if the user has moved on to a different lead
      // since this query was fired (e.g. clicked a new CRM phone), discard
      // this late response. Without the guard, the previous lead's detail
      // arriving after the new lead is selected merges back into
      // selectedLead and the UI snaps to the wrong lead.
      const currentId = selectedLeadIdRef.current;
      if (currentId != null && +currentId !== +leadRes.id) {
        return;
      }
      setTargetLangForCustomer(leadRes?.preferredLanguageCode);
      setSelectedLead({
        ...selectedLead,
        ...leadRes,
        messages: selectedLead && +selectedLead.id === +leadRes?.id ? selectedLead?.messages : [],
      });
    },
    onError: err => {
      console.log("Error in lead query", err);
    },
  });
  const refetchLeadDetails = async () => {
    const res = await getLeadDetail({
      variables: { leadId: +selectedLead?.id },
    });
    const leadRes = res.data.leadNew;

    setSelectedLead({
      ...selectedLead,
      ...leadRes,
      messages: selectedLead && +selectedLead.id === +leadRes?.id ? selectedLead?.messages : [],
    });
  };
  const [getLeadCampaigns] = useLazyQuery(GET_CAMPAIGN_BY_LEAD, {
    fetchPolicy: "cache-and-networ",
    variables: {
      leadId: +selectedLead?.id,
    },
    skip: !selectedLead?.id,
    onCompleted: resp => {
      setLeadCampaigns(resp?.getCampaignByLead?.data || []);
    },
  });

  const [getConsentTemplate] = useLazyQuery(GET_COMPANY_CONSENT_TEMPLATES, {
    fetchPolicy: "cache-and-networ",
    onCompleted: resp => {
      if (resp?.getConsentTemplateMessage?.statusCode === 200) {
        dispatch(
          setConsentTemplateSlice({ consentTemplate: resp?.getConsentTemplateMessage?.content })
        );
        setConsentTemplate(resp?.getConsentTemplateMessage?.content || null);
      }
    },
  });

  // useEffect(() => {
  //   if (canViewTranslation && selectedLead?.id) {
  //     getTranslationSettings({
  //       variables: {
  //         leadId: selectedLead?.id,
  //       },
  //     });
  //   }
  // }, [selectedLead?.id]);

  useEffect(() => {
    const updatedRecords = (records || []).map((record, index) => {
      const recordKey = `record${index + 1}`;

      if (doNotMerge[recordKey]) {
        return {
          ...record,
          Name: { ...record.Name, disabled: true, selected: false },
          "Phone number": { ...record["Phone number"], disabled: true, selected: false },
          Address: { ...record.Address, disabled: true, selected: false },
          Location: { ...record.Location, disabled: true, selected: false },
          Owners: { ...record.Owners, disabled: true, selected: false },
          Email: { ...record.Email, disabled: true, selected: false },
          "Lead status": { ...record["Lead status"], disabled: true, selected: false },
          Source: { ...record.Source, disabled: true, selected: false },
          Vehicle: { ...record.Vehicle, disabled: true, selected: false },
        };
      } else if (Object.hasOwn(doNotMerge, recordKey)) {
        return {
          ...record,
          Name: { ...record.Name, disabled: false, selected: false },
          "Phone number": { ...record["Phone number"], disabled: false, selected: false },
          Address: { ...record.Address, disabled: false, selected: false },
          Location: { ...record.Location, disabled: false, selected: false },
          Owners: { ...record.Owners, disabled: false, selected: false },
          Email: { ...record.Email, disabled: false, selected: false },
          "Lead status": { ...record["Lead status"], disabled: false, selected: false },
          Source: { ...record.Source, disabled: false, selected: false },
          Vehicle: { ...record.Vehicle, disabled: false, selected: false },
        };
      }
      return record;
    });

    setRecords(updatedRecords);
  }, [doNotMerge]);

  useEffect(() => {
    if (isEmpty(consentTemplateFromRedux)) {
      getConsentTemplate();
    } else {
      setConsentTemplate(consentTemplateFromRedux);
    }
  }, [consentTemplateFromRedux]);

  const [callConsentMessage, setCallConsentMessage] = useState(false);
  const [messageText, setmessageText] = useState("");
  const [getLeadsById, { loading: potentialLeadLoader }] = useLazyQuery(GET_POTENTIAL_LEADS_BY_ID);

  // Tekion CRM: search via getLeadsSearch (GET_LEADS_BY_PHONE)
  const [searchTekionLeads, { loading: tekionSearchLoading }] = useLazyQuery(GET_LEADS_BY_PHONE, {
    fetchPolicy: "network-only",
    onCompleted: res => {
      const tekionLeads = res?.getLeadsSearch?.data || [];
      const tekionCount = res?.getLeadsSearch?.count || 0;

      if (process.env.NODE_ENV !== "production") {
        console.log("[Tekion Debug] Search Results:", { count: tekionCount, leads: tekionLeads });
      }

      if (tekionCount > 0) {
        const matchedLead = tekionLeads[0];
        if (process.env.NODE_ENV !== "production") {
          console.log("[Tekion Debug] Search Results Matched Lead:", matchedLead);
        }
        // 1. Populate sidebar list directly from getLeadsSearch results
        setLeadCount(tekionCount);
        setLeadList(structuredClone([...tekionLeads]));
        setSelectedLead({ ...matchedLead, messages: [] });
        page = 1;
        setMessageFilters({
          ...messageFilters,
          leadId: matchedLead?.id,
          lastId: lastLead,
          page: 1,
        });

        // 2. Enrich selectedLead with CRM-specific fields that GET_LEADS_BY_PHONE
        // doesn't fetch — most importantly tkLeadOpportunities[0].tkLeadId,
        // which OpportunityLayer needs to render "Tekion <crmId>" instead of
        // the "#EAI<id>" fallback. GET_LEAD_DETAIL_ACTIVITY_CENTER_V2 selects
        // the full set; firing it here lets the onCompleted handler merge the
        // enriched lead onto selectedLead.
        if (matchedLead?.id) {
          getLeadDetail({ variables: { leadId: +matchedLead.id } });
        }
        setAddPhoneModalVisible(false);
      } else {
        // Not found — open AddPhoneModal with pre-filled data
        setSelectedLead();
        setSelectedLeadId();
        setSelectedLeadID();
        setLeadList([]);
        setLeadCount(0);
        setAddPhoneModalVisible(true);
        openDialog("addLeadViaPhone", {
          dialogHeader: "Confirm Phone To Text",
          phoneNumber: queryString,
          setQueryString: setQueryString,
          openModal: true,
          statusList: statusList,
          setModalVisible: setAddPhoneModalVisible,
          variables: variables,
          data: [],
          sources: sourcesData?.leadSources || [],
          user: user,
          leadFirstName: leadFirstName,
          leadLastName: leadLastName,
          userLocation: userLocation,
          handleLeadCRMName: handleLeadCRMName,
          onSetLead: (item, mode, phoneLead = "") => {
            if (phoneLead === "phoneLead") {
              const itemData = { ...item, messages: [] };
              setSelectedLead(itemData);
              page = 1;
              setMessageFilters({
                ...messageFilters,
                leadId: item.id,
                lastId: lastLead,
                page: 1,
              });
              if (mode === "new") {
                const tempLeads = structuredClone(leadList);
                tempLeads.unshift(itemData);
                setLeadList(structuredClone([...tempLeads]));
              }
            } else {
              if (selectedLead?.id === item?.id) {
                setAddPhoneModalVisible(false);
                return;
              }
              if (sessionStorage.getItem("currentLocationId") !== item?.location?.id) {
                localStorage.setItem("changedLocationLeadId", item?.id);
                sessionStorage.setItem("currentLocationId", item?.location?.id);
                dispatch(setLocationIdSlice({ locationId: item?.location?.id }));
                closeDialog("addLeadViaPhone");
                return;
              }
              handleLeadDetailProfile(item?.id);
              handleScrollOnMovement();
            }
          },
          onLeadStatus: LeadStatus,
          onLeadOwners: leadOwners,
          onVehicles: vehicles,
          crmIntegration: crmIntegration || crmIntegrationType,
          isFromChatbot: true,
          setSearchKey: setSearchKey,
          setVariables: setVariables,
          handleCancelBtn: handleCancel,
          eventId,
          locationName,
          entityId,
          isFromCRM: true,
          vinCustomerId: crmIntegrationType === CRM_TYPES.VIN_SOLUTIONS ? crmLeadId : undefined,
          vinDealerId: crmIntegrationType === CRM_TYPES.VIN_SOLUTIONS ? crmDealerId : undefined,
          refetchLeads: refetchLeads,
          siteId: crmIntegrationType === CRM_TYPES.TEKION ? crmDealerId : undefined,
          paramLeadId: crmOpportunityId,
        });
      }
      // Mark Tekion search done so getLeads can now fire
      setTekionSearchDone(true);
      setApiCheck(true);
    },
    onError: error => {
      console.error("[Tekion Debug] Search Error:", error);
      // Unblock getLeads on error so the app doesn't hang
      setTekionSearchDone(true);
      setApiCheck(true);
    },
  });

  // Unified CRM routing — the auto-fire for Tekion's GET_LEADS_BY_PHONE is
  // retired for the phone-present path. Every CRM (DS / VIN / TK / EL / MF /
  // SF) flows through the main `useQuery(GET_EXTENSION_LIST_ACTIVITY_CENTER)`
  // with the four CRM variables (crmIntegrationType / crmLeadId /
  // crmOpportunityId / crmDealerId), and the backend resolves per-CRM lookup
  // strategy.
  //
  // Exception — Tekion phone-less opportunity lookup: when the extension
  // posts a crmOpportunityId with no phone, the main getLeads path returns
  // the location-wide list instead of the single matched lead (backend can't
  // narrow to a single lead by opportunityId alone). For that one scenario
  // we fall back to searchTekionLeads (GET_LEADS_BY_PHONE) which does
  // resolve the lead by crmOpportunityId and renders it as a single-lead
  // view — matching the phone-click UX.
  useEffect(() => {
    if (!isTekionCrm) return;
    if (!isEmpty(queryString)) return;
    if (!crmOpportunityId) return;
    if (!crmContextReady) return;
    const currentLocationId = sessionStorage.getItem("currentLocationId");
    if (!currentLocationId) return;
    const parsedLocationId = Number(currentLocationId);
    // When the URL doesn't carry crmDealerId, derive it from the current
    // location's Tekion franchise id. The backend's Tekion resolver needs
    // this key to scope the lead lookup — without it, getLeadsSearch returns
    // empty even when the lead exists at the current location, breaking the
    // "currentLocationId-only" entry path. If the current location isn't a
    // Tekion location, no franchise id exists; the search proceeds without
    // one and the backend returns empty, opening AddPhoneModal — the
    // correct "lead not found here" UX.
    const matchedTekionLocation = user?.locations?.find(
      loc =>
        String(loc?.location?.id) === String(currentLocationId) &&
        loc?.location?.crmIntegration?.integrationType === CRM_TYPES.TEKION
    );
    const effectiveDealerId =
      crmDealerId || matchedTekionLocation?.location?.crmIntegration?.crmFranchiseId;
    searchTekionLeads({
      variables: {
        phone: "",
        crmIntegrationType: crmIntegrationType || undefined,
        crmDealerId: effectiveDealerId || undefined,
        crmLeadId: crmLeadId || undefined,
        crmOpportunityId,
        locationId: Number.isNaN(parsedLocationId) ? undefined : parsedLocationId,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isTekionCrm,
    queryString,
    crmIntegrationType,
    crmDealerId,
    crmLeadId,
    crmOpportunityId,
    crmContextReady,
    user?.locations,
  ]);

  const [getEngagementTemplateText] = useLazyQuery(GET_CONSENT_TEMPLATE, {
    fetchPolicy: "network-only",
    onCompleted: res => {
      if (
        res.getEngagementTemplateText.statusCode === 200 &&
        res.getEngagementTemplateText.content !== "" &&
        callConsentMessage
      ) {
        onClickHandler(res.getEngagementTemplateText.content, selectedLead, user.id, true);
      }
    },
  });

  const [updateTranslationSetting] = useMutation(UPDATE_TRANSLATION_SETTINGS, {
    onCompleted: res => {
      if (res?.modifyTranslationSetting?.statusCode === 200) {
        setSelectedLead({
          ...selectedLead,
          preferredLanguageCode:
            res?.modifyTranslationSetting?.translationSetting?.customerLanguage,
        });
        setTargetLangForCustomer(
          res?.modifyTranslationSetting?.translationSetting?.customerLanguage
        );
        setTargetLangForEmployee(res?.modifyTranslationSetting?.translationSetting?.userLanguage);
        setIsAutoTranslate(
          res?.modifyTranslationSetting?.translationSetting?.isAutomaticTranslation
        );
        setIsIncludeOriginalMessage(
          res?.modifyTranslationSetting?.translationSetting?.isIncludeOriginalMessage
        );
        setIsTranslatePreviewShow(
          res?.modifyTranslationSetting?.translationSetting?.isTranslationPreview
        );
      }
    },
  });
  const [createScheduledMessage] = useMutation(CREATE_SCHEDULED_MESSAGE);
  const [createLead, { loading: createLeadLoader }] = useMutation(CREATE_LEAD);
  const [translateMessage, { loading: translateMessageLoader }] = useMutation(TRANSLATE_MESSAGE);
  const [getDetectedLanguage, { loading: getDetectedLanguageLoader }] =
    useLazyQuery(GET_DETECTED_LANGUAGE);
  const [createMessage, { loading: messageLoader }] = useMutation(CREATE_MESSAGE);
  const [broadCastUpdateUnreadCount] = useMutation(BROADCAST_UNREAD_COUNT);
  const [retryMessageSend] = useMutation(RETRY_MESSAGE_SEND);
  const [updateLeadConsent, { loading: consentLoader }] = useMutation(UPDATE_LEAD_CONSENT, {
    onCompleted: res => {
      if (res?.updateLeadConsentStatus?.ok) {
        if (process.env.NODE_ENV !== "production") {
          console.log(
            "after updating lead consent, getting lead details for selectedLead",
            selectedLead
          );
        }
        const respLead = res?.updateLeadConsentStatus?.lead || {};
        setSelectedLead({
          ...selectedLead,
          textConsentStatus: respLead?.textConsentStatus || "PENDING",
          textConsentDate: respLead?.textConsentDate || dayjs(),
        });
        getLeadDetail({
          variables: { leadId: +selectedLead?.id },
        });
      }
    },
  });
  const [updateLeadConversionStatus, { loading: updateStatusLoading }] = useMutation(
    UPDATE_LEAD_CONVERSATION_STATUS
  );
  const [updateLeadPhone, { loading: updatePhoneLoading }] = useMutation(UPDATE_LEAD_PHONE);
  const [createLeadPhone, { loading: phoneLoading }] = useMutation(CREATE_LEAD_PHONE);
  const [updateLeadEmail, { loading: updateEmailLoading }] = useMutation(UPDATE_LEAD_EMAIL);
  const [createLeadEmail, { loading: createEmailLoading }] = useMutation(CREATE_LEAD_EMAIL);

  const [updateLead] = useMutation(UPDATE_LEAD);

  const setOppDropdown = () => {
    const oppoDropdown = prepareOpportunityList(selectedLead?.leadOpportunities, crmIntegration);

    // Add "All" option at the end
    if (oppoDropdown && oppoDropdown.length > 0) {
      oppoDropdown.push({
        id: "#DEFAULTOPPID",
        name: "All",
      });
    }

    setOpportunityList(oppoDropdown || []);
  };

  useEffect(() => {
    selectedLead?.leadOpportunities?.length > 0 && setOppDropdown();
    setmmsLoader(false);
  }, [selectedLead]);

  // useEffect(() => {
  //   !isUndefined(selectedLead?.id) && getLeadDetail({ variables: { leadId: +selectedLead?.id } });
  // }, [selectedLead?.id]);

  useEffect(() => {
    if (reviewInfo && reviewInfo.isActive) {
      setShowReviewRequestButton(true);
    } else {
      setShowReviewRequestButton(false);
    }
  }, [reviewInfo]);

  useEffect(() => {
    setimplicit(
      consent.find(item => item.code === "CONSENT_MESSAGE_FOR_OPTIN_CONSENT_METHOD_OFF")?.isActive
    );
    setexplicit(
      consent.find(item => item.code === "CONSENT_MESSAGE_FOR_OPTIN_CONSENT_METHOD_ON")?.isActive
    );
    setcosentAtEnd(consent.find(item => item.code === "CONSENT_MESSAGE_FOR_MESSAGE")?.isActive);
  }, [consent]);

  // Auto-scroll only when new messages are added (not on metadata changes like note count)
  useEffect(() => {
    if ((selectedLead?.messages || []).length > 0 && page === 1) {
      // Use longer timeout to ensure DOM has fully rendered before scrolling
      setTimeout(() => {
        scrollToBottom("auto");
      }, 200);
    }
  }, [selectedLead?.messages?.length]);

  useEffect(() => {
    if (!isEmpty(selectedLead)) {
      +selectedLeadID !== +selectedLead?.id &&
        selectedLead?.id &&
        getLeadCampaigns({ variables: { leadId: +selectedLead?.id } });
      setSelectedLeadID(selectedLead?.id);
    }

    if (selectedLead?.unreadCount) {
      const selectedLeadIndex = (leadList || []).findIndex(lead => lead?.id === selectedLead?.id);
      if (selectedLeadIndex > -1) {
        const arrayFn = () => {
          const newState = structuredClone(leadList);
          newState[selectedLeadIndex] = {
            ...newState[selectedLeadIndex],
            unreadCount: 0,
          };
          return newState;
        };
        setLeadList(arrayFn());
      }
    }
  }, [selectedLead]);

  useEffect(() => {
    // if(!gotLocationId) return;
    const location = user?.locations?.filter(loc => loc?.location?.id === currentLocation);
    if (location?.length > 0) {
      setUserLocation(location[0]?.location);
    }

    if (user?.company?.id) {
      getReviewInfo();
    }
  }, [user]);

  useEffect(() => {
    const oppName = opportunityList.find(opp => +opp.id === +activeOpp);
    setActiveOppName(oppName);
    if (oppName?.id && oppName?.id[0] !== "#") {
      setMessageFilters({
        ...messageFilters,
        leadOpportunityId: +oppName?.id,
        page: 1,
        lastId: filterLastId,
      });
      setFilterApplied(true);
    } else {
      const dummyMsgFilters = {
        ...messageFilters,
        page: 1,
        lastId: filterLastId,
      };
      delete dummyMsgFilters.leadOpportunityId;
      setFilterApplied(true);
      setMessageFilters({ ...dummyMsgFilters });
    }
  }, [activeOpp]);

  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const fetchUsers = async companyId => {
    if ((userListReduxData?.users || []).length === 0) {
      getUsersByCompany({
        variables: {
          companyId: companyId,
        },
      });
    } else {
      await parseUserList(userListReduxData?.users, userIdMap, setUserIdMap);
    }
  };

  const fetchTeams = async companyId => {
    if (
      isUndefined(userListReduxData?.isUserTeamLeader) ||
      userListReduxData?.isUserTeamLeader === ""
    ) {
      getTeamsByCompany({
        variables: {
          companyId: companyId,
        },
      });
    } else {
      await setFilterStatusForTeamLeader(userListReduxData?.isUserTeamLeader);
    }
  };

  useEffect(() => {
    if (user && user?.company?.id) {
      setTargetLangForEmployee(user?.preferredLanguageCode);
      fetchTeams(user?.company.id);
      fetchUsers(user?.company.id);
    }
  }, [user]);

  const handleUnreadCount = () => {
    if (selectedLead?.messages?.length <= 3 && selectedLead?.id && leadList.length > 0) {
      msgUnreadTimeOut = setTimeout(() => {
        if (selectedLead?.message?.messageType === "APPOINTMENT" && leadList.length > 0) {
          if (
            selectedLead?.messages?.length <= 3 &&
            msgContainerRef?.current?.scrollTop === 0 &&
            !loading
          ) {
            setLeadList(prev => {
              const dummySelectedLead = { ...selectedLead };
              dummySelectedLead.unreadCount = 0;
              const selectedleadIndex = prev.findIndex(lead => lead?.id === dummySelectedLead?.id);
              const dummyLeadList = [...prev];
              dummyLeadList[selectedleadIndex] = dummySelectedLead;
              return dummyLeadList;
            });
          }
        } else {
          if (
            selectedLead?.messages?.length <= 5 &&
            msgContainerRef?.current?.scrollTop === 0 &&
            !loading &&
            leadList.length > 0
          ) {
            setLeadList(prev => {
              const dummySelectedLead = { ...selectedLead };
              dummySelectedLead.unreadCount = 0;
              const selectedleadIndex = prev.findIndex(lead => lead?.id === dummySelectedLead?.id);
              const dummyLeadList = [...prev];
              dummyLeadList[selectedleadIndex] = dummySelectedLead;
              return dummyLeadList;
            });
          }
        }
      }, 2500);
    }
  };

  const handleEditLead = lead => {
    editLeadDetails({
      variables: { leadId: lead.id },
    });
  };

  const updateDimensions = () => {
    setShowLeadSection(window.innerWidth > 1024);
    setCallLeadDetailAPI(window.innerWidth > 1024);
    setShowProfileSection(window.innerWidth > 1024);
  };

  // Chat scrolling behavior: anchor-based restoration and conditional autoscroll
  const { scrollToBottom: scrollToBottomHook, onLoadOlderStart } = useChatScroll({
    containerRef: msgContainerRef,
    items: selectedLead?.messages || [],
    resetDeps: [selectedLead?.id],
    bottomThreshold: 80,
    initialScroll: true,
    anchorSelector: `.${MESSAGE_CONTAINER_CLASSNAME}`,
  });

  const onMsgScroll = () => {
    // const scrollTop = filterApplied
    //   ? msgContainerRef.current.scrollTop + 10
    //   : msgContainerRef.current.scrollTop;
    // scrollTop === 10 ? setFilterApplied(true) : setFilterApplied(false);
    // scrollTop === 10 && setIsMsgScroll(true);
    // setFilterApplied(false);
    const { scrollTop } = msgContainerRef.current;
    // Ensure the previously requested page has actually been committed to state.
    // Apollo flips `loading` to false before onCompleted runs, so without this
    // check a scroll in that tiny window could fire an extra page (e.g. page 3
    // when only 2 pages exist). If messages.length hasn't caught up to the last
    // requested page, skip — state will settle on the next render.
    // const expectedCommittedMessages = Math.min(
    //   (+messageFilters?.page || 1) * pageSize,
    //   messageCount
    // );
    if (
      selectedLead?.messages?.length < messageCount &&
      // selectedLead?.messages?.length >= expectedCommittedMessages &&
      scrollTop <= 2 && // ✅ Allow small margin instead of exact 0 to prevent rapid firing
      !isEmpty(selectedLead?.messages) &&
      !loading &&
      !targetMessageId // prevent pagination when searching for a specific message (Right now its only for internal note messages functionality)
    ) {
      // page = filterApplied ? 1 : page + 1;
      // setScrollBottom(scrollTop);
      page =
        selectedLead?.messages?.length > pageSize - 1 ? (+messageFilters?.page || page) + 1 : page;
      // Notify hook to capture anchor before older messages prepend
      onLoadOlderStart();
      setMessageFilters({
        ...messageFilters,
        leadId: selectedLead?.id,
        lastId: filterApplied ? filterLastId : lastLead,
        page: page,
      });
    }
    timeReference = setTimeout(() => {
      if (selectedLead?.id && leadList?.length) {
        // TODO : come here for final code review
        // setLeadList(prev => {
        //   const dummySelectedLead = { ...selectedLead };
        //   dummySelectedLead.unreadCount = 0;
        //   const selectedleadIndex =
        //     leadList?.length > 0 &&
        //     leadList.findIndex(lead => +lead?.id === +dummySelectedLead?.id);
        //   const dummyLeadList = [...leadList];
        //   dummyLeadList[selectedleadIndex] = dummySelectedLead;
        //   return dummyLeadList;
        // });
      }
    }, 1000);
  };
  // console.log("selectedLead?.messages?.length===>", selectedLead?.messages?.length);
  useEffect(() => {
    // Old scroll-into-view logic removed; preserved by useChatScroll anchoring
  }, [selectedLead]);

  const handleWheel = event => {
    try {
      if (event.deltaY < 0) {
        // Mouse wheel scrolled upward
        // Your code here
        const scrollTop = filterApplied
          ? msgContainerRef.current.scrollTop + 10
          : msgContainerRef.current.scrollTop;
        const topPosition = filterApplied ? 10 : 0;
        if (scrollTop === topPosition && !loading && selectedLead.messages.length < messageCount) {
          page = selectedLead?.messages?.length > pageSize - 1 ? page + 1 : page;
          setMessageFilters({
            ...messageFilters,
            leadId: selectedLead?.id,
            lastId: filterApplied ? filterLastId : lastLead,
            page: page,
          });
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  let startY = 0;

  const handleTouchStart = event => {
    // Store the initial touch position
    startY = event.touches[0].clientY;
  };

  const handleTouchMove = event => {
    const currentY = event.touches[0].clientY;
    const deltaY = currentY - startY;
    // Check if the swipe is upwards and larger than a certain threshold (e.g., 50 pixels)
    if (deltaY > 100) {
      // Add your code here for handling the swipe up event
      const scrollTop = filterApplied
        ? msgContainerRef.current.scrollTop + 10
        : msgContainerRef.current.scrollTop;
      const topPosition = filterApplied ? 10 : 0;
      if (scrollTop === topPosition && !loading && selectedLead.messages.length < messageCount) {
        page = selectedLead?.messages?.length > pageSize - 1 ? page + 1 : page;
        setMessageFilters({
          ...messageFilters,
          leadId: selectedLead?.id,
          lastId: filterApplied ? filterLastId : lastLead,
          page: page,
        });
      }
    }
  };

  const fetchLeadData = () => {
    // Allow fetching if selectedLead.id exists OR leadList has items
    // This fixes race condition where selectedLead is set before leadList is populated
    if (leadList.length > 0 || selectedLead?.id) {
      // Check if this is a lead change (not just pagination)
      const isLeadChange = +selectedLead?.id !== +selectedLeadID;
      const isInitialLoad = isEmpty(prevStateData);

      // Check if messageFilters changed for reasons OTHER than pagination
      // Page changes should ONLY trigger getMessages, not getLeadDetail/getScheduleMessages
      const isFilterChange =
        prevStateData &&
        prevStateData.messageFilters !== messageFilters &&
        prevStateData.messageFilters?.page === messageFilters?.page; // Same page = filter changed

      if (isLeadChange || isInitialLoad || isFilterChange) {
        // Fetch messages for all cases
        getMessages({
          variables: {
            ...messageFilters,
            leadId: selectedLead?.id || selectedLeadID,
            campaignIds: (messageFilters?.campaignIds || []).map(el => parseInt(el)),
          },
        });

        // Only call these APIs if lead actually changed or it's initial load
        // NOT on pagination (scroll up)
        if (isLeadChange || isInitialLoad) {
          getScheduleMessagesForLead({
            variables: {
              leadId: selectedLead?.id || selectedLeadID,
            },
          });
          getLeadDetail({
            variables: {
              leadId: +(selectedLead?.id || selectedLeadID),
            },
          });
        }
      } else if (prevStateData && prevStateData.messageFilters?.page !== messageFilters?.page) {
        // Page changed (scroll up/down) - ONLY fetch messages
        getMessages({
          variables: {
            ...messageFilters,
            leadId: selectedLead?.id || selectedLeadID,
            campaignIds: (messageFilters?.campaignIds || []).map(el => parseInt(el)),
          },
        });
      }
    }
  };

  // useEffect ensures side effects run reliably on every dependency change
  // (useMemo may be skipped by React for performance optimization)
  useEffect(() => {
    if (selectedLead?.id) {
      fetchLeadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLead?.id, messageFilters]);

  const checkLocation = locationId => {
    let locations = [];
    if (sessionStorage.getItem("currentLocationId")?.includes(",")) {
      locations = sessionStorage
        .getItem("currentLocationId")
        .split(",")
        .map(loc => +loc);
    } else {
      locations = [+sessionStorage.getItem("currentLocationId")];
    }
    return locations.includes(+locationId);
  };

  const updateLeftLeadList = async lead => {
    let updatedLead = { ...lead };
    const newList = structuredClone(leadList);
    console.log(
      "Extension >>>>>>>>>>>> TEST LEAD NOT IN FOUND CASE refresh updatedLead===>",
      updatedLead
    );
    if (!isUndefined(updatedLead?.id)) {
      const notificationMessage = (notificationData?.lead_messages || []).find(
        el => +el.lead_id === +updatedLead.id
      );
      if (notificationMessage) {
        updatedLead = {
          ...updatedLead,
          messages: [
            {
              id: notificationMessage?.id,
              content: notificationMessage?.content || "",
              dateReceived: notificationMessage?.date_received,
              dateSent: notificationMessage?.date_sent,
              direction: notificationMessage?.direction,
            },
          ],
        };
      }
      if (notificationData?.active_appointment) {
        updatedLead = {
          ...updatedLead,
          activeAppointment: {
            id: notificationData?.active_appointment?.id,
            startDatetime: notificationData?.active_appointment?.start_datetime,
            isConfirmed: notificationData?.active_appointment?.is_confirmed,
            appointmentStatus: notificationData?.active_appointment?.appointment_status,
            summary: notificationData?.active_appointment?.summary || "",
            description: notificationData?.active_appointment?.description || "",
          },
        };
      }
      // console.log("TEST LEAD NOT IN FOUND CASE newList===>", newList);
      newList.unshift(updatedLead);
      if (newList.length > variables.pageSize) {
        newList.splice(newList.length - 1, 1);
      }
      setLeadList(newList);
    }
  };

  useEffect(() => {
    if (notificationData) {
      const prevValue = text?.current?.value || "";
      const isNotificationLeadExistInLocation = checkLocation(notificationData?.location_id);
      // console.log(
      //   "TEST notificationData isNotificationLeadExistInLocation===>",
      //   isNotificationLeadExistInLocation
      // );
      if (!isNotificationLeadExistInLocation) {
        return;
      }
      if (notificationData.refresh) {
        if (notificationData?.lead_id) {
          const newList = structuredClone(leadList);
          const findIndex = newList.findIndex(el => +el.id === +notificationData?.lead_id);
          if (findIndex > -1) {
            let existingLead = newList[findIndex];
            const notificationMessage = (notificationData?.lead_messages || []).find(
              el => +el.lead_id === +existingLead.id
            );
            existingLead = {
              ...existingLead,
              unreadCount: (existingLead?.unreadCount || 0) + 1,
              messages: [
                {
                  id: notificationMessage?.id,
                  content: notificationMessage?.content || "",
                  dateReceived: notificationMessage?.date_received,
                  dateSent: notificationMessage?.date_sent,
                  direction: notificationMessage?.direction,
                },
              ],
            };
            if (notificationData?.active_appointment) {
              existingLead = {
                ...existingLead,
                activeAppointment: {
                  id: notificationData?.active_appointment?.id,
                  startDatetime: notificationData?.active_appointment?.start_datetime,
                  isConfirmed: notificationData?.active_appointment?.is_confirmed,
                  appointmentStatus: notificationData?.active_appointment?.appointment_status,
                  summary: notificationData?.active_appointment?.summary || "",
                  description: notificationData?.active_appointment?.description || "",
                },
              };
            }
            if (
              +notificationData?.lead_id === +selectedLead?.id &&
              +notificationData?.user_id === +user?.id
            ) {
              existingLead = {
                ...existingLead,
                unreadCount: 0,
              };
            }
            newList.splice(findIndex, 1);
            newList.unshift(existingLead);
            setLeadList(newList);
          } else {
            // Unified CRM routing — lead not found in existing list, fetch it
            // via the main getLeads (works for every CRM after the unified
            // refactor) and prepend to list.
            setRefetching(true);
            // EAI-1200 diagnostic: refetch window opens. Any main getLeads
            // response landing while this is true will be SKIPPED — pair this
            // with the SKIPPED warn to confirm the race fired. Safe: only ids.
            console.log("[refetch] start", {
              notificationLeadId: notificationData?.lead_id ?? null,
            });
            console.log("Extension >>>>>>>>>>>> TEST LEAD NOT IN FOUND CASE refresh");
            refreshLeadList({
              variables: {
                ...variables,
                search: !isEmpty(search) ? search.trim() : "",
                status: isEmpty(search) ? uniq([...selectedQuickFilters, ...selectedStatus]) : [],
                campaignIds:
                  isEmpty(search) && !isEmpty(variables?.campaignIds)
                    ? variables?.campaignIds?.map(el => parseInt(el))
                    : [],
                excludeDuplicate: true,
                userIds:
                  isEmpty(search) && !isEmpty(variables?.userFilters) ? [...userFilters] : [],
                prioritySortOrder: leadSort,
                skipFilter: !isEmpty(search),
                leadId: notificationData?.lead_id,
              },
            })
              .then(res => {
                const getLeadsData = res?.getLeads?.data || res?.data?.getLeads?.data || [];
                // console.log("refreshLeadList getLeadsData ===============>", getLeadsData);
                if (getLeadsData.length > 0) {
                  updateLeftLeadList(getLeadsData[0]);
                }
              })
              .catch(err => {
                console.error("refreshLeadList failed:", err);
              })
              .finally(() => {
                // Always clear the flag — if the promise rejects (network
                // failure in prod), leaving it true would permanently block
                // subsequent getLeads onCompleted handlers from rendering new
                // data (e.g. search results get silently discarded).
                setRefetching(false);
                // EAI-1200 diagnostic: refetch window closes. Responses
                // landing after this are no longer SKIPPED.
                console.log("[refetch] end");
              });
          }
        }
      }

      if (+notificationData?.lead_id === +selectedLead?.id) {
        broadCastUpdateUnreadCount({
          variables: {
            leadId: selectedLead?.id,
          },
        });
      }

      // if (notificationData?.lead_messages?.length > 0) {
      //   const msgContent = notificationData?.lead_messages[0]?.content?.toLowerCase();
      //   if (msgContent === "c" || msgContent === "r" || msgContent === "d") {
      //     // appointlabel was not being changed on lead list (left section)
      //     refetchLeads();
      //   }
      // }

      // Helper function to transform notification to message object
      const transformNotificationToMessage = (notification, options = {}) => {
        const { messageLogAsArray = false, userOverride = null } = options;

        const messageLogData = {
          id: notification?.message_log?.id,
          messageId: notification?.message_log?.message_id,
          toPhone: notification?.message_log?.to_phone,
          fromPhone: notification?.message_log?.from_phone,
        };

        const userData =
          userOverride ||
          (notification?.user
            ? {
                firstName: notification?.user?.first_name,
                lastName: notification?.user?.last_name,
                fullName: notification?.user?.full_name,
                profilePic: notification?.user?.profile_pic,
              }
            : undefined);

        return {
          id: `${notification?.id}`,
          campaignId: notification?.campaign_id,
          content: notification?.content,
          translatedContent: notification?.translated_content,
          dateReceived: notification?.date_received,
          dateSent: notification?.date_sent,
          direction: notification?.direction,
          leadId: notification?.lead_id,
          userId: notification?.user_id,
          ...(userData && { user: userData }),
          systemUserId: notification?.system_user_id,
          messageType: notification?.message_type || "",
          messageStatus: notification?.message_status || "",
          statusCode: notification?.status_code || "",
          errorCode: notification?.error_code || "",
          errorMessage: notification?.error_message || "",
          messageLog: messageLogAsArray ? [messageLogData] : messageLogData,
          mmsObjects: (notification?.mms_objects || [])?.map(item => ({
            id: item.id,
            mediaType: item.media_type,
            mediaUrl: item?.media_url || item?.url,
            thumbnailUrl:
              item?.thumbnail && !isEmpty(item?.thumbnail)
                ? item?.thumbnail
                : item?.media_url || item?.url,
            size: item.size,
          })),
          leadOpportunity: { ...notification?.lead_opportunity },
          contentType: notification?.content_type,
          email: notification.email,
        };
      };

      // Update selected lead with all notification messages
      if (+notificationData?.lead_id === +selectedLead?.id) {
        const notificationMessages = notificationData?.lead_messages || [];

        if (notificationMessages.length > 0) {
          const newMessages = [];

          notificationMessages.forEach(notification => {
            if (HIDDEN_MESSAGE_CONTENT_TYPES.includes(notification?.content_type)) {
              return;
            }
            const messageExists = (selectedLead?.messages || []).some(
              msg => +msg?.id === +notification?.id
            );

            if (!messageExists) {
              const newMessage = transformNotificationToMessage(notification, {
                messageLogAsArray: true,
              });
              newMessages.push(newMessage);
            }
          });

          if (newMessages.length > 0) {
            const newObj = {
              ...selectedLead,
              messages: [...selectedLead.messages, ...newMessages],
              ...(notificationData?.text_consent_status
                ? { textConsentStatus: notificationData?.text_consent_status }
                : {}),
            };

            if (!selectedLead?.textConsentStatus) {
              getLeadDetail({ variables: { leadId: selectedLead?.id } });
            }

            setSelectedLead(newObj);
            updateLeadMessagesRedux(selectedLead?.id, newObj.messages);

            if (text?.current) {
              setTimeout(() => {
                text.current.value = prevValue;
                text.current.focus();
                text.current.style.height = "inherit";
                text.current.style.height = `${text.current.scrollHeight}px`;
              }, 50);
            }
          }
        }
      }

      // Push to Leads list in Redux
      if (notificationData?.lead_messages?.length > 0) {
        notificationData.lead_messages.forEach(notification => {
          const newMessage = transformNotificationToMessage(notification, {
            userOverride: {
              id: user?.id,
              firstName: user?.firstName,
              lastName: user?.lastName,
            },
          });
          dispatch(addMessage({ id: newMessage.leadId, message: newMessage }));
        });
      }
      // if (notificationData?.text_consent_status) {
      //   // setSelectedLead(prev => {
      //   //   const clone = structuredClone(prev);
      //   //   clone.textConsentStatus = notificationData?.text_consent_status;
      //   //   return clone;
      //   // });
      // }
    }
  }, [notificationData]);

  const onClickHandler = (content, lead, userId, button = false) => {
    // const match = content.match(/{([^}]+)}/);
    // if (match) {
    //   message.error(lang.fillValueBeforeSend);
    //   return;
    // }

    // Capture current isReview state and reset immediately
    const currentIsReview = isReview;
    if (currentIsReview) {
      setisReview(false);
    }

    if (!isEmpty(content) && !isEmpty(lead)) {
      if (!isEmpty(lead?.phoneNumbers)) {
        let messagePayload = {
          leadId: +lead?.id,
          userId: userId,
          direction: "TO_LEAD",
          content: content,
          reviewLink: content.includes("{ratingLink}") ? "TBD" : "",
          toPhone: getLeadToPhone(lead),
          dateSent: dayjs().toISOString(),
          ...(currentIsReview
            ? { messageType: "REVIEW", contentType: MESSAGE_CONTENT_TYPES.REVIEW_REQUEST_SENT }
            : {}),
          user: {
            id: user.id,
            firstName: user.firstName,
            lastName: user.lastName,
          },
          aiResponseHistoryId: textAiResponseHistoryId ?? null,
        };

        messagePayload.leadOpportunityId = resolveLeadOpportunityId(messageOpportunity);
        const messageLog = {
          toPhone: lead?.phoneNumbers[0]?.phone,
        };
        let selectedLeadDetails = {
          ...selectedLead,
          textConsentStatus: lead?.textConsentStatus || selectedLead?.textConsentStatus,
        };
        if ((selectedLead?.messages || []).length <= 0) {
          selectedLeadDetails = { ...selectedLeadDetails, messages: [] };
        }
        const temp = structuredClone(selectedLeadDetails);
        if (!currentIsReview) {
          temp.messages.push({
            ...messagePayload,
            type: "new",
          });
        }
        selectedLeadDetails = structuredClone(temp);
        selectedLeadDetails = {
          ...selectedLeadDetails,
          messages: selectedLeadDetails.messages.filter(item => item !== undefined),
        };
        page = 1;
        // setSelectedLead(selectedLeadDetails);
        if (eventId) {
          messagePayload = { ...messagePayload, dsEventId: eventId };
        } else {
          delete messagePayload.dsEventId;
        }
        createMessage({
          variables: {
            ...messagePayload,
          },
        }).then(res => {
          if (text.current) {
            setmessageText("");
            setTimeout(() => {
              textMode === 0 ? (text.current.value = "") : setrichTextValue("");
              text.current.value = "";
              text.current.style.height = "0px";
              text.current.placeholder = placeholder();
            }, 500);
          }

          setCallConsentMessage(false);
          if (res?.data?.createMessage?.statusCode === 202) {
            // Phase 3a (lambda cutover): leave optimistic bubble queued.
            // SocketIO sent_message will replace it via replaceQueuedMessage.
            dispatch(
              addMessage({ id: selectedLead.id, messages: { ...messagePayload, type: "queued" } })
            );
            const leadInfo = structuredClone({ ...selectedLeadDetails });
            if (!currentIsReview) {
              const findIndex = leadInfo.messages.findIndex(el => el?.type === "new");
              if (findIndex > -1) {
                leadInfo.messages[findIndex] = {
                  ...leadInfo.messages[findIndex],
                  type: "queued",
                };
              }
            }
            setSelectedLead({ ...leadInfo });
            setChangeState(!changeState);
            setbtnClicked(true);
            dispatch(setTextAiResponseHistoryId(null));
          } else if (res?.data?.createMessage?.statusCode === 200) {
            const selectedLeadIndex = (leadList || []).findIndex(
              lead => lead?.id === selectedLead?.id
            );
            if (selectedLeadIndex > -1) {
              const arrayFn = () => {
                const newState = structuredClone(leadList);
                newState[selectedLeadIndex] = {
                  ...newState[selectedLeadIndex],
                  unreadCount: 0,
                };
                return newState;
              };
              setLeadList(arrayFn());
            }
            dispatch(
              addMessage({ id: selectedLead.id, messages: { ...messagePayload, type: "new" } })
            );
            if (
              !isConsentStatusEnable(
                selectedLead?.textConsentStatus,
                user?.company?.isOptinConsentMethod
              )
            ) {
              updateLeadConsent({
                variables: { leadId: selectedLead?.id },
              });
            }

            const resMessage = res?.data?.createMessage?.leadMessage || {};
            const leadInfo = structuredClone({ ...selectedLeadDetails });
            if (!currentIsReview) {
              const findIndex = leadInfo.messages.findIndex(el => el?.type === "new");
              if (findIndex > -1) {
                leadInfo.messages[findIndex] = {
                  ...resMessage,
                  leadOpportunity: resMessage?.leadOpportunity || { name: "", id: "" },
                };
              }
            } else {
              leadInfo.messages.push(resMessage);
            }
            setSelectedLead({ ...leadInfo });
            setChangeState(!changeState);
            setbtnClicked(true);
            dispatch(setTextAiResponseHistoryId(null));
          } else {
            message.error(res?.data?.createMessage?.message || lang.msgSendFail);
            const leadInfo = { ...selectedLeadDetails };
            const findIndex = leadInfo.messages.findIndex(el => el?.type === "new");
            if (findIndex > -1) {
              leadInfo.messages[findIndex].type = "error";
            }
            setSelectedLead({ ...leadInfo });
            setChangeState(!changeState);
            // Restore isReview state if message failed to send
            if (currentIsReview) {
              setisReview(true);
            }
          }
        });
      } else {
        message.error("No phone number registered for this lead");
      }
    }
    if (!selectedLead?.textConsentStatus) {
      getLeadDetail({ variables: { leadId: selectedLead?.id } });
    }
  };

  const handleRetry = (e, c) => {
    if (c?.id) {
      const leadDetail = structuredClone(selectedLead);
      const findIndex = leadDetail.messages.findIndex(el => +el?.id === +c?.id);
      if (findIndex > -1) {
        leadDetail.messages[findIndex] = {
          ...leadDetail.messages[findIndex],
          type: "new",
          messageStatus: "",
        };
        setSelectedLead({ ...leadDetail });
      }
      retryMessageSend({
        variables: {
          messageId: c.id,
        },
      }).then(resp => {
        if (resp?.data?.retryMessage?.statusCode === 200) {
          getMessages();
        } else {
          message.error(resp?.data?.retryMessage?.message);
        }
      });
    }
  };

  const onClickReviewHandler = (content, reviewLink, lead, userId) => {
    if (!isEmpty(content)) {
      let messagePayload = {
        leadId: lead?.id,
        userId: userId,
        direction: "TO_LEAD",
        content: content,
        toPhone: getLeadToPhone(lead),
        reviewLink,
        aiResponseHistoryId: textAiResponseHistoryId ?? null,
        leadOpportunityId: resolveLeadOpportunityId(messageOpportunity),
      };
      let selectedLeadDetails = {
        ...selectedLead,
        textConsentStatus: lead?.textConsentStatus || selectedLead?.textConsentStatus,
      };
      if ((selectedLead?.messages || []).length <= 0) {
        selectedLeadDetails = { ...selectedLeadDetails, messages: [] };
      }

      page = 1;
      setSelectedLead(selectedLeadDetails);
      text.current.value = "";
      if (eventId) {
        messagePayload = { ...messagePayload, dsEventId: eventId };
      } else {
        delete messagePayload.dsEventId;
      }
      createMessage({
        variables: {
          ...messagePayload,
        },
      }).then(res => {
        if (res?.data?.createMessage?.statusCode === 200) {
          const selectedLeadIndex = (leadList || []).findIndex(
            lead => lead?.id === selectedLead?.id
          );
          if (selectedLeadIndex > -1) {
            const arrayFn = () => {
              const newState = structuredClone(leadList);
              newState[selectedLeadIndex] = {
                ...newState[selectedLeadIndex],
                unreadCount: 0,
              };
              return newState;
            };
            setLeadList(arrayFn());
          }
          const resMessage = res?.data?.createMessage?.leadMessage || {};
          messagePayload.content = resMessage?.content;
          selectedLeadDetails.messages.push({
            ...messagePayload,
            type: "new",
          });
          setSelectedLead(selectedLeadDetails);
          const leadDetails = structuredClone({ ...selectedLeadDetails });
          const findIndex = leadDetails.messages.findIndex(el => el?.type === "new");
          if (findIndex > -1) {
            leadDetails.messages[findIndex] = { ...resMessage };
            // leadDetails.messages[findIndex].type = "";
            // leadDetails.messages[findIndex].id = resMessage?.id;
            // leadDetails.messages[findIndex].dateSent = resMessage?.dateSent;
            // leadDetails.messages[findIndex].messageStatus = resMessage?.messageStatus;
            // leadDetails.messages[findIndex].messageType = resMessage?.messageType;
            // leadDetails.messages[findIndex].errorMessage = resMessage?.errorMessage;
            // leadDetails.messages[findIndex].errorCode = resMessage?.errorCode;
            // leadDetails.messages[findIndex].leadOpportunity = resMessage?.leadOpportunity ||
            //   resMessage?.lead_opportunity || { name: "", id: "" };
          }
          setSelectedLead({ ...leadDetails });
          updateLeadMessagesRedux(leadDetails?.id, leadDetails?.messages);
          setChangeState(!changeState);
          dispatch(setTextAiResponseHistoryId(null));
        } else {
          message.error(res?.data?.createMessage?.message);
        }
      });
    }
  };

  const SetContentBy = item => {
    return item?.content || "";
  };

  const handleLogoClick = () => {
    let url = `${window.location.origin}/engagements/activity-center`;
    const loc =
      location2?.length > 0
        ? sessionStorage.getItem("currentLocationId")?.includes(",")
          ? "all"
          : locationIdslice || userLocation?.id
        : "";
    // We're in a CRM-initiated iframe context when the unified contract's
    // `crmIntegrationType` marker is present in the URL.
    if (window.location.search.includes("crmIntegrationType")) {
      window.open(
        `${
          window.location.origin
        }/engagements/activity-center${selectedLead?.phoneNumbers[0]?.phone.slice(2)}${
          window.location.search
        }}`,
        "_blank"
      );
    } else {
      if (selectedLead?.phoneNumbers?.length > 0) {
        url = `${url}/${selectedLead?.phoneNumbers[0]?.phone.slice(2)}?loc=${loc}`;
      } else {
        url =
          !isUndefined(queryString) && !isEmpty(queryString)
            ? `${url}/${queryString}?loc${loc}`
            : `${url}?loc=${loc}`;
      }
      window.open(url, "_blank");
    }
  };

  const handleOpportunityId = selectedLead =>
    getOpprDetails({ opportunity: selectedLead?.leadOpportunity }).label;

  // Ref always holds the latest selectedLead so callbacks captured into imperative
  // dialog payloads (openDialog) can read the live value instead of a stale closure.
  const selectedLeadRef = useRef(selectedLead);
  useEffect(() => {
    selectedLeadRef.current = selectedLead;
    selectedLeadIdRef.current = selectedLead?.id ?? null;
  }, [selectedLead]);

  // Avoids re-pinning the lead after appointment save by skipping the leads-list refetch.
  // Instead, merges the new appointment into the leads list so the calendar label updates,
  // and (only if the appointment is for the currently open lead) updates selectedLead and
  // refetches its messages. The appointmentLeadId arg is passed from appointmentForm to
  // sidestep stale-closure issues where selectedLead may have changed since this dialog
  // was opened (e.g. user clicked the calendar icon on a non-selected lead).
  const refetchAfterAppointmentSave = (appointment, appointmentLeadId) => {
    const liveSelectedLead = selectedLeadRef.current;
    const leadId = appointmentLeadId || liveSelectedLead?.id;
    if (!leadId) return;

    if (appointment) {
      dispatch(
        updateLeadInList({
          id: leadId,
          activeAppointment: appointment,
        })
      );

      if (+leadId === +liveSelectedLead?.id) {
        dispatch(
          setSelectedLeadRedux({
            ...liveSelectedLead,
            activeAppointment: appointment,
          })
        );
      }
    }

    if (+leadId === +liveSelectedLead?.id) {
      getMessages({
        variables: {
          ...messageFilters,
          leadId: liveSelectedLead.id,
          page: 1,
        },
      });
    }
  };

  const handleAppointmentModalClose = async (event, lead, isAPINeedTocall = false) => {
    event && event.stopPropagation && event.stopPropagation();
    setAppointmentLead({});
    try {
      let appointmentDetails;
      if (isAPINeedTocall) {
        // appointmentDetails = await getLeadActiveAppointment({
        //   variables: { leadId: lead?.id },
        // });
        setAppointmentPopupVisible(!openAppointmentPopup);
        setAppointmentLead(prev => {
          const newState = { ...prev, ...appointmentDetails?.data?.lead };
          !isAPINeedTocall && setAppointmentPopupVisible(!openAppointmentPopup);
          openDialog("appointmentForm", {
            dialogHeader:
              lead?.activeAppointment?.appointmentStatus === "CANCELLED"
                ? lang.appointmentCancelled
                : lang.editAppointment,
            lead: lead,
            visibleModal: openAppointmentPopup,
            appointment: lead?.activeAppointment,
            defaultDate: null,
            eventId: eventId,
            isFromCard: true,
            refetchLeads: refetchAfterAppointmentSave,
            refreshLeadListData: refetchAfterAppointmentSave,
            setAppointmentModelVisible: handleAppointmentModalClose,
            leadOpportunities: lead?.leadOpportunities,
            redirect: async (e, updateDate, needToRedirect = true, leadId, isClickOnName) => {
              // Read live selectedLead via ref — this redirect is captured into the
              // appointmentForm dialog payload, so closure values can be stale.
              const liveSelectedLeadId = selectedLeadRef.current?.id;
              if (+liveSelectedLeadId === +leadId && isClickOnName) {
                closeDialog("appointmentForm");
                return;
              }
              // Any branch that calls handleLeadDetailProfile writes to localStorage
              // ("clickLeadId"), which the parent useEffect picks up and uses to
              // refetch lead detail + unshift the lead into the leads list — i.e.
              // pins it to the top.
              // For a save-and-close flow, selectedLead is already the saved lead
              // (set when the user clicked the card / calendar label that opened
              // this dialog), and the lead's data was already updated in the list
              // via refetchAfterAppointmentSave. So skip the cascade entirely.
              if (leadId) {
                return;
              }
              if (isEmpty(appintmentLead) && e) {
                // tabContext.setActiveTab("activity-center")
              } else {
                // setIsMsgApi(true);
                handleLeadDetailProfile(liveSelectedLeadId);
                handleScrollOnMovement();
                setShowLeadSection(false);
                setIsAppointmentChangeFromLead(prev => !prev);
              }
            },
          });
          return newState;
        });
        setAppointmentPopupVisible(!openAppointmentPopup);
      }
    } catch (err) {
      console.log("Error in getLeadActiveAppointment", err);
    }
  };

  const handleSetDefinedTemplate = msg => {
    text.current.value = msg;
    textMode === 0 ? (text.current.value = msg) : setrichTextValue(richTextValue + msg);
    // setmessageText(msg);
  };

  const updateLoading =
    updatePhoneLoading || phoneLoading || updateEmailLoading || createEmailLoading;

  const handleActiveToggle = async e => {
    await updateLeadConversionStatus({
      variables: { leadId: selectedLead?.id, disableConversation: !e },
    }).then(resp => {
      if (resp?.data?.enableDisableLeadConversation?.statusCode === 200) {
        const respLead = resp?.data?.enableDisableLeadConversation?.lead || {};
        setSelectedLead({
          ...selectedLead,
          ...(selectedLead.conversationStatus
            ? { conversationStatus: !e }
            : { conversationStatus: respLead.conversationStatus || {} }),
        });
        const arrayFn = () => {
          const newState = structuredClone(leadList);
          const findIndex = newState.findIndex(el => +el.id === +selectedLead?.id);
          if (findIndex > -1) {
            if (newState[findIndex].conversationStatus) {
              newState[findIndex].conversationStatus.disableConversation = !e;
            } else {
              newState[findIndex] = {
                ...newState[findIndex],
                conversationStatus: respLead?.conversationStatus || {},
              };
            }
          }
          return newState;
        };
        setLeadList(arrayFn());
        message.success(`The Lead auto message feature has been updated successfully`);
      }
    });
  };

  const handleStatusFilter = status => {
    setSelectedStatus(status);
    setFilterApplied(true);
    setVariables({ ...variables, page: 1, status });
    // Unified CRM routing — variable change triggers main useQuery refetch
    // for every CRM. No Tekion-specific lazy refetch needed.
  };

  let concentTime;

  const sendContentMessage = async () => {
    let content =
      consentTemplate ||
      `${user?.company?.name || "The dealer"} wants to message you. Reply STOP to opt out.`;
    if (user?.company?.isOptinConsentMethod) {
      content = `${
        user?.company?.name || "The dealer"
      } wants to message you. Reply YES to opt in, or STOP to opt out.`;
    }
    await updateLeadConsent({ variables: { leadId: selectedLead?.id } })
      .then(resp => {
        if (resp?.data?.updateLeadConsentStatus?.ok) {
          const respLead = resp?.data?.updateLeadConsentStatus?.lead || {};
          setSelectedLead({
            ...selectedLead,
            textConsentStatus: respLead?.textConsentStatus || "PENDING",
            textConsentDate: respLead?.textConsentDate || dayjs(),
          });
          const arrayFn = () => {
            const newState = structuredClone(leadList);
            const findIndex = newState.findIndex(el => +el.id === +selectedLead?.id);
            if (findIndex > -1) {
              newState[findIndex].textConsentStatus = respLead?.textConsentStatus;
              newState[findIndex].textConsentDate = respLead?.textConsentDate;
            }
            return newState;
          };
          setLeadList(arrayFn());
          message.success(`The consent has been sent successfully`);

          setTimeout(() => {
            clearTimeout(concentTime);
            setDisableConcentClick(true);
          }, 3000);
        }
      })
      .catch(() => {
        clearTimeout(concentTime);
        setDisableConcentClick(true);
      });
    onClickHandler(content, { ...selectedLead, textConsentStatus: "PENDING" }, user?.id);
  };
  const handleSendConsentClick = (e, status) => {
    status !== "PENDING" && setDisableConcentClick(prev => !prev);
    if (e) {
      e.preventDefault();
      if (status === "PENDING") {
        showConfirmationModal(
          "The consent already sent to customer, Would you like to send consent again?",
          "",
          () => {
            sendContentMessage();
          }
        );
      } else {
        sendContentMessage();
      }
    }

    concentTime = setTimeout(() => {
      setDisableConcentClick(true);
    }, 10000);
  };

  const handleSearch = e => {
    // Clear any stuck isRefetching state from a prior notification-driven
    // refresh (e.g. one whose refreshLeadList promise rejected in prod).
    // Otherwise the getLeads onCompleted guard would silently discard our
    // search response and the UI would keep showing stale data.
    setRefetching(false);
    page = 0;
    lastLead = "";
    setSelectedLead({});
    // Empty search = "clear" click (X button). Delegate to resetSearch so
    // CRM identifiers are wiped too — otherwise `crmLeadId` / `crmOpportunityId`
    // / `crmDealerId` / `crmIntegrationType` keep the backend in single-lead
    // mode and the previous lead stays rendered.
    if (e === "" || e === undefined || e === null) {
      resetSearch();
      return;
    }
    setSearchKey(e);
    setVariables({ ...variables, page: 1, dsEventId: "", dsEntityId: "" });
    setSearch(e);
    setEventId("");
    setEntityId("");
    // Unified CRM routing — the `setVariables` / `setSearch` above already
    // update the main useQuery's variables; Apollo refetches automatically.
  };

  useEffect(() => {
    if (leadCountUpdatedData?.lead_id) {
      const selectedLeadIndex = (leadList || []).findIndex(
        lead => +lead?.id === +leadCountUpdatedData?.lead_id
      );
      if (selectedLeadIndex > -1) {
        const array = () => {
          const newState = structuredClone(leadList);
          newState[selectedLeadIndex] = {
            ...newState[selectedLeadIndex],
            unreadCount: leadCountUpdatedData.unread_count,
          };
          return newState;
        };
        setLeadList(array());
      }
    }
  }, [leadCountUpdatedData]);

  useEffect(() => {
    if (
      !isUndefined(queryString) &&
      searchKey !== "" &&
      searchKey !== "remove" &&
      searchKey &&
      search !== searchKey
    ) {
      handleSearch(searchKey);
    }
  }, [searchKey]);

  useEffect(() => {
    setActiveLeadId(localStorage.getItem("changedLocationLeadId"));
  }, [locaitonLocalId]);

  function SuggestAMessage({ createSuggestedResponse, misc }) {
    return misc.loading ? (
      <Spin size="small" className="mr-2" />
    ) : (
      <Tooltip title="Suggest a message">
        <Icon
          className="text-sm mr-2"
          onClick={() => createSuggestedResponse()}
          component={EngagedAiLogo}
          alt="EngagedAi"
        />
      </Tooltip>
    );
  }
  useEffect(() => {
    const slug = window.location.pathname;
    const phoneNumber =
      `${slug?.split("/")[2]}`.replace("/", "") === "undefined" ||
      `${slug?.split("/")[2]}`.replace("/", "") === "remove"
        ? ""
        : `${slug?.split("/")[2]}`.replace("/", "") || "";
    phoneNumber && setSearchKey(phoneNumber);
  }, [window.location.href]);

  const handleOppFilter = filterName => {
    setActiveOpp(filterName);
  };
  const placeholder = () => {
    return buttonStyle()?.background === "#F59E0B"
      ? `${lang.clickOnYellowSendIcon}`
      : buttonStyle().background === "#EF4444"
      ? "Customer has opted out, you don’t have consent!"
      : `Use Otto AI bot to write your message or type your message here...`;
  };
  const textDisabled = () => {
    // if (selectedLead?.leadSource?.name === "EngagedAi - Webchat") {
    //   if (connection?.connected) return false;
    //   return false;
    // }
    // console.log(
    //   "Text consent Log====> isConsentStatusEnable(selectedLead?.textConsentStatus, user?.company?.isOptinConsentMethod),cosentAtEnd,explicit ===>",
    //   isConsentStatusEnable(selectedLead?.textConsentStatus, user?.company?.isOptinConsentMethod),
    //   cosentAtEnd,
    //   explicit,
    //   selectedLead
    // );
    if (
      !isConsentStatusEnable(selectedLead?.textConsentStatus, user?.company?.isOptinConsentMethod)
    ) {
      if (implicit || explicit) {
        return true;
      }
      return false;
      // eslint-disable-next-line no-else-return
    } else {
      return false;
    }
  };

  const handleSendReviewClick = () => {
    setSendReviewVisible(true);
    openDialog("reviewDialog", {
      handleConfirm: () => {
        closeDialog("reviewDialog");
      },
      oncancel: () => {
        closeDialog("reviewDialog");
      },
      lead: selectedLead,
      dialogHeader: "Send Review Invite Link",
      confirmBtnText: "Send",
      sendSendReview: payload => {
        onClickReviewHandler(`${payload.body}`, payload.reviewLink, selectedLead, user?.id);
      },
    });
  };

  const handleReviewTemplateUploadClick = () => {
    setReviewTemplateUploadVisible(true);
  };

  const handleAddAppointment = () => {
    setOpenAppointmentDrawer(true);
    setRefetchAppointment(false);
  };
  const { textMode: textModeRedux } = useSelector(state => state.lead);
  const addSignature = signature => {
    if (textModeRedux === "Email") {
      emailTextRef.current.innerHTML = `${emailTextRef.current.innerHTML} <br/> ${signature}`;
    }
  };
  const tooltipTitle = () => {
    if (textModeRedux === "Email") {
      return "Send Email";
    }
    if (
      !isConsentStatusEnable(selectedLead?.textConsentStatus, user?.company?.isOptinConsentMethod)
    ) {
      const hasOptedOut = selectedLead?.textConsentStatus === "DECLINED";

      if (implicit || explicit) {
        return hasOptedOut ? "Lead has opted out" : "Send consent request";
      } else {
        return hasOptedOut ? "Lead has opted out" : "Send message";
      }
    } else {
      return "Send Message";
    }
  };
  const getLocationName = (initials = true) => {
    const id = sessionStorage.getItem("currentLocationId");
    if (id?.includes(",")) {
      return "All";
    } else {
      const obj = location2?.find(item => item.id === id);
      if (initials) {
        return convertToInitials(obj?.title);
      } else {
        return obj?.title;
      }
    }
  };
  const buttonStyle = () => {
    if (textModeRedux === "Email") {
      return { background: "blue" };
    }
    const style = {
      background: selectedLead?.textConsentStatus === "DECLINED" ? "#EF4444" : "blue",
    };
    if (
      !isConsentStatusEnable(selectedLead?.textConsentStatus, user?.company?.isOptinConsentMethod)
    ) {
      if ((implicit || explicit) && selectedLead?.textConsentStatus !== "DECLINED") {
        if (selectedLead?.textConsentStatus === "ACCEPTED") {
          style.background = "#52c41a";
        } else {
          style.background = "#F59E0B";
        }
      }
      return style;
    }
    if (canDisabledConversation) {
      style.background = "#EBEBE4";
    }
    return style;
  };

  const buttonDisabled = () => {
    if (textModeRedux === "Email") {
      return false;
    }
    return selectedLead?.textConsentStatus === "DECLINED";
  };

  const sendConsentMessage = () => {
    if (implicit) {
      const { templatetext } = consent.find(
        item => item.code === "CONSENT_MESSAGE_FOR_OPTIN_CONSENT_METHOD_OFF"
      );
      getEngagementTemplateText({
        variables: {
          leadId: selectedLead?.id,
          content: templatetext,
        },
      });
    }
    if (explicit) {
      const { templatetext } = consent.find(
        item => item.code === "CONSENT_MESSAGE_FOR_OPTIN_CONSENT_METHOD_ON"
      );
      getEngagementTemplateText({
        variables: {
          leadId: selectedLead?.id,
          content: templatetext,
        },
      });
    }
  };

  const handleAddPhoneClick = () => {
    openDialog("addLeadViaPhone", {
      dialogHeader: lang.addPhone,
      phoneNumber: queryString,
      setQueryString: setQueryString,
      openModal: openAddModal && modal && apiCheck,
      statusList: statusList,
      setModalVisible: setAddPhoneModalVisible,
      variables: variables,
      data: leadList,
      sources: sourcesData?.leadSources || [],
      user: user,
      leadFirstName: leadFirstName,
      leadLastName: leadLastName,
      userLocation: userLocation,
      handleLeadCRMName: handleLeadCRMName,
      onSetLead: (item, mode, phoneLead = "") => {
        if (phoneLead === "phoneLead") {
          const itemData = { ...item, messages: [] };
          setSelectedLead(itemData);
          page = 1;
          setMessageFilters({
            ...messageFilters,
            leadId: item.id,
            lastId: lastLead,
            page: 1,
          });
          if (mode === "new") {
            if (!Array.isArray(leadList) || !Object.isExtensible(leadList)) {
              // Make a shallow copy of leadList if it's an array
              const tempLeadList = Array.isArray(leadList) ? [...leadList] : [];
              tempLeadList.unshift(itemData);
              // Replace the original leadList with the new, modified copy
              setLeadList(structuredClone([...tempLeadList]));
            } else {
              leadList.unshift(itemData);
            }
          }
        } else {
          if (selectedLead?.id === item?.id) {
            setAddPhoneModalVisible(false);
            return;
          }

          if (sessionStorage.getItem("currentLocationId") !== item?.location?.id) {
            localStorage.setItem("changedLocationLeadId", item?.id);
            sessionStorage.setItem("currentLocationId", item?.location?.id);
            dispatch(setLocationIdSlice({ locationId: item?.location?.id }));
            closeDialog("addLeadViaPhone");
            return;
          }

          handleLeadDetailProfile(item?.id);
          handleScrollOnMovement();
        }
      },
      onLeadStatus: LeadStatus,
      onLeadOwners: leadOwners,
      onVehicles: vehicles,
      crmIntegration: crmIntegration || crmIntegrationType,
      isFromChatbot: true,
      setSearchKey: setSearchKey,
      setVariables: setVariables,
      handleCancelBtn: handleCancel,
      refetchLeads: refetchLeads,
      siteId: crmDealerId,
      paramLeadId: crmOpportunityId,
    });
  };

  const handleUpdate = async payload => {
    if (payload) {
      let lead = structuredClone(selectedLead);
      if (payload?.key === "fullName") {
        const leadResp = await updateLead({
          variables: {
            leadId: selectedLead.id,
            fullName: payload?.value?.replace(/\s{2,}/g, " ").trim() || "",
            isSyncCheck: true,
            isPushCrm: true,
          },
        });
        if (leadResp?.data?.updateLead?.statusCode !== 200) {
          message.error(leadResp?.data?.updateLead?.message);
          return;
        }

        lead = {
          ...lead,
          fullName: leadResp?.data?.updateLead?.lead?.fullName,
        };
        getLeadDetail({ variables: { leadId: lead?.id } });
        const arrayFn = () => {
          const newState = structuredClone(leadList);
          const findIndex = newState.findIndex(el => +el.id === +selectedLead?.id);
          if (findIndex > -1) {
            newState[findIndex].fullName = lead.fullName;
          }
          return newState;
        };
        setLeadList(arrayFn());
      }
      if (payload?.key === "phone") {
        let phoneResp = null;
        if (payload.id) {
          phoneResp = await updateLeadPhone({
            variables: {
              id: payload.id,
              phone: payload?.value || "",
              isSyncCheck: true,
              isPushCrm: true,
              phoneType: toTitleCase(payload.phoneType),
              leadId: selectedLead.id,
            },
          });
          if (phoneResp?.data?.updateLeadPhone?.statusCode !== 200) {
            message.error(phoneResp?.data?.updateLeadPhone?.message);
            return;
          }
          const index = lead.phoneNumbers.findIndex(
            item => toTitleCase(item.phoneType || item.lookupType) === payload.phoneType
          );
          lead.phoneNumbers[index] = {
            ...phoneResp?.data?.updateLeadPhone?.leadPhone,
          };
          getLeadDetail({ variables: { leadId: lead?.id } });
        } else {
          phoneResp = await createLeadPhone({
            variables: {
              leadId: parseInt(selectedLead?.id),
              phone: payload?.value || "",
              isSyncCheck: true,
              isPushCrm: true,
              phoneType: toTitleCase(payload.phoneType),
            },
          });
          if (phoneResp?.data?.createLeadPhone?.statusCode !== 200) {
            message.error(phoneResp?.data?.createLeadPhone?.message);
            return;
          }
          lead = {
            ...lead,
            phoneNumbers: [{ ...phoneResp?.data?.createLeadPhone?.leadPhone }],
          };
        }
        const arrayFn = () => {
          const newState = structuredClone(leadList);
          const findIndex = newState.findIndex(el => +el.id === +selectedLead?.id);
          if (findIndex > -1) {
            const [phone] = lead.phoneNumbers;
            newState[findIndex].phoneNumbers[0] = phone;
          }
          return newState;
        };
        setLeadList(arrayFn());
      }
      if (payload?.key === "email") {
        // eslint-disable-next-line no-useless-escape
        const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (!payload?.value.match(emailRegex)) {
          message.error(lang.enterValidEmail);
          return;
        }
        let emailResp = null;
        if ((lead?.emails || []).length > 0 && lead?.emails[0] != null) {
          emailResp = await updateLeadEmail({
            variables: {
              id: parseInt(parseInt(lead?.emails[0].id)),
              email: payload?.value || "",
              isSyncCheck: true,
              isPushCrm: true,
            },
          });
          if (emailResp?.data?.updateLeadEmail?.statusCode !== 200) {
            message.error(emailResp?.data?.updateLeadEmail?.message);
            return;
          }
          lead.emails[0] = {
            ...emailResp?.data?.updateLeadEmail?.leadEmail,
          };
          getLeadDetail({ variables: { leadId: lead?.id } });
        } else {
          emailResp = await createLeadEmail({
            variables: {
              leadId: parseInt(selectedLead?.id),
              email: payload?.value || "",
              isSyncCheck: true,
              isPushCrm: true,
            },
          });
          if (emailResp?.data?.createLeadEmail?.statusCode !== 200) {
            message.error(emailResp?.data?.createLeadEmail?.message);
            return;
          }
          lead = {
            ...lead,
            emails: [{ ...emailResp?.data?.createLeadEmail?.leadEmail }],
          };
        }
        const arrayFn = () => {
          const newState = structuredClone(leadList);
          const findIndex = newState.findIndex(el => +el.id === +selectedLead?.id);
          if (findIndex > -1) {
            const [email] = lead.emails;
            if (newState[findIndex]?.emails && newState[findIndex].emails[0]) {
              newState[findIndex].emails[0] = email;
            }
          }
          return newState;
        };
        setLeadList(arrayFn());
      }
      setSelectedLead(lead);

      setInlineEditField(null);
    }
  };

  const scrollToBottom = (behavior = "smooth") => {
    scrollToBottomHook(behavior);
  };

  const handleLeadCRMName = () => {
    setLeadFirstName("");
    setLeadLastName("");
    setSearch(localStorage.getItem("previousLeadSearchTrack"));
  };

  const [leadIdClick, setLeadIdClick] = useState("");
  const [getLeadDetailClick] = useLazyQuery(GET_LEAD_DETAIL_CLICK, {
    fetchPolicy: "network-only",
    onCompleted: resp => {
      const leadDetail = resp?.lead;
      if (!leadDetail) return;
      // Stale-response guard: rapid sidebar clicks (A then B) can have A's
      // response land after B was clicked. `leadIdClick` holds the MOST
      // RECENTLY clicked id; if the response's lead doesn't match, it's a
      // late reply for a previously-clicked lead — discard.
      // NOTE: we cannot use `selectedLeadIdRef` here because this query
      // precedes selectedLead being set. Using `leadIdClick` (set
      // synchronously by handleLeadDetailProfile before the fire) is the
      // correct "expected id" for this flow.
      if (leadIdClick && +leadIdClick !== +leadDetail.id) {
        return;
      }
      // Existing check: a CRM postMessage clears both leadIdClick and
      // localStorage.clickLeadId, so a stale response after a postMessage-
      // driven context switch is naturally ignored here without additional
      // guards.
      if (leadIdClick || localStorage.getItem("clickLeadId")) {
        let newLeadList = isClickonPotentialDuplicate
          ? leadData?.getLeads?.data?.length > 0 && [...leadData?.getLeads?.data]
          : leadList?.length > 0
          ? [...leadList]
          : leadData?.getLeads?.data?.length > 0 && [...leadData?.getLeads?.data];
        const activeLeadindex = newLeadList.findIndex(lead => +lead.id === +leadIdClick);

        if (activeLeadindex > -1) {
          newLeadList.splice(activeLeadindex, 1);
        }
        newLeadList.unshift(leadDetail);
        setSelectedLead({ ...leadDetail, messages: selectedLead.messages });
        setMessageFilters({
          campaignIds: [],
          leadId: leadIdClick,
          lastId: "",
          page: 1,
          pageSize: 20,
        });

        if (variables?.page > 1 && activeLeadindex === -1) {
          newLeadList = newLeadList.slice(0, newLeadList?.length - 1);
        }
        setSelectedLead({ ...leadDetail, messages: selectedLead.messages });
      }
    },
  });

  const handleLeadDetailProfile = async leadId => {
    setLeadIdClick(leadId);
    localStorage.setItem("clickLeadId", leadId);
    getLeadDetailClick({ variables: { leadId: leadId } });
    getMessages({
      variables: {
        ...messageFilters,
        campaignIds: (messageFilters.campaignIds || []).map(el => parseInt(el)),
      },
    });
  };

  const handleScrollOnMovement = () => {
    document.querySelector(".antdList").scrollTop = 0;
  };

  const debounceFnSearchLead = useCallback(debounce(handleSearch, 300), []);

  const handlePotentialLeadPopup = () => {
    setOpenPotentialLeadDialog(prev => !prev);
  };

  const [getTranslationSettings] = useLazyQuery(GET_TRANSLATION_SETTINGS, {
    fetchPolicy: "network-only",
    onCompleted: res => {
      if (res?.getTranslationSettings) {
        setTargetLangForCustomer(res?.getTranslationSettings?.customerLanguage);
        setTargetLangForEmployee(res?.getTranslationSettings?.userLanguage);
        setIsAutoTranslate(res?.getTranslationSettings?.isAutomaticTranslation);
        setIsIncludeOriginalMessage(res?.getTranslationSettings?.isIncludeOriginalMessage);
        setIsTranslatePreviewShow(res?.getTranslationSettings?.isTranslationPreview);
      }
    },
  });

  // useEffect ensures side effects run reliably on every dependency change
  useEffect(() => {
    if (canViewTranslation && selectedLead?.id && +selectedLead?.id !== +selectedLeadID) {
      getTranslationSettings({ variables: { leadId: selectedLead?.id } });
    }
    dispatch(changeMessageOpportunity("#DEFAULTOPPID"));
    setSummaryVisible({ visible: false, count: 0 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLead?.id]);

  const renderConsentNote = () => {
    if (afterMessageFromRedux?.content) {
      if (!onlyFirstMessage) {
        return true;
      } else {
        if (selectedLead?.messages?.length) {
          return false;
        }
        return true;
      }
    }
    return false;
  };
  const handleRefetchAndCloseDrawer = flag => {
    try {
      setRefetchAppointment(true);
      setOpenAppointmentDrawer(flag);
    } catch (err) {
      console.log(err.message);
    }
  };
  const handleKeyDown = event => {
    if (event.keyCode === 16) {
      // 16 is the key code for the Shift key
      event.preventDefault();
      event.stopPropagation();
    }
  };
  const handleMMS = async mmsArr => {
    // Definitive sync re-entry guard. See EAI-1124 fix in
    // engagementActivity.js for full writeup.
    if (sendingMMSRef.current) return;
    sendingMMSRef.current = true;
    setmmsLoader(true);

    const messagePayload = {
      leadId: +selectedLead?.id,
      userId: +user.id,
      direction: "TO_LEAD",
      content: textMode === 0 ? text.current.value.trim() : richTextValue.trim(),
      toPhone: getLeadToPhone(selectedLead, { withPlusPrefix: true }),
      mmsObjects: mmsArr,
      aiResponseHistoryId: textAiResponseHistoryId ?? null,
      attachmentSource: AttachmentSource.GALLERY,
      leadOpportunityId: resolveLeadOpportunityId(messageOpportunity),
    };

    try {
      const res = await createMMS({ variables: messagePayload });
      if (res?.data?.createMms?.statusCode === 200) {
        const messages = structuredClone(selectedLead.messages);
        const mmsObjects = res?.data?.createMms.leadMessage.mmsObjects.map(media => ({
          compressedMediaUrl: media?.compressedMediaUrl || null,
          mediaUrl: media?.mediaUrl,
          mediaType: media?.mediaType,
          size: media?.size,
          thumbnail: media?.thumbnail || media?.mediaUrl || null,
          compressedThumbnail: media?.compressedThumbnail || null,
        }));
        messages.push({
          ...res?.data?.createMms.leadMessage,
          mmsObjects: mmsObjects,
        });
        setSelectedLead({
          ...selectedLead,
          messages: [...messages],
        });
        updateLeadMessagesRedux(selectedLead?.id, messages);
        textMode === 0 ? (text.current.value = "") : setrichTextValue("");
        message.success(res?.data?.createMms?.message);
        setAttachments([]);
        setmessageText("");
        text.current.value = "";
        dispatch(setTextAiResponseHistoryId(null));
      }
    } catch (err) {
      console.error("createMMS failed:", err);
      message.error("Failed to send message. Please try again.");
    } finally {
      sendingMMSRef.current = false;
      setmmsLoader(false);
    }
  };
  const handleKeyUp = async event => {
    if (event.keyCode === 13 && event.shiftKey) {
      // 13 is the key code for the Enter key
      event.preventDefault();
      text.current.scrollTop = text.current.scrollHeight;
    } else if (event.keyCode === 13) {
      // EAI-1124: block Enter+Click race that produced duplicate createMms.
      if (sendingMMSRef.current || mmsLoader) {
        event.preventDefault();
        return;
      }
      let mmsArr = [];
      if (attachments.length > 0) {
        setmmsLoader(true);
        try {
          mmsArr = await handleFiles(
            attachments,
            user,
            selectedLead,
            fetchData,
            setMediaUploadLoader
          );
        } catch (err) {
          console.error("handleFiles failed in Enter path:", err);
          setmmsLoader(false);
          message.error("Failed to upload attachment. Please try again.");
          return;
        }
        if (!mmsArr || mmsArr.length === 0) {
          setmmsLoader(false);
          message.error("Failed to upload attachment. Please try again.");
          return;
        }
      }
      if (mmsArr.length > 0) {
        // handleMMS owns the loader/ref reset from here on (try/finally).
        handleMMS(mmsArr);
      } else {
        if (
          isEmpty(messageText.trim()) &&
          isEmpty(textMode === 0 ? text.current?.value?.trim() : richTextValue)
        ) {
          // setmessageText(messageText.trim());
          return message.error(lang.pleaseEnterMessageToSend);
        }
        setmessageText(textMode === 0 ? text.current.value : richTextValue);

        if (
          isConsentStatusEnable(
            selectedLead?.textConsentStatus,
            user?.company?.isOptinConsentMethod
          )
        ) {
          let msg;
          if (onlyFirstMessage) {
            // Consent text to be added only on the first message to lead
            if (selectedLead?.messages?.length > 0) {
              // Not the first message to lead, so consent text not required to be added.
              msg = text.current?.value.trim() || messageText.trim();
            } else {
              // Append consent text to the message
              msg =
                afterMessageConsent !== ""
                  ? `${
                      textMode === 0 ? text.current.value.trim() : richTextValue.trim()
                    } ${afterMessageConsent}`
                  : textMode === 0
                  ? text.current.value.trim()
                  : richTextValue.trim();
            }
          } else {
            // Consent text to be added on every message to lead
            msg =
              afterMessageConsent !== "" && selectedLead?.leadSource?.name !== "EngagedAi - Webchat"
                ? `${
                    textMode === 0 ? text.current.value.trim() : richTextValue.trim()
                  } ${afterMessageConsent}`
                : textMode === 0
                ? text.current.value.trim()
                : richTextValue.trim();
          }
          // console.log(msg);
          onClickHandler(msg, selectedLead, user?.id);
        } else {
          event.preventDefault();
          // Consent text to be added on every message to lead
          // msg =
          //   afterMessageConsent !== "" && selectedLead?.leadSource?.name !== "EngagedAi - Webchat"
          //     ? `${
          //         textMode === 0 ? text.current.value.trim() : richTextValue.trim()
          //       } ${afterMessageConsent}`
          //     : textMode === 0
          //     ? text.current.value.trim()
          //     : richTextValue.trim();
        }
      }
    }
    // NOTE: Removed redundant keyCode 46 (Delete) handler — the browser performs the
    // forward-delete natively on keydown; handling it again here removed a second
    // character (double-delete bug).
  };

  const handleActiveLeadFilterOnLogout = () => {
    dispatch(pushActiveLeadFilter({ activeLeadFilter: {} }));
  };

  const resetLeadFilterOnLogout = () => {
    dispatch(resetLeadFilters());
  };

  const setLocationToNullOnLogout = () => {
    dispatch(setLocationIdSlice({ locationId: null }));
  };
  const findOpp = () => {
    return opportunityList.find(item => +item.id === +activeOpp);
  };
  const opportunityObj = useMemo(findOpp, [activeOpp, opportunityList]);

  function getIdsBySelectedField(data, fieldName) {
    return data.filter(item => item[fieldName]?.selected === true).map(item => item.id);
  }

  const findLeadById = id => {
    return duplicateRecord.find(lead => lead.id === id);
  };

  const handleMerge = async () => {
    const phones = findLeadById(getIdsBySelectedField(records, "Phone number")[0])?.phoneNumbers;
    const email = findLeadById(getIdsBySelectedField(records, "Email")[0])?.email;

    // Validate that at least phone or email is available
    if ((!phones || phones?.length === 0) && !email) {
      message.error("At least one phone number or email is required to merge leads");
      return;
    }

    await createLead({
      variables: {
        firstName: findLeadById(getIdsBySelectedField(records, "Name")[0])?.firstName,
        lastName: findLeadById(getIdsBySelectedField(records, "Name")[0])?.lastName,
        fullName: findLeadById(getIdsBySelectedField(records, "Name")[0])?.fullName,
        phones,
        locationId: findLeadById(getIdsBySelectedField(records, "Name")[0])?.location?.id,
        email,
        leadStatusTypeId: findLeadById(records[0].id)?.leadStatusType,
        leadSourceOriginalId: findLeadById(getIdsBySelectedField(records, "Name")[0])
          ?.leadSourceOriginalId,
        vehicleOfInterests: findLeadById(getIdsBySelectedField(records, "Name")[0])
          ?.vehicleOfInterest,
        textConsent: findLeadById(getIdsBySelectedField(records, "Name")[0])?.textConsentStatus,
        potentialLeads: [...findLeadById(records[0]?.id)?.potentialLeads, +records[0]?.id],
        leadAddressObj: {
          addressLine1: findLeadById(getIdsBySelectedField(records, "Address")[0])?.addresses
            ?.addressLine1,
          addressLine2: findLeadById(getIdsBySelectedField(records, "Address")[0])?.addresses
            ?.addressLine1,
          city: findLeadById(getIdsBySelectedField(records, "Address")[0])?.addresses?.addressLine1,
          state: findLeadById(getIdsBySelectedField(records, "Address")[0])?.addresses
            ?.addressLine1,
          country: findLeadById(getIdsBySelectedField(records, "Address")[0])?.addresses
            ?.addressLine1,
          postalCode: findLeadById(getIdsBySelectedField(records, "Address")[0])?.addresses
            ?.addressLine1,
        },
        leadSourceType: findLeadById(getIdsBySelectedField(records, "Source")[0])?.leadSourceType,
        leadOpportunityUsers: findLeadById(records[0]?.id)?.leadUsers?.map(item => ({
          ...item,
          userType: item?.userType?.name,
        })),
      },
      onCompleted: res => {
        if (res?.createLead?.statusCode === 200) {
          setVisibleMergeLeadModal(false);
          // Unified CRM routing — main useQuery refetch covers every CRM.
          refetchLeads();
        } else {
          message.error(res?.createLead?.message);
        }
      },
    });
  };

  const convertLeadsToFormattedArray = leadsArray => {
    return leadsArray?.map((lead, index) => ({
      id: lead?.id,
      Name: {
        value: lead.fullName,
        selected: false,
      },
      "Phone number": {
        value: lead?.phoneNumbers[0]?.phone,
        selected: false,
      },
      Address: {
        value: lead?.addresses?.addressLine1,
        selected: false,
      },
      Location: {
        value: lead?.location?.title,
        selected: false,
      },
      Owners: {
        value:
          [...lead?.leadUsers]
            ?.map(item => `${item?.user?.firstName || "N/A"} ${item?.user?.lastName || "N/A"}`)
            .join(", ") || "",
        selected: false,
        Owners: [...lead?.leadUsers],
      },
      Email: {
        value: lead?.emails?.email,
        selected: false,
      },
      "Lead status": {
        value: lead?.leadStatusType?.status,
        selected: false,
      },
      Source: {
        value: lead?.leadSource?.name,
        selected: false,
      },
      Vehicle: {
        value: null,
        selected: false,
      },
    }));
  };
  const getDuplicateLeads = async (item, ids) => {
    setVisibleMergeLeadModal(true);
    const duplicateLeads = await getLeadsById({
      variables: {
        leadIds: ids,
      },
    });
    const temp = [...(duplicateLeads.data?.getLeadsById || [])];
    temp.unshift(item);
    setDuplicateRecord(temp);
    setRecords(convertLeadsToFormattedArray(temp));
  };

  const removeMergedLead = (ids, leads) => {
    const updatedLeads = leads?.filter(lead => !ids.includes(+lead.id));
    setLeadList(updatedLeads);
  };

  const getMergedLead = async (item, ids, leads) => {
    const duplicateLeads = await getLeadsById({
      variables: {
        leadIds: ids,
      },
    });

    const temp = [...(duplicateLeads.data?.getLeadsById || [])];

    // Find the index of the lead that matches the item id
    let index = -1;
    try {
      index = (leads || []).findIndex(lead => +lead.id === +item.id);
    } catch (error) {
      console.error("Error finding index in leads array:", error);
      return;
    }

    if (index === -1) {
      // If no match is found, return the original leads without modification
      return;
    }

    // Create a new array with the temp array added after the matching lead
    const updatedLeads = [
      ...leads.slice(0, index + 1), // All leads up to the matching lead (inclusive)
      ...temp, // Add the temp array after the matching lead
      ...leads.slice(index + 1), // The rest of the leads
    ];

    // Dispatch the updated leads list
    setLeadList(updatedLeads);
  };

  const groupedMessages = useMemo(
    () => groupMessagesByDate(selectedLead?.messages || []),
    [selectedLead, selectedLead?.messages]
  );
  const totalSize = useMemo(() => {
    return sumBy(
      attachments.map(item => item.file),
      "size"
    );
  }, [attachments]);
  const screenParts = useMemo(() => {
    if (screenWidth < 1280) {
      return {
        leftSide: 230,
        middleSection: 380,
        rightSide: 230,
      };
    } else {
      return {
        leftSide: 350,
        middleSection: 450,
        rightSide: 350,
      };
    }
  }, [screenWidth]);

  const hasLoadedinRedux =
    leadList.find(el => +el.id === +selectedLead?.id)?.hasLoadedinRedux || false;
  const [emailForm] = Form.useForm();
  const [createEmail] = useMutation(CREATE_EMAIL);
  const handleEmail = async () => {
    // if(emailTextRef.current){
    if (isEmpty(emailTextRef.current.innerText.replace(/\s/g, ""))) {
      return message.error("Please enter a content");
    }
    // }
    let mmsArr = [];
    if (attachments.length > 0) {
      setmmsLoader(true);
      mmsArr = await handleFiles(attachments, user, selectedLead, fetchData, setMediaUploadLoader);
      setmmsLoader(false);
    }
    const {
      attachments: inlineAttachments,
      content: contentWithLinks,
      linkedCount,
    } = buildEmailAttachmentsPayload(
      mmsArr,
      emailTextRef.current.innerHTML,
      EMAIL_ATTACHMENT_LIMITS.MAX_RAW_BYTES
    );
    const payload = {
      attachments: inlineAttachments,
      leadId: selectedLead.id,
      ...emailForm.getFieldsValue(),
      content: contentWithLinks,
      userId: user.id,
      ...(messageOpportunity !== "#DEFAULTOPPID" ? { leadOpportunityId: messageOpportunity } : {}),
      aiResponseHistoryId: emailAiResponseHistoryId ?? null,
    };
    if (linkedCount > 0) {
      message.info(
        `${linkedCount} large file${linkedCount > 1 ? "s" : ""} sent as download link${
          linkedCount > 1 ? "s" : ""
        }.`
      );
    }
    const res = await createEmail({
      variables: payload,
    });
    if (res?.data?.createEmail?.statusCode === 200) {
      emailTextRef.current.innerHTML = "";
      emailForm.resetFields();
      const selectedLeadIndex = (leadList || []).findIndex(lead => lead?.id === selectedLead?.id);
      if (selectedLeadIndex > -1) {
        const arrayFn = () => {
          const newState = structuredClone(leadList);
          newState[selectedLeadIndex] = {
            ...newState[selectedLeadIndex],
            unreadCount: 0,
          };
          return newState;
        };
        setLeadList(arrayFn());
      }
      const resMessage = res?.data?.createEmail?.leadMessage || {};
      const id = parseInt(resMessage?.id);
      const selectedLeadDetails = structuredClone({
        ...selectedLead,
        textConsentStatus: lead?.textConsentStatus || selectedLead?.textConsentStatus,
      });
      selectedLeadDetails.messages.push({
        ...resMessage,
      });
      setSelectedLead(selectedLeadDetails);
      setAttachments([]);
      message.success(res?.data?.createEmail?.message);
      dispatch(setEmailAiResponseHistoryId(null));
    } else {
      message.error(res?.data?.createEmail?.message);
    }
  };

  const handleBackButtonClick = () => {
    setMessageFilters(prev => ({
      ...prev,
      page: 1,
      pageSize: 20,
      leadId: null,
      campaignIds: [],
      lastId: "",
      internalMessageId: null,
    }));
    dispatch(resetSelectedLeadMessages());
    setSearch("");
    setIsSingleLeadView(false);

    // Force scroll to bottom after data refetch with sufficient delay using auto behavior
    setTimeout(() => {
      scrollToBottom("auto");
    }, 300);
    window.history.pushState("", "", "/browser-ext-v3");
    clearTargetMessageId();
  };

  // Show skeleton only when there is nothing yet to render. The moment
  // `selectedLead.id` is set (by getLeads onCompleted), the skeleton lifts
  // even though secondary enrichment queries (getLeadDetail, getMessages,
  // getCampaignByLead, etc.) may still be in flight — they merge their
  // results into the already-rendered lead. Message and lead-detail
  // spinners are handled by their own inner indicators.
  //
  // Fetch signals considered:
  //   - leadsLoading:           main getLeads useQuery (first-time load)
  //   - refreshLeadListLoading: notification-driven lazy leads refetch
  //   - tekionSearchLoading:    Tekion GET_LEADS_BY_PHONE (legacy, no auto-trigger)
  const isLeadLoading =
    !selectedLead?.id && (leadsLoading || refreshLeadListLoading || tekionSearchLoading);

  return (
    <div id="extension-container" className="flex-row-centered h-full">
      <div ref={appRef} id="app-container" className="py-[5px] w-[calc(100%-40px)]">
        <Spin
          spinning={activeSpinner || mediaUploadLoader || tekionSearchLoading}
          tip={
            mediaUploadLoader
              ? `${lang.uploadingMedia}...`
              : leadsLoading || tekionSearchLoading || !gotLocationId
              ? `${lang.searching}...`
              : activeSpinner
              ? lang.openingAppointmentForm
              : ""
          }
          className="fixed top-[50%] left-[50%] z-50 font-bold bg-white py-[15px] px-[30px]"
          style={{
            transform: "translateX(-50%) translateY(-50%)",
          }}
        />
        <Modal
          open={visibleMergeLeadModal}
          onCancel={() => setVisibleMergeLeadModal(false)}
          footer={null}
          width={1000}
          closable={false}
        >
          <div className="relative bg-white rounded-lg w-full h-auto">
            <div className="flex items-center justify-center relative">
              <div className="text-center font-bold text-2xl flex-1">
                Potential Duplicate Records
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                fill="none"
                className="absolute right-0 text-xl cursor-pointer"
                onClick={() => setVisibleMergeLeadModal(false)}
              >
                <rect width={23} height={23} x={0.5} y={0.5} fill="#fff" rx={11.5} />
                <rect width={23} height={23} x={0.5} y={0.5} stroke="#E2E8F0" rx={11.5} />
                <path
                  stroke="#334155"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="m14.625 9.375-5.25 5.25M9.375 9.375l5.25 5.25"
                />
              </svg>
            </div>
            <div className="mt-4 text-center">
              <span>
                Choose data from the fields to continue the records into a single primary record.
              </span>
            </div>

            <div className="mt-12">
              {potentialLeadLoader ? (
                <div className="flex justify-center items-center h-[300px]">
                  <Spin size="large" />
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={tableData}
                  pagination={false}
                  scroll={{ x: "max-content", y: "300px" }}
                />
              )}
            </div>
            <div className="flex flex-col h-full mt-6">
              <div className="flex items-center space-x-4 mb-4">
                <Button loading={createLeadLoader} onClick={handleMerge} className="bg-[#3B82F6]">
                  <span className="text-[#FFFFFF]">Merge</span>
                </Button>

                <Button onClick={() => setVisibleMergeLeadModal(false)}>Cancel</Button>
                <span className="ml-4">
                  <span className="text-[#EF4444]">Warning:</span>
                  <br />
                  <span className="text-[#334155]">
                    Merging records is an irreversible action. Selected fields will be the final
                    data for the merged record.
                  </span>
                </span>
              </div>
            </div>
          </div>
        </Modal>
        <div className="flex items-start gap-1 h-[99vh] 3xl:h-[99vh] border-1 border-slate-200 border-t-0 border-l-0">
          {IsLeadListVisible && (
            <div
              className={`h-full w-[${screenParts.leftSide}px] max-w-[${screenParts.leftSide}px] antdList pl-2 pt-2`}
            >
              <LeadListContainer
                setSummaryVisible={setSummaryVisible}
                showSidebar={showSidebar}
                setShowSideBar={setShowSideBar}
                selectedLead={selectedLead}
                leadsError={leadsError}
                leadsLoading={leadsLoading || refreshLeadListLoading || tekionSearchLoading}
                setShowLeadSection={setShowLeadSection}
                leadList={leadList}
                setLeadList={setLeadList}
                variables={variables}
                leadCount={leadCount}
                lastLead={lastLead}
                setmessageText={setmessageText}
                setVariables={setVariables}
                setSelectedLead={setSelectedLead}
                setMessageFilters={payload => {
                  text.current.value = "";
                  setMessageFilters({ ...payload });
                }}
                messageFilters={messageFilters}
                sourcesData={sourcesData}
                searchKey={searchKey}
                setSearchKey={setSearchKey}
                handleSearch={debounceFnSearchLead}
                leadCampaigns={leadCampaigns}
                activeOpp={activeOpp}
                setActiveOpp={setActiveOpp}
                opportunityList={opportunityList}
                activeOppName={activeOppName}
                timeReference={timeReference}
                setOpportunityList={setOpportunityList}
                setFilterApplied={setFilterApplied}
                handleOppFilter={handleOppFilter}
                setShowProfileSection={setShowProfileSection}
                selectedStatus={uniq([...selectedQuickFilters, ...selectedStatus])}
                setSelectedStatus={setSelectedStatus}
                leadStatus={leadStatus}
                handleStatusFilter={handleStatusFilter}
                handleAppointmentModalClose={handleAppointmentModalClose}
                openAppointmentPopup={openAppointmentPopup}
                getLeadDetail={getLeadDetail}
                setSelectedLeadId={setSelectedLeadId}
                setbtnClicked={setbtnClicked}
                setRefetchAppointment={setRefetchAppointment}
                setActiveLeadId={setActiveLeadId}
                handleScrollOnMovement={handleScrollOnMovement}
                setQueryString={setQueryString}
                isFromChatbot
                eventId={eventId}
                IsLeadListVisible={IsLeadListVisible}
                handleLeadListVisible={handleLeadListVisible}
                // eslint-disable-next-line no-return-assign
                changePage={() => (page = 1)}
                spinner={spinner}
                setAttachments={setAttachments}
                visibleMergeLeadModal={visibleMergeLeadModal}
                setVisibleMergeLeadModal={setVisibleMergeLeadModal}
                getDuplicateLeads={getDuplicateLeads}
                getMergedLead={getMergedLead}
                removeMergedLead={removeMergedLead}
                onClearAllFilters={() => {
                  // Exit any CRM-scoped single-lead view so the main getLeads
                  // useQuery unskips and refetches the full list. Specifically
                  // needed for the Tekion phone-less opportunity lookup: the
                  // main query is skipped while `crmOpportunityId` is set, so
                  // Clear All has to drop those identifiers before any refetch
                  // can return "all leads".
                  setIsSingleLeadView(false);
                  setCrmIntegrationType(null);
                  setCrmLeadId(null);
                  setCrmOpportunityId(null);
                  setCrmDealerId(null);
                  setEntityId("");
                  setEventId("");
                  if (window.location.pathname.includes("browser-ext")) {
                    window.history.pushState("", "", "/browser-ext-v3/");
                  }
                }}
                isSingleLeadView={isSingleLeadView}
                onLoadAllLeads={() => {
                  // Mirror onClearAllFilters: the main getLeads query is
                  // skipped while Tekion's crmOpportunityId is set, so the
                  // CRM-scoped identifiers must be dropped before the refetch
                  // can return "all leads".
                  setIsSingleLeadView(false);
                  setCrmIntegrationType(null);
                  setCrmLeadId(null);
                  setCrmOpportunityId(null);
                  setCrmDealerId(null);
                  setEntityId("");
                  setEventId("");
                  setVariables({ ...variables, leadId: null });
                  clearTargetMessageId();
                  if (window.location.pathname.includes("browser-ext")) {
                    window.history.pushState("", "", "/browser-ext-v3/");
                  }
                  dispatch(setSearchRedux(""));
                }}
              />
            </div>
          )}

          <div
            className={`flex-1 flex flex-col h-full overflow-y-auto overflow-x-hidden relative chatContainer w-[${screenParts.middleSection}px] max-w-[${screenParts.middleSection}px]  border-1 border-slate-200 border-t-0 border-b-0`}
          >
            <div className="flex items-center px-1 justify-between border-[0px] w-full border-b border-solid border-b-grey-200 sticky py-1.5 top-0 bg-white z-10">
              <div className="flex items-center min-w-0 flex-1 gap-1">
                <Icon
                  onClick={() => handleLogoClick()}
                  className="text-4xl cursor-pointer"
                  component={EngagedAiLogo}
                  alt="EngagedAi"
                />
                {/* Header shows a two-line skeleton while any lead-related query
                    is in flight — initial load, lead switch, Tekion search, or
                    lazy refreshLeadList. Without this, the user sees a blank
                    header until the network resolves, which reads as "no data".
                    Once loaded, renders the actual fullName + consent/phone line. */}
                {isLeadLoading ? (
                  <div className="flex items-center min-w-0 flex-1">
                    <div className="flex justify-start ml-3 flex-col min-w-0 w-full max-w-[220px] py-1">
                      <Skeleton active title={{ width: 140 }} paragraph={{ rows: 1, width: 180 }} />
                    </div>
                  </div>
                ) : selectedLead?.id ? (
                  <div className="flex items-center min-w-0 flex-1">
                    <div className="flex justify-start ml-3 flex-col min-w-0">
                      <p className="text-sm text-left font-bold ellipsis w-full m-0">
                        <Tooltip title={selectedLead?.fullName || ""}>
                          {selectedLead?.fullName || ""}
                        </Tooltip>
                      </p>
                      <p className="m-0">{ShowConsent(selectedLead, user, true, queryString)}</p>
                    </div>
                    {crmIntegration === "SF" &&
                      selectedLead?.phoneNumbers?.length > 0 &&
                      selectedLead?.phoneNumbers[0]?.phone &&
                      (selectedLead?.phoneNumbers[0]?.potentialLeads?.length === 1
                        ? !selectedLead?.phoneNumbers[0]?.potentialLeads?.includes(
                            +selectedLead?.id
                          )
                        : selectedLead?.phoneNumbers[0]?.potentialLeads?.length
                        ? true
                        : false) && (
                        <Tooltip title="Potential Duplicate Leads">
                          <Icon
                            className="primaryColorTheme text-[20px] ml-1 flex-shrink-0"
                            onClick={() => handlePotentialLeadPopup()}
                            type="usergroup-add"
                          />
                        </Tooltip>
                      )}
                  </div>
                ) : null}
              </div>
              <div className="flex items-center justify-end flex-shrink-0">
                <div className="gap-1 flex items-center flex-row">
                  {Role !== "ADMIN" && (
                    <Select
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.children ?? "")
                          .toString()
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      className={`${
                        window.innerWidth >= 800 ? "min-w-[200px]" : "min-w-[100px]"
                      } mr-1`}
                      value={
                        location2?.length > 0
                          ? sessionStorage.getItem("currentLocationId")?.includes(",")
                            ? "all"
                            : sessionStorage.getItem("currentLocationId")?.toString().trim()
                          : undefined
                      }
                      onChange={e => {
                        // Wipe the previous URL-driven CRM context (crmDealerId /
                        // crmOpportunityId / crmLeadId / crmIntegrationType) AND the
                        // path-segment phone before switching locations. Without this,
                        // the user picks a new location but the React state still
                        // holds the prior URL's identifiers — `searchTekionLeads`
                        // useEffect re-fires with the stale crmOpportunityId, the
                        // backend resolves the lead by id regardless of location, and
                        // the previous lead snaps back into view, making the dropdown
                        // appear unresponsive. resetSearch also pushes the URL back
                        // to `/browser-ext-v3/` so a refresh lands on a clean
                        // location-browse view.
                        resetSearch();
                        localStorage.removeItem("changedLocationLeadId");
                        localStorage.removeItem("clickLeadId");
                        clearTargetMessageId();
                        setPhone("");
                        // Activate the manual-override sentinel so subsequent
                        // crm_context_update re-emits from frame.js for the
                        // SAME dealer are ignored. The dispatch below triggers
                        // resetApiCacheStore → meData briefly null in
                        // layout.js → BrowserExtensionPopup unmounts and
                        // remounts with empty CRM state. On remount the
                        // iframe posts crm_context_ready, the parent resets
                        // _lastSentContextJson and re-flushes the previously
                        // cached context. Without this flag the re-apply
                        // branch in handleCrmContextUpdate (dedupe matched,
                        // state wiped) would restore the old crmDealerId and
                        // the auto-match useEffect would snap the location
                        // back to where the user just left. The dedupe block
                        // clears this flag automatically once a genuinely
                        // different dealer ctx arrives.
                        sessionStorage.setItem(MANUAL_OVERRIDE_KEY, "true");
                        // Clear Redux lead state so the previous lead doesn't
                        // flash in the sidebar between this click and the new
                        // location's lead-list response. The crm_context_update
                        // handler does the same on a CRM-driven switch — manual
                        // switches deserve the same clean handoff.
                        dispatch(setSelectedLeadRedux({}));
                        dispatch(setLeadsRedux([]));
                        setLeadCount(0);
                        setSelectedLeadID(undefined);
                        setLeadIdClick("");
                        if (e === "all") {
                          let ids = "";
                          for (let i = 0; i < location2.length; i++) {
                            const element = location2[i];
                            ids = `${ids}${element.id}${location2.length - 1 === i ? "" : ","}`;
                          }
                          sessionStorage.setItem("currentLocationId", ids);
                          dispatch(setLocationIdSlice({ locationId: ids }));
                        } else {
                          setLocation(e);
                          sessionStorage.setItem("currentLocationId", e);
                          const crmIntegrationType = getActiveCrmIntegration(e);
                          setUser({
                            ...user,
                            locationId: e,
                            company: { ...user.company, crmIntegrationType },
                          });
                          dispatch(setLocationIdSlice({ locationId: e }));
                        }
                        if (window.location.pathname?.includes("activity-center")) {
                          window.history.pushState("", "", `/engagements/activity-center`);
                        }
                        persistor.pause();
                        persistor.flush().then(() => {
                          return persistor.purge();
                        });
                        dispatch(resetApiCacheStore({}));
                        dispatch(setTasks({ tasks: [], count: 0 }));
                        dispatch(setNotesRedux([]));
                        setchanged(!changed);
                      }}
                    >
                      {(location2 || []).length > 1 && (
                        <Select.Option key="all" value="all">
                          {lang.all}
                        </Select.Option>
                      )}
                      {((location2 || []).slice().sort(dynamicSort("title")) || []).map(item => (
                        <Select.Option
                          key={item?.id?.toString().trim()}
                          value={item?.id?.toString().trim()}
                        >
                          {item.title}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                  <Badge
                    count={notificationsCount ? notificationsCount.getUnreadNotificationsCount : 0}
                  >
                    <NotificationIcon
                      onClick={() => setNotificationDrawer(true)}
                      className="cursor-pointer text-[#64748B]"
                    />
                  </Badge>
                  {/* <div className="flex items-center"> */}
                  <Dropdown
                    overlay={profileMenu(
                      setShowSupportModal,
                      deleteFcmDevice,
                      handleActiveLeadFilterOnLogout,
                      resetLeadFilterOnLogout,
                      setLocationToNullOnLogout,
                      isPlatformAdminUser,
                      persistor,
                      dispatch,
                      () => setSettingsDrawer(true),
                      {
                        settingLabel: "Profile",
                        settingIcon: "UserOutlined",
                      },
                      apolloPersistor,
                      user?.id
                    )}
                    trigger={["click"]}
                    placement="bottomRight"
                  >
                    <div className="bg-[#F1F5F9] ml-2 flex items-center p-1 rounded-[100px] cursor-pointer">
                      <Avatar src={user?.profilePic || ""} size="small">
                        {convertToInitials(user?.fullName)}
                      </Avatar>
                    </div>
                  </Dropdown>
                </div>
                {/* </div> */}
              </div>
            </div>
            {/* Global lead-pane skeleton — replaces the opportunity/status bar
                and the message list (but NOT the top nav or bottom compose)
                while any lead-related query is in flight. Keeps the user's
                nav + compose context visible while clearly signalling that
                this-lead's data is loading. */}
            {isLeadLoading ? (
              <div className="flex-1 flex flex-col overflow-hidden px-4 py-3 gap-3 bg-white">
                <div className="flex items-center gap-2">
                  <Skeleton.Button active size="small" style={{ width: 110 }} />
                  <Skeleton.Button active size="small" style={{ width: 70 }} />
                  <div className="flex-1" />
                  <Skeleton.Avatar active size="small" shape="circle" />
                  <Skeleton.Avatar active size="small" shape="circle" />
                </div>
                <div className="flex-1 bg-[#F5F5F5] rounded overflow-hidden p-4">
                  <Skeleton active paragraph={{ rows: 2, width: ["60%", "40%"] }} />
                  <div className="mt-4">
                    <Skeleton active paragraph={{ rows: 2, width: ["50%", "70%"] }} />
                  </div>
                  <div className="mt-4">
                    <Skeleton active paragraph={{ rows: 2, width: ["65%", "45%"] }} />
                  </div>
                </div>
              </div>
            ) : (
              <>
                <TopToolbarJsx
                  selectedLead={selectedLead}
                  messageFilters={messageFilters}
                  page={page}
                  setMessageFilters={setMessageFilters}
                  opportunityList={opportunityList}
                  activeOpp={activeOpp}
                  setActiveOpp={setActiveOpp}
                  handleOppFilter={handleOppFilter}
                  activeOppName={activeOppName}
                  refetchLeadDetails={refetchLeadDetails}
                  disabled={
                    !selectedLead?.id || messageLoader || loading || spinner || leadsLoading
                  }
                  setVisibleTranslationSetting={setVisibleTranslationSetting}
                  visibleTranslationSettings={visibleTranslationSettings}
                  targetLangForCustomer={targetLangForCustomer}
                  setTargetLangForCustomer={setTargetLangForCustomer}
                  updateTranslationSetting={updateTranslationSetting}
                  targetLangForEmployee={targetLangForEmployee}
                  isAutoTranslate={isAutoTranslate}
                  isIncludeOriginalMessage={isIncludeOriginalMessage}
                  isTranslatePreviewShow={isTranslatePreviewShow}
                  languages={languages}
                  setTargetLangForEmployee={setTargetLangForEmployee}
                  setIsAutoTranslate={setIsAutoTranslate}
                  setIsIncludeOriginalMessage={setIsIncludeOriginalMessage}
                  setIsTranslatePreviewShow={setIsTranslatePreviewShow}
                  // Shows "View all messages" button when navigated to a specific message (e.g. notification click)
                  renderBackToNormalModeButton={!!targetMessageId}
                  handleBackButtonClick={handleBackButtonClick}
                />
                <div
                  // className="grow overflow-auto h-[71%]"
                  className="bg-[#F5F5F5] grow overflow-x-hidden overflow-y-auto h-[71%] px-1"
                  ref={msgContainerRef}
                  onScroll={onMsgScroll}
                  // onWheel={handleWheel}
                  // onTouchStart={handleTouchStart}
                  // onTouchMove={handleTouchMove}
                >
                  {/* Sticky loader for pagination */}
                  <PaginationLoader
                    isLoading={loading && hasLoadedinRedux}
                    loadingText={`${lang.loadingMoreMessages}...`}
                  />

                  <Spin
                    spinning={loading && !hasLoadedinRedux}
                    tip={loading ? `${lang.loadingMessages}...` : `${lang.loadingMoreMessages}...`}
                  >
                    <div className="pb-2.5">
                      {Object.keys(groupedMessages).length === 0 && !loading ? (
                        <EmptyConversationState />
                      ) : (
                        Object.keys(groupedMessages)
                          .sort((a, b) => {
                            const dateA = dayjs(a);
                            const dateB = dayjs(b);
                            // Sort in descending order, so the latest date is at the bottom
                            return dateA.isBefore(dateB) ? -1 : 1;
                          })
                          .map((date, index) => {
                            const messageProps = {
                              targetLangForCustomer,
                              targetLangForEmployee,
                              canViewTranslation,
                              date,
                              isIncludeOriginalMessage,
                              isAutoTranslate,
                              userIdMap,
                              handleRetry,
                              hasAnyForwardOption,
                            };
                            return (
                              <MessagesGroup
                                key={date}
                                dateMessages={groupedMessages[date]}
                                targetMessageId={targetMessageId}
                                {...messageProps}
                              />
                            );
                          })
                      )}
                    </div>
                  </Spin>
                  <div ref={messagesEndRef} />
                </div>
              </>
            )}

            <OptionContainer>
              <Row gutter={24}>
                {!recording.visible ? (
                  <Col span={24}>
                    <>
                      {attachments.length > 0 && (
                        <Collapse
                          className="reverse-collapse border-none transparent-collapse"
                          defaultActiveKey={["1"]}
                          accordion
                        >
                          <Collapse.Panel
                            key="1"
                            header={
                              <div className="flex-row-centered gap-0.5 items-center justify-between">
                                <div className="flex-row-centered gap-0.5 items-center">
                                  <span className="text-xs font-[600] text-grey-700">
                                    {attachments.length} attachment
                                  </span>
                                  <i className="text-xs font-[400] text-grey-700">
                                    {" "}
                                    <span className="my-1  flex flex-row items-center gap-1 ">
                                      ({formatBytes(totalSize, 2)})
                                    </span>
                                  </i>
                                </div>
                                <span
                                  className="text-red-500 text-xs font-[600] cursor-pointer"
                                  onClick={e => {
                                    e.stopPropagation();
                                    // Clean up blob URLs to prevent memory leaks
                                    attachments.forEach(attachment => {
                                      if (
                                        attachment?.preview &&
                                        attachment.preview.startsWith("blob:")
                                      ) {
                                        URL.revokeObjectURL(attachment.preview);
                                      }
                                    });
                                    setAttachments([]);
                                  }}
                                >
                                  Remove all
                                </span>
                              </div>
                            }
                          >
                            <Attachments
                              key={selectedLead?.id}
                              attachments={attachments}
                              setAttachments={setAttachments}
                            />
                          </Collapse.Panel>
                        </Collapse>
                      )}
                      {summaryVisible.visible && (
                        <ConversationSummary
                          key={selectedLead?.id}
                          isDisabled={
                            !selectedLead?.id || messageLoader || loading || spinner || leadsLoading
                          }
                          selectedLead={selectedLead}
                          user={user}
                          summaryVisible={summaryVisible}
                          setSummaryVisible={setSummaryVisible}
                        />
                      )}
                      <ResizableContainer
                        defaultHeight={
                          textModeRedux === "Email"
                            ? INPUT_TAB_HEIGHT.DEFAULT_EMAIL
                            : INPUT_TAB_HEIGHT.DEFAULT_TEXT_MESSAGE
                        }
                        minHeight={
                          textModeRedux === "Email"
                            ? INPUT_TAB_HEIGHT.MIN_EMAIL
                            : INPUT_TAB_HEIGHT.MIN_TEXT_MESSAGE
                        }
                        maxHeight={
                          textModeRedux === "Email"
                            ? INPUT_TAB_HEIGHT.MAX_EMAIL
                            : INPUT_TAB_HEIGHT.MAX_TEXT_MESSAGE
                        }
                      >
                        <InputArea
                          textMode={textMode}
                          buttonStyle={buttonStyle}
                          text={text}
                          selectedLead={selectedLead}
                          handleKeyDown={handleKeyDown}
                          handleKeyUp={handleKeyUp}
                          textDisabled={textDisabled}
                          messageLoader={messageLoader}
                          loading={loading}
                          spinner={spinner}
                          leadsLoading={leadsLoading}
                          lang={lang}
                          setmessageText={setmessageText}
                          placeholder={placeholder}
                          messageText={messageText}
                          richTextValue={richTextValue}
                          setrichTextValue={setrichTextValue}
                          renderConsentNote={renderConsentNote}
                          afterMessageFromRedux={afterMessageFromRedux}
                          handleSetDefinedTemplate={handleSetDefinedTemplate}
                          isEmojiOpen={isEmojiOpen}
                          setIsEmojiOpen={setIsEmojiOpen}
                          scheduledMessages={scheduledMessages}
                          refetchMessages={refetchMessages}
                          getMessages={getMessages}
                          user={user}
                          SuggestAMessage={SuggestAMessage}
                          tooltipTitle={tooltipTitle}
                          buttonDisabled={buttonDisabled}
                          mmsLoader={mmsLoader}
                          attachments={attachments}
                          setmmsLoader={setmmsLoader}
                          fetchData={fetchData}
                          setMediaUploadLoader={setMediaUploadLoader}
                          handleMMS={handleMMS}
                          onlyFirstMessage={onlyFirstMessage}
                          afterMessageConsent={afterMessageConsent}
                          onClickHandler={onClickHandler}
                          setCallConsentMessage={setCallConsentMessage}
                          sendConsentMessage={sendConsentMessage}
                          translateMessage={translateMessage}
                          languages={languages}
                          originalText={originalText}
                          setOriginalText={setOriginalText}
                          isTranslatePreviewShow={isTranslatePreviewShow}
                          setisReview={setisReview}
                          setEmailCursor={value => setemailCursor(value)}
                          emailTextRef={emailTextRef}
                          emailForm={emailForm}
                          handleEmail={handleEmail}
                        />
                      </ResizableContainer>
                    </>
                  </Col>
                ) : (
                  <div style={{ display: "flex" }}>
                    <h1>Record View</h1>
                  </div>
                )}
              </Row>
              <div className="w-full">
                {!isUserIsBeingSet && (!user?.phone || (user?.phone === "" && showLeadSection)) && (
                  <Alert
                    className="sm:w-2/4 w-full text-[11px] "
                    message={
                      <div
                        className="secondaryColorTheme"
                        onClick={() => setOpenEditUserPhone(true)}
                      >
                        {lang.dontHaveValidNumber}
                        <AntdIconV4 type="EditOutlined" />
                      </div>
                    }
                    type="error"
                  />
                )}
              </div>{" "}
              <div className="w-full h-[1px] bg-grey-200" />
              <BottomActions
                attachments={attachments}
                handleMediaSharing={handleMediaSharing}
                mediaRef={mediaRef}
                videoRef={videoRef}
                documentRef={documentRef}
                setAttachments={setAttachments}
                textMode={textMode}
                handleSetDefinedTemplate={handleSetDefinedTemplate}
                text={text}
                messageText={messageText}
                textDisabled={textDisabled}
                setIsEmojiOpen={setIsEmojiOpen}
                isEmojiOpen={isEmojiOpen}
                selectedLead={selectedLead}
                user={user}
                setTemplateModal={setTemplateModal}
                handleSendReviewClick={handleSendReviewClick}
                handleAddAppointment={handleAddAppointment}
                richTextValue={richTextValue}
                setrichTextValue={setrichTextValue}
                SuggestAMessage={SuggestAMessage}
                showReviewRequestButton={showReviewRequestButton}
                refetchLeads={refetchLeads}
                setmessageText={setmessageText}
                setisReview={setisReview}
                activeOppName={activeOppName}
                getMessages={getMessages}
                scheduledMessages={scheduledMessages}
                buttonDisabled={buttonDisabled}
                leadsLoading={leadsLoading}
                loading={loading}
                messageLoader={messageLoader}
                mmsLoader={mmsLoader}
                buttonStyle={buttonStyle}
                afterMessageConsent={afterMessageConsent}
                fetchData={fetchData}
                handleFiles={handleFiles}
                handleMMS={handleMMS}
                isConsentStatusEnable={isConsentStatusEnable}
                onlyFirstMessage={onlyFirstMessage}
                sendConsentMessage={sendConsentMessage}
                setCallConsentMessage={setCallConsentMessage}
                setMediaUploadLoader={setMediaUploadLoader}
                setmmsLoader={setmmsLoader}
                spinner={spinner}
                onClickHandler={onClickHandler}
                tooltipTitle={tooltipTitle}
                setSummaryVisible={setSummaryVisible}
                summaryVisible={summaryVisible}
                setscheduledMessageDrawer={setscheduledMessageDrawer}
                opportunityList={opportunityList}
                crmIntegrationType={crmIntegration}
                addSignature={addSignature}
                emailCursor={emailCursor}
                setEmailCursor={setemailCursor}
                emailTextRef={emailTextRef}
                emailForm={emailForm}
              />
            </OptionContainer>
          </div>
          {isLeadProfileVisible && (
            <div
              className={`h-full pt-3 overflow-y-auto w-[${screenParts.rightSide}px] max-w-[${screenParts.rightSide}px]`}
            >
              <LeadProfile
                showAdd={false}
                handleAddAppointment={handleAddAppointment}
                connection={connection}
                setConnection={setConnection}
                setLeadList={setLeadList}
                socket={socket}
                canEditPhone={canEdit}
                handleAddPhoneClick={handleAddPhoneClick}
                selectedLead={selectedLead}
                setPushToCrmModalVisible={setPushToCrmModalVisible}
                setOpenEditPopup={setOpenEditPopup}
                handleUpdate={handleUpdate}
                refetchAppointment={refetchAppointment}
                handleSendConsentClick={handleSendConsentClick}
                disableConcentClick={disableConcentClick}
                consentLoader={consentLoader}
                handleActiveToggle={handleActiveToggle}
                setInlineEditField={setInlineEditField}
                updateLoading={updateLoading}
                inlineField={inlineField}
                user={user}
                updateStatusLoading={updateStatusLoading}
                setFilters={id => {
                  page = 1;
                  setMessageFilters({
                    ...messageFilters,
                    page: 1,
                    campaignIds: id ? [id] : [],
                  });
                }}
                refetchLeadDetails={refetchLeadDetails}
                handleEditLead={lead => handleEditLead(lead)}
                setRefetchAppointment={setRefetchAppointment}
                setSelectedLead={setSelectedLead}
                setMessageFilters={setMessageFilters}
                messageFilters={messageFilters}
                refetchLeads={refetchLeads}
                crmLeadObj={selectedLead?.crmLeadObj}
                isAppointmentChangeFromLead={isAppointmentChangeFromLead}
                spinner={spinner}
                statusList={statusList}
                setstatusList={setstatusList}
                leadList={leadList}
                setShowLeadSection={setShowLeadSection}
                setOpportunityList={setOpportunityList}
                setFilterApplied={setFilterApplied}
                setSelectedLeadId={setSelectedLeadId}
                setActiveOpp={setActiveOpp}
                timeReference={timeReference}
                crmIntegration={crmIntegration || crmIntegrationType}
                crmIntegrationData={crmIntegrationData}
                handleLeadDetailProfile={handleLeadDetailProfile}
                setIsClickonPotentialDuplicate={setIsClickonPotentialDuplicate}
                getLeadDetail={getLeadDetail}
                eventId={eventId}
                userIdMap={userIdMap}
                getMessages={getMessages}
                activeOpportunity={activeOpp}
                languages={languages}
                refreshLeadListData={refetchAfterAppointmentSave}
              />
            </div>
          )}

          {openTemplateModal && (
            <TemplateDrawer
              openTemplateDrawer={openTemplateModal}
              setOpenTemplateDrawer={setTemplateModal}
              onApply={handleSetDefinedTemplate}
              leadId={selectedLead?.id}
            />
          )}

          {openAppointmentDrawer && (
            <AppointmentModal
              lead={selectedLead}
              eventId={eventId}
              refetchLeads={refetchAfterAppointmentSave}
              refreshLeadListData={refetchAfterAppointmentSave}
              openAppointmentDrawer={openAppointmentDrawer}
              setOpenDrawer={flag => {
                handleRefetchAndCloseDrawer(flag);
              }}
              assignedUserId={
                (selectedLead?.activeAppointment && selectedLead?.activeAppointment?.user?.id) ||
                user.id
              }
              leadOpportunities={selectedLead?.leadOpportunities}
              onClick={async (item, flag, updateDate, isClickOnName) => {
                // Use the live selectedLead via ref. This onClick is captured into the
                // appointmentForm dialog payload (via openDialog inside Appointments), so
                // its closure can be stale by the time save fires.
                const liveSelectedLeadId = selectedLeadRef.current?.id;
                if (+item?.id === +liveSelectedLeadId && isClickOnName) {
                  setOpenAppointmentDrawer(false);
                  return;
                }
                if (isClickOnName) {
                  setOpenAppointmentDrawer(false);
                  handleLeadDetailProfile(item?.id);
                  handleScrollOnMovement();
                  return;
                }

                // Same-lead save (typical flow): no scroll-to-top, no profile reload — the lead
                // hasn't moved and is already loaded. Just close the drawer and notify listeners.
                if (+item?.id === +liveSelectedLeadId) {
                  setOpenAppointmentDrawer(false);
                  setIsAppointmentChangeFromLead(prev => !prev);
                  return;
                }

                // Cross-lead save (e.g. lead-changer used inside the form). Skip
                // handleLeadDetailProfile to avoid the localStorage cascade →
                // getLeads refetch → unshift pin. Lead-level updates already
                // happened in refetchAfterAppointmentSave.
                setOpenAppointmentDrawer(false);
                setIsAppointmentChangeFromLead(prev => !prev);
              }}
            />
          )}

          {/* {!IsLeadListVisible && (
            <span
              onClick={() => setIsLeadListVisible(!IsLeadListVisible)}
              className={`absolute cursor-pointer left-2.5 z-[999] top-[6.5rem] ${
                IsLeadListVisible ? "rotate-180" : "rotate-0"
              }`}
            >
              <RightBlackIcon />
            </span>
          )} */}
        </div>
        <Drawer
          title="Notifications"
          open={notificationDrawer}
          className="notification-drawer"
          width={isMobileView ? "100%" : "30%"}
          onClose={() => setNotificationDrawer(false)}
        >
          <NotificationsDropdown
            setSelectedLeadPhoneToRedux={setSelectedLeadPhoneToRedux}
            locationIdslice={locationIdslice}
            refetchNotificationsCount={refetchNotificationsCount}
            notificationLoader={props.notificationLoader}
            onClose={() => setNotificationDrawer(false)}
            handleDispatch={handleDispatch}
          />
        </Drawer>
        <Drawer
          title="Profile"
          placement="right"
          extra={
            <Avatar src={user?.profilePic} size="small">
              {!user?.profilePic && user ? convertToInitials(user?.fullName) : null}
            </Avatar>
          }
          open={settingsDrawer}
          onClose={() => setSettingsDrawer(false)}
          width={isMobileView ? "100%" : 730}
          closeIcon={<LeftOutlined />}
          styles={{ header: { padding: "16px" }, body: { padding: "0px" } }}
          destroyOnClose
        >
          <UserProfile refreshUsers={() => {}} />
        </Drawer>
        <ViewScheduledMessagesPopup
          getMessages={getMessages}
          selectedLead={selectedLead}
          messageText={messageText}
          scheduledMessageDrawer={scheduledMessageDrawer}
          setscheduledMessageDrawer={setscheduledMessageDrawer}
        />
      </div>
      <div className="w-[40px] h-screen flex-1 bg-white border-r-grey-200 border-[0px] border-r border-solid pt-[56px] flex flex-col">
        <span
          className={`fixed cursor-pointer top-3 flex-row-centered justify-center rounded right-1 p-1 ${
            IsLeadListVisible && "bg-grey-200"
          }`}
          onClick={() => {
            const isExpanding = !IsLeadListVisible;
            setIsLeadListVisible(prev => !prev);
            // Unified CRM routing — if the list is empty on expand, ask the
            // main useQuery to refetch. Works for every CRM.
            if (isExpanding && isEmpty(leadList)) {
              refetchLeads?.();
            }
          }}
        >
          {IsLeadListVisible ? <CollapseIcon /> : <ExpandIcon />}
        </span>
        <div className="flex flex-col gap-10">
          <span
            onClick={handleAddPhoneClick}
            className="flex-col-centered cursor-pointer items-center justify-center gap-1 "
          >
            <AddUserIcon />
            <span className="rotate-90 mt-5 whitespace-nowrap block">Add Lead</span>
          </span>
          <span
            onClick={() => {
              // sendMessageToParent("engagedai-resize", {
              //   width: isLeadProfileVisible ? -screenParts.rightSide : screenParts.rightSide,
              // });
              setisLeadProfileVisible(prev => !prev);
            }}
            className="flex-col-centered cursor-pointer items-center justify-center gap-1"
          >
            <InfoCircleOutlined />
            <span className="rotate-90 mt-[50px] whitespace-nowrap block">Lead Information</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default BrowserExtensionPopup;
